import { DropdownOption } from "../../shared/ui/dropdown/dropdown";

export const LOCATIONS: DropdownOption<number>[] = [
  {
    id: 106001,
    label: 'Νησιά Αργοσαρωνικού',
    value: 106001,
    type: 'default',
  },
  {
    id: 2601,
    label: 'Νησιά Αργοσαρωνικού, Αγκίστρι',
    value: 2601,
    type: 'default',
  },
  {
    id: 102601,
    label: 'Νησιά Αργοσαρωνικού, Αγκίστρι, Κέντρο',
    value: 102601,
    type: 'default',
  },
  {
    id: 118246,
    label: 'Νησιά Αργοσαρωνικού, Αγκίστρι, Κύρα',
    value: 118246,
    type: 'default',
  },
  {
    id: 118247,
    label: 'Νησιά Αργοσαρωνικού, Αγκίστρι, Λιμενάρια',
    value: 118247,
    type: 'default',
  },
  {
    id: 118248,
    label: 'Νησιά Αργοσαρωνικού, Αγκίστρι, Απόνησος',
    value: 118248,
    type: 'default',
  },
  {
    id: 118249,
    label: 'Νησιά Αργοσαρωνικού, Αγκίστρι, Μετόχι',
    value: 118249,
    type: 'default',
  },
  {
    id: 118250,
    label: 'Νησιά Αργοσαρωνικού, Αγκίστρι, Σκάλα',
    value: 118250,
    type: 'default',
  },
  {
    id: 118251,
    label: 'Νησιά Αργοσαρωνικού, Αγκίστρι, Μεγαλοχώρι',
    value: 118251,
    type: 'default',
  },
  {
    id: 2602,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα',
    value: 2602,
    type: 'default',
  },
  {
    id: 102602,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Κέντρο',
    value: 102602,
    type: 'default',
  },
  {
    id: 117915,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Μονή',
    value: 117915,
    type: 'default',
  },
  {
    id: 117916,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Κλήμα',
    value: 117916,
    type: 'default',
  },
  {
    id: 117917,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Σφεντούρι',
    value: 117917,
    type: 'default',
  },
  {
    id: 117918,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Πέρδικα',
    value: 117918,
    type: 'default',
  },
  {
    id: 117919,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Βλάχηδες',
    value: 117919,
    type: 'default',
  },
  {
    id: 117920,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Κανάκηδες',
    value: 117920,
    type: 'default',
  },
  {
    id: 117921,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Αιγηνίτισσα',
    value: 117921,
    type: 'default',
  },
  {
    id: 117922,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Αποσπόρηδες',
    value: 117922,
    type: 'default',
  },
  {
    id: 117923,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Ανίτσαιο',
    value: 117923,
    type: 'default',
  },
  {
    id: 117924,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Προφήτης Ηλίας',
    value: 117924,
    type: 'default',
  },
  {
    id: 117925,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Κάβος',
    value: 117925,
    type: 'default',
  },
  {
    id: 117926,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Πόρτες',
    value: 117926,
    type: 'default',
  },
  {
    id: 117927,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Παχεία Ράχη',
    value: 117927,
    type: 'default',
  },
  {
    id: 117928,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Κυλινδράς',
    value: 117928,
    type: 'default',
  },
  {
    id: 117929,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Καπότηδες',
    value: 117929,
    type: 'default',
  },
  {
    id: 117930,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Μαραθώνας',
    value: 117930,
    type: 'default',
  },
  {
    id: 117931,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Λαζάρηδες',
    value: 117931,
    type: 'default',
  },
  {
    id: 117932,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Τζίκηδες',
    value: 117932,
    type: 'default',
  },
  {
    id: 117933,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Γιαννάκηδες',
    value: 117933,
    type: 'default',
  },
  {
    id: 117934,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Μονή Κοιμήσεως Θεοτόκου',
    value: 117934,
    type: 'default',
  },
  {
    id: 117935,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Μπενάκηδες',
    value: 117935,
    type: 'default',
  },
  {
    id: 117936,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Παγώνι',
    value: 117936,
    type: 'default',
  },
  {
    id: 117937,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Ψαχνή',
    value: 117937,
    type: 'default',
  },
  {
    id: 117938,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Αλώνες',
    value: 117938,
    type: 'default',
  },
  {
    id: 117939,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Αγία Μαρίνα',
    value: 117939,
    type: 'default',
  },
  {
    id: 117940,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Κοντός',
    value: 117940,
    type: 'default',
  },
  {
    id: 117941,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Μεσαγρός',
    value: 117941,
    type: 'default',
  },
  {
    id: 117942,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Κυψέλη',
    value: 117942,
    type: 'default',
  },
  {
    id: 117943,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Λιβάδι',
    value: 117943,
    type: 'default',
  },
  {
    id: 117944,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Βίγλα',
    value: 117944,
    type: 'default',
  },
  {
    id: 117945,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Βαθύ',
    value: 117945,
    type: 'default',
  },
  {
    id: 117946,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Θερμά',
    value: 117946,
    type: 'default',
  },
  {
    id: 117947,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Βαγία',
    value: 117947,
    type: 'default',
  },
  {
    id: 117948,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Μαυρομούτσουνο',
    value: 117948,
    type: 'default',
  },
  {
    id: 117949,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Υψηλή',
    value: 117949,
    type: 'default',
  },
  {
    id: 117950,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Λαγούσα',
    value: 117950,
    type: 'default',
  },
  {
    id: 117951,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Σταχτορροή',
    value: 117951,
    type: 'default',
  },
  {
    id: 117952,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Λαγουσάκι',
    value: 117952,
    type: 'default',
  },
  {
    id: 507542,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Σουβάλα',
    value: 507542,
    type: 'default',
  },
  {
    id: 13000133,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Αγία Φανερωμένη',
    value: 13000133,
    type: 'default',
  },
  {
    id: 13000134,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Άγιοι Ασώματοι',
    value: 13000134,
    type: 'default',
  },
  {
    id: 13000135,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Άγιος Φώτιος',
    value: 13000135,
    type: 'default',
  },
  {
    id: 13000136,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Βροχεία',
    value: 13000136,
    type: 'default',
  },
  {
    id: 13000137,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Κάμπος - Μύλοι',
    value: 13000137,
    type: 'default',
  },
  {
    id: 13000138,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Λίμπονες - Αγία Ειρήνη',
    value: 13000138,
    type: 'default',
  },
  {
    id: 13000139,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Μέριστος - Αγία Παρασκευή',
    value: 13000139,
    type: 'default',
  },
  {
    id: 13000140,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Παλαιόπυργος',
    value: 13000140,
    type: 'default',
  },
  {
    id: 13000141,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Περιβόλα',
    value: 13000141,
    type: 'default',
  },
  {
    id: 13000142,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Πλακάκια',
    value: 13000142,
    type: 'default',
  },
  {
    id: 13000143,
    label: 'Νησιά Αργοσαρωνικού, Αίγινα, Χλόη',
    value: 13000143,
    type: 'default',
  },
  {
    id: 2603,
    label: 'Νησιά Αργοσαρωνικού, Αμπελάκια',
    value: 2603,
    type: 'default',
  },
  {
    id: 123432,
    label: 'Νησιά Αργοσαρωνικού, Αμπελάκια, Κυνόσουρα',
    value: 123432,
    type: 'default',
  },
  {
    id: 123431,
    label: 'Νησιά Αργοσαρωνικού, Αμπελάκια, Σελήνια',
    value: 123431,
    type: 'default',
  },
  {
    id: 123430,
    label: 'Νησιά Αργοσαρωνικού, Αμπελάκια, Κέντρο',
    value: 123430,
    type: 'default',
  },
  {
    id: 123433,
    label: 'Νησιά Αργοσαρωνικού, Αμπελάκια, Σπιθάρι',
    value: 123433,
    type: 'default',
  },
  {
    id: 123434,
    label: 'Νησιά Αργοσαρωνικού, Αμπελάκια, Καματερό',
    value: 123434,
    type: 'default',
  },
  {
    id: 2609,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα',
    value: 2609,
    type: 'default',
  },
  {
    id: 102609,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Κέντρο',
    value: 102609,
    type: 'default',
  },
  {
    id: 118563,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Στενό',
    value: 118563,
    type: 'default',
  },
  {
    id: 118568,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Δριτσαίικα',
    value: 118568,
    type: 'default',
  },
  {
    id: 118569,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Βρομολίμνη',
    value: 118569,
    type: 'default',
  },
  {
    id: 118570,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Μεγαλοχώρι',
    value: 118570,
    type: 'default',
  },
  {
    id: 118571,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Βαθύ',
    value: 118571,
    type: 'default',
  },
  {
    id: 118572,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Μεγάλο Ποτάμι',
    value: 118572,
    type: 'default',
  },
  {
    id: 118573,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Κυψέλη',
    value: 118573,
    type: 'default',
  },
  {
    id: 118574,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Καημένη Χώρα',
    value: 118574,
    type: 'default',
  },
  {
    id: 118575,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Άγιοι Θεόδωροι',
    value: 118575,
    type: 'default',
  },
  {
    id: 118576,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Μακρύλογγος',
    value: 118576,
    type: 'default',
  },
  {
    id: 118577,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Παλαιά Λουτρά',
    value: 118577,
    type: 'default',
  },
  {
    id: 118578,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Κουνουπίτσα',
    value: 118578,
    type: 'default',
  },
  {
    id: 118579,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Άγιος Νικόλαος',
    value: 118579,
    type: 'default',
  },
  {
    id: 118580,
    label: 'Νησιά Αργοσαρωνικού, Μέθανα, Άγιος Γεώργιος',
    value: 118580,
    type: 'default',
  },
  {
    id: 2613,
    label: 'Νησιά Αργοσαρωνικού, Πόρος',
    value: 2613,
    type: 'default',
  },
  {
    id: 102613,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Κέντρο',
    value: 102613,
    type: 'default',
  },
  {
    id: 118934,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Λεμονοδάσος',
    value: 118934,
    type: 'default',
  },
  {
    id: 118937,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Άγιος Νεκτάριος',
    value: 118937,
    type: 'default',
  },
  {
    id: 13000144,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Αρβανίτης - Λαζαρέτο - Μπούρτζι',
    value: 13000144,
    type: 'default',
  },
  {
    id: 13000145,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Βαγιωνιά',
    value: 13000145,
    type: 'default',
  },
  {
    id: 13000146,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Καραπολίτη - Μακρογιαννέικα',
    value: 13000146,
    type: 'default',
  },
  {
    id: 13000147,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Μικρό Νεώριο',
    value: 13000147,
    type: 'default',
  },
  {
    id: 13000148,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Πέρλια - Συνοικισμός',
    value: 13000148,
    type: 'default',
  },
  {
    id: 13000149,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Πλάκα - Αλυκή',
    value: 13000149,
    type: 'default',
  },
  {
    id: 13000150,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Τσελεβίνια',
    value: 13000150,
    type: 'default',
  },
  {
    id: 118928,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Μονή Ζωοδόχου Πηγής Καλαυρείας',
    value: 118928,
    type: 'default',
  },
  {
    id: 118929,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Βλαχαίικα',
    value: 118929,
    type: 'default',
  },
  {
    id: 118930,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Περγάρι',
    value: 118930,
    type: 'default',
  },
  {
    id: 118931,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Πάνω Μπισαίικα',
    value: 118931,
    type: 'default',
  },
  {
    id: 118932,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Μπισαίικα',
    value: 118932,
    type: 'default',
  },
  {
    id: 118933,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Άρτεμις',
    value: 118933,
    type: 'default',
  },
  {
    id: 118935,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Κυανή Ακτή',
    value: 118935,
    type: 'default',
  },
  {
    id: 118936,
    label: 'Νησιά Αργοσαρωνικού, Πόρος, Μεγάλο Νεώριο',
    value: 118936,
    type: 'default',
  },
  {
    id: 2614,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα',
    value: 2614,
    type: 'default',
  },
  {
    id: 102614,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Κέντρο',
    value: 102614,
    type: 'default',
  },
  {
    id: 117141,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Γιάλα',
    value: 117141,
    type: 'default',
  },
  {
    id: 117142,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Κακή Βίγλα',
    value: 117142,
    type: 'default',
  },
  {
    id: 117148,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Αγία Παρασκευή',
    value: 117148,
    type: 'default',
  },
  {
    id: 117153,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Άγιος Ιωάννης',
    value: 117153,
    type: 'default',
  },
  {
    id: 117155,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Άγιος Γεώργιος',
    value: 117155,
    type: 'default',
  },
  {
    id: 117156,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Παλούκια',
    value: 117156,
    type: 'default',
  },
  {
    id: 117159,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Βασιλικά',
    value: 117159,
    type: 'default',
  },
  {
    id: 117160,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Άνω Βασιλικά',
    value: 117160,
    type: 'default',
  },
  {
    id: 117162,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Μπλέ Λιμανάκι',
    value: 117162,
    type: 'default',
  },
  {
    id: 117163,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Μπατσής',
    value: 117163,
    type: 'default',
  },
  {
    id: 123410,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Βρωμοπούσι',
    value: 123410,
    type: 'default',
  },
  {
    id: 123411,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Ψιλή Άμμος',
    value: 123411,
    type: 'default',
  },
  {
    id: 123412,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Ξένο',
    value: 123412,
    type: 'default',
  },
  {
    id: 123413,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Στενό',
    value: 123413,
    type: 'default',
  },
  {
    id: 123414,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Γαλήνη',
    value: 123414,
    type: 'default',
  },
  {
    id: 123415,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Βαθύ',
    value: 123415,
    type: 'default',
  },
  {
    id: 123416,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Άγιος Αθανάσιος',
    value: 123416,
    type: 'default',
  },
  {
    id: 123417,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Αιάντειο',
    value: 123417,
    type: 'default',
  },
  {
    id: 123418,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Κανάκια',
    value: 123418,
    type: 'default',
  },
  {
    id: 123419,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Κολώνες',
    value: 123419,
    type: 'default',
  },
  {
    id: 123420,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Περάνι',
    value: 123420,
    type: 'default',
  },
  {
    id: 123421,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Περιστέρια',
    value: 123421,
    type: 'default',
  },
  {
    id: 13000151,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Αγία Μαρίνα',
    value: 13000151,
    type: 'default',
  },
  {
    id: 13000152,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Άγιος Γεώργιος Στενού',
    value: 13000152,
    type: 'default',
  },
  {
    id: 13000153,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Άγιος Δημήτριος',
    value: 13000153,
    type: 'default',
  },
  {
    id: 13000154,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Άγιος Νικόλαος',
    value: 13000154,
    type: 'default',
  },
  {
    id: 13000155,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Αλώνια',
    value: 13000155,
    type: 'default',
  },
  {
    id: 13000156,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Βροντού',
    value: 13000156,
    type: 'default',
  },
  {
    id: 13000157,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Δημήτρανι',
    value: 13000157,
    type: 'default',
  },
  {
    id: 13000158,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Δρένια',
    value: 13000158,
    type: 'default',
  },
  {
    id: 13000159,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Ελληνικό',
    value: 13000159,
    type: 'default',
  },
  {
    id: 13000160,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Ζορμπαλά',
    value: 13000160,
    type: 'default',
  },
  {
    id: 13000161,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Ηλιακτή',
    value: 13000161,
    type: 'default',
  },
  {
    id: 13000162,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Ιπποκράτους - Μητσολιό',
    value: 13000162,
    type: 'default',
  },
  {
    id: 13000163,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Καμπόλι',
    value: 13000163,
    type: 'default',
  },
  {
    id: 13000164,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Λουκέζες',
    value: 13000164,
    type: 'default',
  },
  {
    id: 13000165,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Μαρούδι',
    value: 13000165,
    type: 'default',
  },
  {
    id: 13000166,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Μπόνι - Λευτέρι',
    value: 13000166,
    type: 'default',
  },
  {
    id: 13000167,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, ΝΑΤΟ',
    value: 13000167,
    type: 'default',
  },
  {
    id: 13000168,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Ναύσταθμος Σαλαμίνας',
    value: 13000168,
    type: 'default',
  },
  {
    id: 13000169,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Νέα Μενεμένη',
    value: 13000169,
    type: 'default',
  },
  {
    id: 13000170,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Ντοροτό',
    value: 13000170,
    type: 'default',
  },
  {
    id: 13000171,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Παλιάμπελα',
    value: 13000171,
    type: 'default',
  },
  {
    id: 13000172,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Παραλία Σπιθάρι',
    value: 13000172,
    type: 'default',
  },
  {
    id: 13000173,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Πόρτο Φίνο',
    value: 13000173,
    type: 'default',
  },
  {
    id: 13000174,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Ρεβυθούσα',
    value: 13000174,
    type: 'default',
  },
  {
    id: 13000175,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Ρέστη',
    value: 13000175,
    type: 'default',
  },
  {
    id: 13000176,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Σατερλί',
    value: 13000176,
    type: 'default',
  },
  {
    id: 13000177,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Τσάμη - Ζωοδόχου Πηγής',
    value: 13000177,
    type: 'default',
  },
  {
    id: 13000178,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Φανερωμένη - Καμινάκια',
    value: 13000178,
    type: 'default',
  },
  {
    id: 13000179,
    label: 'Νησιά Αργοσαρωνικού, Σαλαμίνα, Φοίνικας',
    value: 13000179,
    type: 'default',
  },
  {
    id: 2615,
    label: 'Νησιά Αργοσαρωνικού, Σπέτσες',
    value: 2615,
    type: 'default',
  },
  {
    id: 102615,
    label: 'Νησιά Αργοσαρωνικού, Σπέτσες, Κέντρο',
    value: 102615,
    type: 'default',
  },
  {
    id: 116716,
    label: 'Νησιά Αργοσαρωνικού, Σπέτσες, Μονή Αγίων Πάντων',
    value: 116716,
    type: 'default',
  },
  {
    id: 116717,
    label: 'Νησιά Αργοσαρωνικού, Σπέτσες, Κουζούνος',
    value: 116717,
    type: 'default',
  },
  {
    id: 116718,
    label: 'Νησιά Αργοσαρωνικού, Σπέτσες, Βελοπούλα',
    value: 116718,
    type: 'default',
  },
  {
    id: 116720,
    label: 'Νησιά Αργοσαρωνικού, Σπέτσες, Φαλκόνερα',
    value: 116720,
    type: 'default',
  },
  {
    id: 116721,
    label: 'Νησιά Αργοσαρωνικού, Σπέτσες, Σπετσοπούλα',
    value: 116721,
    type: 'default',
  },
  {
    id: 116723,
    label: 'Νησιά Αργοσαρωνικού, Σπέτσες, Άγιοι Ανάργυροι',
    value: 116723,
    type: 'default',
  },
  {
    id: 116724,
    label: 'Νησιά Αργοσαρωνικού, Σπέτσες, Λιγονέρι',
    value: 116724,
    type: 'default',
  },
  {
    id: 2617,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα',
    value: 2617,
    type: 'default',
  },
  {
    id: 102617,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Κέντρο',
    value: 102617,
    type: 'default',
  },
  {
    id: 118544,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Ψωμαίικα',
    value: 118544,
    type: 'default',
  },
  {
    id: 118545,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Σαρωνίδα',
    value: 118545,
    type: 'default',
  },
  {
    id: 118546,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Γαλατάς',
    value: 118546,
    type: 'default',
  },
  {
    id: 118547,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Αγία Σωτήρα',
    value: 118547,
    type: 'default',
  },
  {
    id: 118548,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Άγιος Γεώργιος',
    value: 118548,
    type: 'default',
  },
  {
    id: 118549,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Βύδι',
    value: 118549,
    type: 'default',
  },
  {
    id: 118550,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Χώρα',
    value: 118550,
    type: 'default',
  },
  {
    id: 118551,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Σκαπέτι',
    value: 118551,
    type: 'default',
  },
  {
    id: 118552,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Άγιος Κωνσταντίνος',
    value: 118552,
    type: 'default',
  },
  {
    id: 118553,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Ψήφτα',
    value: 118553,
    type: 'default',
  },
  {
    id: 118554,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Κατσαντωναίικα',
    value: 118554,
    type: 'default',
  },
  {
    id: 118555,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Μεταμόρφωση',
    value: 118555,
    type: 'default',
  },
  {
    id: 118556,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Ζερβαίικα',
    value: 118556,
    type: 'default',
  },
  {
    id: 118557,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Καλλονή',
    value: 118557,
    type: 'default',
  },
  {
    id: 118558,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Καρατζάς',
    value: 118558,
    type: 'default',
  },
  {
    id: 118559,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Τακτικούπολη',
    value: 118559,
    type: 'default',
  },
  {
    id: 118560,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Ακτή Αγάπης',
    value: 118560,
    type: 'default',
  },
  {
    id: 118561,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Αγία Ελένη',
    value: 118561,
    type: 'default',
  },
  {
    id: 118562,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Νερατζιά',
    value: 118562,
    type: 'default',
  },
  {
    id: 118564,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Δρυόπη',
    value: 118564,
    type: 'default',
  },
  {
    id: 118565,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Μύλος',
    value: 118565,
    type: 'default',
  },
  {
    id: 118566,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Άνω Φανάρι',
    value: 118566,
    type: 'default',
  },
  {
    id: 118567,
    label: 'Νησιά Αργοσαρωνικού, Τροιζήνα, Νησίδα',
    value: 118567,
    type: 'default',
  },
  {
    id: 2618,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα',
    value: 2618,
    type: 'default',
  },
  {
    id: 102618,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Κέντρο',
    value: 102618,
    type: 'default',
  },
  {
    id: 116531,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Μονή Αγίου Νικολάου',
    value: 116531,
    type: 'default',
  },
  {
    id: 116532,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Μονή Άγιας Ευπραξίας',
    value: 116532,
    type: 'default',
  },
  {
    id: 116533,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Άγιος Ιωάννης',
    value: 116533,
    type: 'default',
  },
  {
    id: 116534,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Άγιος Νικόλαος',
    value: 116534,
    type: 'default',
  },
  {
    id: 116535,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Κιβωτός',
    value: 116535,
    type: 'default',
  },
  {
    id: 116536,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Λιμιόνιζα',
    value: 116536,
    type: 'default',
  },
  {
    id: 116537,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Σταυρονήσι',
    value: 116537,
    type: 'default',
  },
  {
    id: 116538,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Τρικέρι',
    value: 116538,
    type: 'default',
  },
  {
    id: 116539,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Δοκός',
    value: 116539,
    type: 'default',
  },
  {
    id: 116541,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Βένιζα',
    value: 116541,
    type: 'default',
  },
  {
    id: 116542,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Πλατονήσι',
    value: 116542,
    type: 'default',
  },
  {
    id: 116543,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Επισκοπή',
    value: 116543,
    type: 'default',
  },
  {
    id: 116554,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Μονή Άγιας Τριάδος',
    value: 116554,
    type: 'default',
  },
  {
    id: 116555,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Μανδράκι',
    value: 116555,
    type: 'default',
  },
  {
    id: 116556,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Μονή Γεννήσεως Θεοτόκου Ζούρβας',
    value: 116556,
    type: 'default',
  },
  {
    id: 116544,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Ζώγερι',
    value: 116544,
    type: 'default',
  },
  {
    id: 116545,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Πέτασι',
    value: 116545,
    type: 'default',
  },
  {
    id: 116546,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Κλιμάκι',
    value: 116546,
    type: 'default',
  },
  {
    id: 116547,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Μώλος',
    value: 116547,
    type: 'default',
  },
  {
    id: 116548,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Παλαμιδάς',
    value: 116548,
    type: 'default',
  },
  {
    id: 116549,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Μονή Προφήτη Ηλία',
    value: 116549,
    type: 'default',
  },
  {
    id: 116550,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Βλυχός',
    value: 116550,
    type: 'default',
  },
  {
    id: 116551,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Καστέλλι',
    value: 116551,
    type: 'default',
  },
  {
    id: 116552,
    label: 'Νησιά Αργοσαρωνικού, Ύδρα, Μ. Αγ. Ματρώνης',
    value: 116552,
    type: 'default',
  },
  {
    id: 101,
    label: 'Αθήνα - Βόρεια Προάστια',
    value: 101,
    type: 'default',
  },
  {
    id: 2100,
    label: 'Αθήνα - Βόρεια Προάστια, Άγιος Στέφανος',
    value: 2100,
    type: 'default',
  },
  {
    id: 4600,
    label: 'Αθήνα - Βόρεια Προάστια, Άγιος Στέφανος, Κέντρο',
    value: 4600,
    type: 'default',
  },
  {
    id: 4601,
    label: 'Αθήνα - Βόρεια Προάστια, Άγιος Στέφανος, Νυμφών',
    value: 4601,
    type: 'default',
  },
  {
    id: 4602,
    label: 'Αθήνα - Βόρεια Προάστια, Άγιος Στέφανος, Καπιτένια',
    value: 4602,
    type: 'default',
  },
  {
    id: 13000127,
    label: 'Αθήνα - Βόρεια Προάστια, Άγιος Στέφανος, Βιομηχανική Περιοχή',
    value: 13000127,
    type: 'default',
  },
  {
    id: 115522,
    label: 'Αθήνα - Βόρεια Προάστια, Άγιος Στέφανος, Πευκόφυτο',
    value: 115522,
    type: 'default',
  },
  {
    id: 2101,
    label: 'Αθήνα - Βόρεια Προάστια, Αγία Παρασκευή',
    value: 2101,
    type: 'default',
  },
  {
    id: 329487,
    label: 'Αθήνα - Βόρεια Προάστια, Αγία Παρασκευή, Πευκάκια',
    value: 329487,
    type: 'default',
  },
  {
    id: 329488,
    label: 'Αθήνα - Βόρεια Προάστια, Αγία Παρασκευή, Παράδεισος',
    value: 329488,
    type: 'default',
  },
  {
    id: 329489,
    label: 'Αθήνα - Βόρεια Προάστια, Αγία Παρασκευή, Νέα Ζωή',
    value: 329489,
    type: 'default',
  },
  {
    id: 123120,
    label: 'Αθήνα - Βόρεια Προάστια, Αγία Παρασκευή, Άγιος Ιωάννης',
    value: 123120,
    type: 'default',
  },
  {
    id: 329486,
    label: 'Αθήνα - Βόρεια Προάστια, Αγία Παρασκευή, Κολλέγιο',
    value: 329486,
    type: 'default',
  },
  {
    id: 107120,
    label: 'Αθήνα - Βόρεια Προάστια, Αγία Παρασκευή, ΕΡΤ',
    value: 107120,
    type: 'default',
  },
  {
    id: 107121,
    label: 'Αθήνα - Βόρεια Προάστια, Αγία Παρασκευή, Κοντόπευκο',
    value: 107121,
    type: 'default',
  },
  {
    id: 107122,
    label: 'Αθήνα - Βόρεια Προάστια, Αγία Παρασκευή, Τσακός',
    value: 107122,
    type: 'default',
  },
  {
    id: 107123,
    label: 'Αθήνα - Βόρεια Προάστια, Αγία Παρασκευή, Σταυρός',
    value: 107123,
    type: 'default',
  },
  {
    id: 2102,
    label: 'Αθήνα - Βόρεια Προάστια, Άνοιξη',
    value: 2102,
    type: 'default',
  },
  {
    id: 4603,
    label: 'Αθήνα - Βόρεια Προάστια, Άνοιξη, Κέντρο',
    value: 4603,
    type: 'default',
  },
  {
    id: 4604,
    label: 'Αθήνα - Βόρεια Προάστια, Άνοιξη, Άγιοι Άγγελοι',
    value: 4604,
    type: 'default',
  },
  {
    id: 4605,
    label: 'Αθήνα - Βόρεια Προάστια, Άνοιξη, Φασιδέρη',
    value: 4605,
    type: 'default',
  },
  {
    id: 2103,
    label: 'Αθήνα - Βόρεια Προάστια, Βριλήσσια',
    value: 2103,
    type: 'default',
  },
  {
    id: 6500,
    label: 'Αθήνα - Βόρεια Προάστια, Βριλήσσια, Πάτημα Βριλησσίων',
    value: 6500,
    type: 'default',
  },
  {
    id: 102103,
    label: 'Αθήνα - Βόρεια Προάστια, Βριλήσσια, Κέντρο',
    value: 102103,
    type: 'default',
  },
  {
    id: 106378,
    label: 'Αθήνα - Βόρεια Προάστια, Βριλήσσια, Άνω Βριλήσσια',
    value: 106378,
    type: 'default',
  },
  {
    id: 2104,
    label: 'Αθήνα - Βόρεια Προάστια, Διόνυσος',
    value: 2104,
    type: 'default',
  },
  {
    id: 102104,
    label: 'Αθήνα - Βόρεια Προάστια, Διόνυσος, Κέντρο',
    value: 102104,
    type: 'default',
  },
  {
    id: 106274,
    label: 'Αθήνα - Βόρεια Προάστια, Διόνυσος, Ζώνη Χονδρεμπορίου',
    value: 106274,
    type: 'default',
  },
  {
    id: 116298,
    label: 'Αθήνα - Βόρεια Προάστια, Διόνυσος, Οικισμός Ποντίων',
    value: 116298,
    type: 'default',
  },
  {
    id: 116299,
    label: 'Αθήνα - Βόρεια Προάστια, Διόνυσος, Ραπεντώσα',
    value: 116299,
    type: 'default',
  },
  {
    id: 2105,
    label: 'Αθήνα - Βόρεια Προάστια, Δροσιά',
    value: 2105,
    type: 'default',
  },
  {
    id: 499134,
    label: 'Αθήνα - Βόρεια Προάστια, Δροσιά, Κέντρο Δροσιάς',
    value: 499134,
    type: 'default',
  },
  {
    id: 499135,
    label: 'Αθήνα - Βόρεια Προάστια, Δροσιά, Άνω Δροσιά',
    value: 499135,
    type: 'default',
  },
  {
    id: 499133,
    label: 'Αθήνα - Βόρεια Προάστια, Δροσιά, Ρέα',
    value: 499133,
    type: 'default',
  },
  {
    id: 2106,
    label: 'Αθήνα - Βόρεια Προάστια, Εκάλη',
    value: 2106,
    type: 'default',
  },
  {
    id: 499136,
    label: 'Αθήνα - Βόρεια Προάστια, Εκάλη, Άνω Καστρί',
    value: 499136,
    type: 'default',
  },
  {
    id: 499137,
    label: 'Αθήνα - Βόρεια Προάστια, Εκάλη, Άνω Εκάλη',
    value: 499137,
    type: 'default',
  },
  {
    id: 499138,
    label: 'Αθήνα - Βόρεια Προάστια, Εκάλη, Κάτω Εκάλη',
    value: 499138,
    type: 'default',
  },
  {
    id: 499139,
    label: 'Αθήνα - Βόρεια Προάστια, Εκάλη, Αναγέννηση',
    value: 499139,
    type: 'default',
  },
  {
    id: 499140,
    label: 'Αθήνα - Βόρεια Προάστια, Εκάλη, Άνω Ρέα',
    value: 499140,
    type: 'default',
  },
  {
    id: 13000128,
    label: 'Αθήνα - Βόρεια Προάστια, Εκάλη, Δημοσιογραφικά',
    value: 13000128,
    type: 'default',
  },
  {
    id: 2107,
    label: 'Αθήνα - Βόρεια Προάστια, Ηράκλειο',
    value: 2107,
    type: 'default',
  },
  {
    id: 123045,
    label: 'Αθήνα - Βόρεια Προάστια, Ηράκλειο, Παλαιό Ηράκλειο',
    value: 123045,
    type: 'default',
  },
  {
    id: 123048,
    label: 'Αθήνα - Βόρεια Προάστια, Ηράκλειο, Νέο Ηράκλειο',
    value: 123048,
    type: 'default',
  },
  {
    id: 123046,
    label: 'Αθήνα - Βόρεια Προάστια, Ηράκλειο, Πράσινος Λόφος',
    value: 123046,
    type: 'default',
  },
  {
    id: 123044,
    label: 'Αθήνα - Βόρεια Προάστια, Ηράκλειο, Κάτω Ψαλίδι',
    value: 123044,
    type: 'default',
  },
  {
    id: 102107,
    label: 'Αθήνα - Βόρεια Προάστια, Ηράκλειο, Κέντρο',
    value: 102107,
    type: 'default',
  },
  {
    id: 123040,
    label: 'Αθήνα - Βόρεια Προάστια, Ηράκλειο, Αγία Τριάδα',
    value: 123040,
    type: 'default',
  },
  {
    id: 123041,
    label: 'Αθήνα - Βόρεια Προάστια, Ηράκλειο, Άνω Ψαλίδι',
    value: 123041,
    type: 'default',
  },
  {
    id: 123042,
    label: 'Αθήνα - Βόρεια Προάστια, Ηράκλειο, Ηπειρώτικα',
    value: 123042,
    type: 'default',
  },
  {
    id: 2109,
    label: 'Αθήνα - Βόρεια Προάστια, Κρυονέρι',
    value: 2109,
    type: 'default',
  },
  {
    id: 4607,
    label: 'Αθήνα - Βόρεια Προάστια, Κρυονέρι, Ζώνη Χονδρεμπορίου',
    value: 4607,
    type: 'default',
  },
  {
    id: 4606,
    label: 'Αθήνα - Βόρεια Προάστια, Κρυονέρι, Κέντρο',
    value: 4606,
    type: 'default',
  },
  {
    id: 2110,
    label: 'Αθήνα - Βόρεια Προάστια, Λυκόβρυση',
    value: 2110,
    type: 'default',
  },
  {
    id: 123060,
    label: 'Αθήνα - Βόρεια Προάστια, Λυκόβρυση, Ζωοδόχος Πηγή',
    value: 123060,
    type: 'default',
  },
  {
    id: 123061,
    label: 'Αθήνα - Βόρεια Προάστια, Λυκόβρυση, Αγία Βαρβάρα Λυκοβρύσεως',
    value: 123061,
    type: 'default',
  },
  {
    id: 123062,
    label: 'Αθήνα - Βόρεια Προάστια, Λυκόβρυση, Αγία Ειρήνη Λυκόβρυσης',
    value: 123062,
    type: 'default',
  },
  {
    id: 2111,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι',
    value: 2111,
    type: 'default',
  },
  {
    id: 1170124,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Άγιοι Ανάργυροι',
    value: 1170124,
    type: 'default',
  },
  {
    id: 1170125,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Σισμανόγλειο',
    value: 1170125,
    type: 'default',
  },
  {
    id: 102111,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Κέντρο',
    value: 102111,
    type: 'default',
  },
  {
    id: 106298,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Νέο Τέρμα',
    value: 106298,
    type: 'default',
  },
  {
    id: 106305,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Στούντιο Άλφα',
    value: 106305,
    type: 'default',
  },
  {
    id: 106317,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Νέα Λέσβος',
    value: 106317,
    type: 'default',
  },
  {
    id: 106331,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Ανάβρυτα',
    value: 106331,
    type: 'default',
  },
  {
    id: 106336,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Άλσος Κτήματος Συγγρού',
    value: 106336,
    type: 'default',
  },
  {
    id: 106340,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Αμαλίειο Ορφανοτροφείο',
    value: 106340,
    type: 'default',
  },
  {
    id: 106345,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Ο.Α.Κ.Α.',
    value: 106345,
    type: 'default',
  },
  {
    id: 106349,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Κοκκινιά',
    value: 106349,
    type: 'default',
  },
  {
    id: 106397,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Α.Σ.ΠΑΙ.Τ.Ε.',
    value: 106397,
    type: 'default',
  },
  {
    id: 106425,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Όριο Βριλησσίων',
    value: 106425,
    type: 'default',
  },
  {
    id: 106431,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Εργατικές Πολυκατοικίες',
    value: 106431,
    type: 'default',
  },
  {
    id: 106439,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Ψαλίδι',
    value: 106439,
    type: 'default',
  },
  {
    id: 117000,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Νέα Φιλοθέη',
    value: 117000,
    type: 'default',
  },
  {
    id: 117001,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Σωρός',
    value: 117001,
    type: 'default',
  },
  {
    id: 117002,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Παράδεισος',
    value: 117002,
    type: 'default',
  },
  {
    id: 1170123,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Άγιος Θωμάς',
    value: 1170123,
    type: 'default',
  },
  {
    id: 13000001,
    label: 'Αθήνα - Βόρεια Προάστια, Μαρούσι, Πολύδροσο',
    value: 13000001,
    type: 'default',
  },
  {
    id: 2112,
    label: 'Αθήνα - Βόρεια Προάστια, Μελίσσια',
    value: 2112,
    type: 'default',
  },
  {
    id: 106295,
    label: 'Αθήνα - Βόρεια Προάστια, Μελίσσια, Αμαλία Φλέμινγκ',
    value: 106295,
    type: 'default',
  },
  {
    id: 106319,
    label: 'Αθήνα - Βόρεια Προάστια, Μελίσσια, Όριο Βριλησσίων',
    value: 106319,
    type: 'default',
  },
  {
    id: 106373,
    label: 'Αθήνα - Βόρεια Προάστια, Μελίσσια, Όριο Κηφισιάς',
    value: 106373,
    type: 'default',
  },
  {
    id: 106339,
    label: 'Αθήνα - Βόρεια Προάστια, Μελίσσια, Άνω Μελίσσια',
    value: 106339,
    type: 'default',
  },
  {
    id: 2114,
    label: 'Αθήνα - Βόρεια Προάστια, Νέα Πεντέλη',
    value: 2114,
    type: 'default',
  },
  {
    id: 499141,
    label: 'Αθήνα - Βόρεια Προάστια, Νέα Πεντέλη, Κέντρο  Νέας Πεντέλης',
    value: 499141,
    type: 'default',
  },
  {
    id: 499142,
    label: 'Αθήνα - Βόρεια Προάστια, Νέα Πεντέλη, Προφήτης Ηλίας',
    value: 499142,
    type: 'default',
  },
  {
    id: 499143,
    label: 'Αθήνα - Βόρεια Προάστια, Νέα Πεντέλη, Άγιος Σύλλας',
    value: 499143,
    type: 'default',
  },
  {
    id: 2115,
    label: 'Αθήνα - Βόρεια Προάστια, Νέο Ψυχικό',
    value: 2115,
    type: 'default',
  },
  {
    id: 123000,
    label: 'Αθήνα - Βόρεια Προάστια, Νέο Ψυχικό, Αγία Σοφία',
    value: 123000,
    type: 'default',
  },
  {
    id: 123001,
    label: 'Αθήνα - Βόρεια Προάστια, Νέο Ψυχικό, Φάρος',
    value: 123001,
    type: 'default',
  },
  {
    id: 123002,
    label: 'Αθήνα - Βόρεια Προάστια, Νέο Ψυχικό, Άγιος Γεώργιος',
    value: 123002,
    type: 'default',
  },
  {
    id: 2116,
    label: 'Αθήνα - Βόρεια Προάστια, Παπάγου',
    value: 2116,
    type: 'default',
  },
  {
    id: 123140,
    label: 'Αθήνα - Βόρεια Προάστια, Παπάγου, Κάτω Παπάγου',
    value: 123140,
    type: 'default',
  },
  {
    id: 123141,
    label: 'Αθήνα - Βόρεια Προάστια, Παπάγου, Πάρκο Στρατάρχου Παπάγου',
    value: 123141,
    type: 'default',
  },
  {
    id: 123142,
    label: 'Αθήνα - Βόρεια Προάστια, Παπάγου, Άνω Παπάγου',
    value: 123142,
    type: 'default',
  },
  {
    id: 2117,
    label: 'Αθήνα - Βόρεια Προάστια, Πεντέλη',
    value: 2117,
    type: 'default',
  },
  {
    id: 102117,
    label: 'Αθήνα - Βόρεια Προάστια, Πεντέλη, Κέντρο',
    value: 102117,
    type: 'default',
  },
  {
    id: 116404,
    label: 'Αθήνα - Βόρεια Προάστια, Πεντέλη, Καλίσια',
    value: 116404,
    type: 'default',
  },
  {
    id: 116405,
    label: 'Αθήνα - Βόρεια Προάστια, Πεντέλη, Άνω Πεντέλη',
    value: 116405,
    type: 'default',
  },
  {
    id: 116406,
    label: 'Αθήνα - Βόρεια Προάστια, Πεντέλη, Βαγιάτη',
    value: 116406,
    type: 'default',
  },
  {
    id: 116407,
    label: 'Αθήνα - Βόρεια Προάστια, Πεντέλη, Μουζάκη',
    value: 116407,
    type: 'default',
  },
  {
    id: 116408,
    label: 'Αθήνα - Βόρεια Προάστια, Πεντέλη, Νταού Πεντέλη',
    value: 116408,
    type: 'default',
  },
  {
    id: 2118,
    label: 'Αθήνα - Βόρεια Προάστια, Πεύκη',
    value: 2118,
    type: 'default',
  },
  {
    id: 123050,
    label: 'Αθήνα - Βόρεια Προάστια, Πεύκη, Άνω Πεύκη',
    value: 123050,
    type: 'default',
  },
  {
    id: 123051,
    label: 'Αθήνα - Βόρεια Προάστια, Πεύκη, Κάτω Πεύκη',
    value: 123051,
    type: 'default',
  },
  {
    id: 2119,
    label: 'Αθήνα - Βόρεια Προάστια, Ροδόπολη',
    value: 2119,
    type: 'default',
  },
  {
    id: 499144,
    label: 'Αθήνα - Βόρεια Προάστια, Ροδόπολη, Λεωφόρος Ροδόπολης',
    value: 499144,
    type: 'default',
  },
  {
    id: 499145,
    label: 'Αθήνα - Βόρεια Προάστια, Ροδόπολη, Πεντελικό δάσος Ροδοπόλεως',
    value: 499145,
    type: 'default',
  },
  {
    id: 499146,
    label: 'Αθήνα - Βόρεια Προάστια, Ροδόπολη, Υπόλοιπο Ροδόπολης',
    value: 499146,
    type: 'default',
  },
  {
    id: 2120,
    label: 'Αθήνα - Βόρεια Προάστια, Σταμάτα',
    value: 2120,
    type: 'default',
  },
  {
    id: 4613,
    label: 'Αθήνα - Βόρεια Προάστια, Σταμάτα, Κέντρο',
    value: 4613,
    type: 'default',
  },
  {
    id: 4614,
    label: 'Αθήνα - Βόρεια Προάστια, Σταμάτα, Εύξεινος Πόντος',
    value: 4614,
    type: 'default',
  },
  {
    id: 2121,
    label: 'Αθήνα - Βόρεια Προάστια, Φιλοθέη',
    value: 2121,
    type: 'default',
  },
  {
    id: 123020,
    label: 'Αθήνα - Βόρεια Προάστια, Φιλοθέη, Δροσοπούλου',
    value: 123020,
    type: 'default',
  },
  {
    id: 123021,
    label: 'Αθήνα - Βόρεια Προάστια, Φιλοθέη, Άνω Φιλοθέη',
    value: 123021,
    type: 'default',
  },
  {
    id: 2122,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι',
    value: 2122,
    type: 'default',
  },
  {
    id: 329482,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι, Αγία Βαρβάρα',
    value: 329482,
    type: 'default',
  },
  {
    id: 329483,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι, Αγία Άννα',
    value: 329483,
    type: 'default',
  },
  {
    id: 329484,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι, Τούφα',
    value: 329484,
    type: 'default',
  },
  {
    id: 329485,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι, Πάτημα',
    value: 329485,
    type: 'default',
  },
  {
    id: 102122,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι, Κέντρο',
    value: 102122,
    type: 'default',
  },
  {
    id: 106313,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι, Άνω Πάτημα',
    value: 106313,
    type: 'default',
  },
  {
    id: 106341,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι, Έθνος',
    value: 106341,
    type: 'default',
  },
  {
    id: 106435,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι, Ριζάρειος',
    value: 106435,
    type: 'default',
  },
  {
    id: 107025,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι, Πολύδροσο',
    value: 107025,
    type: 'default',
  },
  {
    id: 107027,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι, Νέο Χαλάνδρι',
    value: 107027,
    type: 'default',
  },
  {
    id: 107029,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι, Σίδερα Χαλανδρίου',
    value: 107029,
    type: 'default',
  },
  {
    id: 107030,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι, Νομισματοκοπειο',
    value: 107030,
    type: 'default',
  },
  {
    id: 107031,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι, Άνω Χαλάνδρι',
    value: 107031,
    type: 'default',
  },
  {
    id: 329481,
    label: 'Αθήνα - Βόρεια Προάστια, Χαλάνδρι, Κάτω Χαλάνδρι',
    value: 329481,
    type: 'default',
  },
  {
    id: 2123,
    label: 'Αθήνα - Βόρεια Προάστια, Χολαργός',
    value: 2123,
    type: 'default',
  },
  {
    id: 106271,
    label: 'Αθήνα - Βόρεια Προάστια, Χολαργός, Άνω Χολαργός',
    value: 106271,
    type: 'default',
  },
  {
    id: 123130,
    label: 'Αθήνα - Βόρεια Προάστια, Χολαργός, Λόφος Τσακού',
    value: 123130,
    type: 'default',
  },
  {
    id: 202317,
    label: 'Αθήνα - Βόρεια Προάστια, Χολαργός, Φανερωμένη',
    value: 202317,
    type: 'default',
  },
  {
    id: 202318,
    label: 'Αθήνα - Βόρεια Προάστια, Χολαργός, Πλατεία Δημοκρατίας',
    value: 202318,
    type: 'default',
  },
  {
    id: 2108,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά',
    value: 2108,
    type: 'default',
  },
  {
    id: 102108,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Κέντρο',
    value: 102108,
    type: 'default',
  },
  {
    id: 106282,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Κεφαλάρι',
    value: 106282,
    type: 'default',
  },
  {
    id: 106322,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Άνω Κηφισιά',
    value: 106322,
    type: 'default',
  },
  {
    id: 106326,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Πολιτεία',
    value: 106326,
    type: 'default',
  },
  {
    id: 106330,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Αδάμες (Οικισμός Γράμμος - Φοίνικας)',
    value: 106330,
    type: 'default',
  },
  {
    id: 106361,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Προφήτης Ηλίας',
    value: 106361,
    type: 'default',
  },
  {
    id: 106366,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Κάτω Κηφισιά',
    value: 106366,
    type: 'default',
  },
  {
    id: 106375,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Νέα Κηφισιά',
    value: 106375,
    type: 'default',
  },
  {
    id: 106385,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Ζηρίνειο',
    value: 106385,
    type: 'default',
  },
  {
    id: 106386,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Αγία Κυριακή',
    value: 106386,
    type: 'default',
  },
  {
    id: 106417,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Πανόραμα',
    value: 106417,
    type: 'default',
  },
  {
    id: 106421,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Στροφύλι',
    value: 106421,
    type: 'default',
  },
  {
    id: 106428,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Αδάμες (Οικισμός Πελοποννησίων)',
    value: 106428,
    type: 'default',
  },
  {
    id: 13000129,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Άγιος Παντελεήμονας',
    value: 13000129,
    type: 'default',
  },
  {
    id: 13000130,
    label: 'Αθήνα - Βόρεια Προάστια, Κηφισιά, Καλυφτάκη',
    value: 13000130,
    type: 'default',
  },
  {
    id: 2113,
    label: 'Αθήνα - Βόρεια Προάστια, Νέα Ερυθραία',
    value: 2113,
    type: 'default',
  },
  {
    id: 4608,
    label: 'Αθήνα - Βόρεια Προάστια, Νέα Ερυθραία, Κέντρο',
    value: 4608,
    type: 'default',
  },
  {
    id: 4609,
    label: 'Αθήνα - Βόρεια Προάστια, Νέα Ερυθραία, Καστρίτσα',
    value: 4609,
    type: 'default',
  },
  {
    id: 4610,
    label: 'Αθήνα - Βόρεια Προάστια, Νέα Ερυθραία, Μορτερό',
    value: 4610,
    type: 'default',
  },
  {
    id: 4611,
    label: 'Αθήνα - Βόρεια Προάστια, Νέα Ερυθραία, Καστρί',
    value: 4611,
    type: 'default',
  },
  {
    id: 4612,
    label: 'Αθήνα - Βόρεια Προάστια, Νέα Ερυθραία, Εθνικιστών και Αναπήρων Πολέμου',
    value: 4612,
    type: 'default',
  },
  {
    id: 2124,
    label: 'Αθήνα - Βόρεια Προάστια, Παλαιό Ψυχικό',
    value: 2124,
    type: 'default',
  },
  {
    id: 123010,
    label: 'Αθήνα - Βόρεια Προάστια, Παλαιό Ψυχικό, Ευκάλυπτοι - Άνω Φάρος',
    value: 123010,
    type: 'default',
  },
  {
    id: 123011,
    label: 'Αθήνα - Βόρεια Προάστια, Παλαιό Ψυχικό, Άγιος Δημήτριος',
    value: 123011,
    type: 'default',
  },
  {
    id: 123012,
    label: 'Αθήνα - Βόρεια Προάστια, Παλαιό Ψυχικό, Καμάρας',
    value: 123012,
    type: 'default',
  },
  {
    id: 123014,
    label: 'Αθήνα - Βόρεια Προάστια, Παλαιό Ψυχικό, Αρσάκειο',
    value: 123014,
    type: 'default',
  },
  {
    id: 123015,
    label: 'Αθήνα - Βόρεια Προάστια, Παλαιό Ψυχικό, Κολλέγιο Αθηνών',
    value: 123015,
    type: 'default',
  },
  {
    id: 123013,
    label: 'Αθήνα - Βόρεια Προάστια, Παλαιό Ψυχικό, Ελευθερίας',
    value: 123013,
    type: 'default',
  },
  {
    id: 102,
    label: 'Αθήνα - Νότια Προάστια',
    value: 102,
    type: 'default',
  },
  {
    id: 2200,
    label: 'Αθήνα - Νότια Προάστια, Άγιος Δημήτριος',
    value: 2200,
    type: 'default',
  },
  {
    id: 106367,
    label: 'Αθήνα - Νότια Προάστια, Άγιος Δημήτριος, Νεκροταφείο Καλλιθέας',
    value: 106367,
    type: 'default',
  },
  {
    id: 4615,
    label: 'Αθήνα - Νότια Προάστια, Άγιος Δημήτριος, Κέντρο',
    value: 4615,
    type: 'default',
  },
  {
    id: 106391,
    label: 'Αθήνα - Νότια Προάστια, Άγιος Δημήτριος, Τσουκάλι',
    value: 106391,
    type: 'default',
  },
  {
    id: 106402,
    label: 'Αθήνα - Νότια Προάστια, Άγιος Δημήτριος, Ασύρματος',
    value: 106402,
    type: 'default',
  },
  {
    id: 106405,
    label: 'Αθήνα - Νότια Προάστια, Άγιος Δημήτριος, Μοναστήριο',
    value: 106405,
    type: 'default',
  },
  {
    id: 106409,
    label: 'Αθήνα - Νότια Προάστια, Άγιος Δημήτριος, Νεκροταφείο',
    value: 106409,
    type: 'default',
  },
  {
    id: 123200,
    label: 'Αθήνα - Νότια Προάστια, Άγιος Δημήτριος, Σούλι',
    value: 123200,
    type: 'default',
  },
  {
    id: 106257,
    label: 'Αθήνα - Νότια Προάστια, Άγιος Δημήτριος, Κοψαχείλα',
    value: 106257,
    type: 'default',
  },
  {
    id: 106261,
    label: 'Αθήνα - Νότια Προάστια, Άγιος Δημήτριος, Ανθέων',
    value: 106261,
    type: 'default',
  },
  {
    id: 106294,
    label: 'Αθήνα - Νότια Προάστια, Άγιος Δημήτριος, Εθνικής Αντιστάσεως',
    value: 106294,
    type: 'default',
  },
  {
    id: 106390,
    label: 'Αθήνα - Νότια Προάστια, Άγιος Δημήτριος, Ελιά',
    value: 106390,
    type: 'default',
  },
  {
    id: 2201,
    label: 'Αθήνα - Νότια Προάστια, Άλιμος',
    value: 2201,
    type: 'default',
  },
  {
    id: 102201,
    label: 'Αθήνα - Νότια Προάστια, Άλιμος, Κέντρο',
    value: 102201,
    type: 'default',
  },
  {
    id: 106286,
    label: 'Αθήνα - Νότια Προάστια, Άλιμος, Εκτελωνιστών - Εφοριακών',
    value: 106286,
    type: 'default',
  },
  {
    id: 106315,
    label: 'Αθήνα - Νότια Προάστια, Άλιμος, Τράχωνες',
    value: 106315,
    type: 'default',
  },
  {
    id: 106321,
    label: 'Αθήνα - Νότια Προάστια, Άλιμος, Άνω Καλαμάκι',
    value: 106321,
    type: 'default',
  },
  {
    id: 107205,
    label: 'Αθήνα - Νότια Προάστια, Άλιμος, Καλαμάκι',
    value: 107205,
    type: 'default',
  },
  {
    id: 123210,
    label: 'Αθήνα - Νότια Προάστια, Άλιμος, Κεφαλληνίων',
    value: 123210,
    type: 'default',
  },
  {
    id: 13000109,
    label: 'Αθήνα - Νότια Προάστια, Άλιμος, Κυθηρίων - Πανί',
    value: 13000109,
    type: 'default',
  },
  {
    id: 2202,
    label: 'Αθήνα - Νότια Προάστια, Αργυρούπολη',
    value: 2202,
    type: 'default',
  },
  {
    id: 102202,
    label: 'Αθήνα - Νότια Προάστια, Αργυρούπολη, Κέντρο',
    value: 102202,
    type: 'default',
  },
  {
    id: 202319,
    label: 'Αθήνα - Νότια Προάστια, Αργυρούπολη, Νέα Αλεξάνδρεια',
    value: 202319,
    type: 'default',
  },
  {
    id: 2203,
    label: 'Αθήνα - Νότια Προάστια, Βάρη - Βάρκιζα',
    value: 2203,
    type: 'default',
  },
  {
    id: 2204,
    label: 'Αθήνα - Νότια Προάστια, Βάρη - Βάρκιζα, Βάρκιζα',
    value: 2204,
    type: 'default',
  },
  {
    id: 102203,
    label: 'Αθήνα - Νότια Προάστια, Βάρη - Βάρκιζα, Βάρη',
    value: 102203,
    type: 'default',
  },
  {
    id: 123241,
    label: 'Αθήνα - Νότια Προάστια, Βάρη - Βάρκιζα, Λαθουρίζα',
    value: 123241,
    type: 'default',
  },
  {
    id: 123242,
    label: 'Αθήνα - Νότια Προάστια, Βάρη - Βάρκιζα, Ασύρματος Αλίανθου',
    value: 123242,
    type: 'default',
  },
  {
    id: 202302,
    label: 'Αθήνα - Νότια Προάστια, Βάρη - Βάρκιζα, Μηλαδέζα',
    value: 202302,
    type: 'default',
  },
  {
    id: 202303,
    label: 'Αθήνα - Νότια Προάστια, Βάρη - Βάρκιζα, Βλάχικα',
    value: 202303,
    type: 'default',
  },
  {
    id: 202304,
    label: 'Αθήνα - Νότια Προάστια, Βάρη - Βάρκιζα, Χέρωμα',
    value: 202304,
    type: 'default',
  },
  {
    id: 2205,
    label: 'Αθήνα - Νότια Προάστια, Βούλα',
    value: 2205,
    type: 'default',
  },
  {
    id: 106415,
    label: 'Αθήνα - Νότια Προάστια, Βούλα, Ευρυάλη',
    value: 106415,
    type: 'default',
  },
  {
    id: 106427,
    label: 'Αθήνα - Νότια Προάστια, Βούλα, Κέντρο',
    value: 106427,
    type: 'default',
  },
  {
    id: 107216,
    label: 'Αθήνα - Νότια Προάστια, Βούλα, Πανόραμα',
    value: 107216,
    type: 'default',
  },
  {
    id: 202305,
    label: 'Αθήνα - Νότια Προάστια, Βούλα, Δικηγορικά',
    value: 202305,
    type: 'default',
  },
  {
    id: 202306,
    label: 'Αθήνα - Νότια Προάστια, Βούλα, Πηγαδάκια',
    value: 202306,
    type: 'default',
  },
  {
    id: 202307,
    label: 'Αθήνα - Νότια Προάστια, Βούλα, Καλυμνιώτικα',
    value: 202307,
    type: 'default',
  },
  {
    id: 2206,
    label: 'Αθήνα - Νότια Προάστια, Βουλιαγμένη',
    value: 2206,
    type: 'default',
  },
  {
    id: 2213,
    label: 'Αθήνα - Νότια Προάστια, Βουλιαγμένη, Καβούρι',
    value: 2213,
    type: 'default',
  },
  {
    id: 102206,
    label: 'Αθήνα - Νότια Προάστια, Βουλιαγμένη, Κέντρο',
    value: 102206,
    type: 'default',
  },
  {
    id: 107212,
    label: 'Αθήνα - Νότια Προάστια, Βουλιαγμένη, Λαιμός',
    value: 107212,
    type: 'default',
  },
  {
    id: 2207,
    label: 'Αθήνα - Νότια Προάστια, Βύρωνας',
    value: 2207,
    type: 'default',
  },
  {
    id: 106355,
    label: 'Αθήνα - Νότια Προάστια, Βύρωνας, Νέο Παγκράτι',
    value: 106355,
    type: 'default',
  },
  {
    id: 106376,
    label: 'Αθήνα - Νότια Προάστια, Βύρωνας, Ζωοδόχος Πηγή',
    value: 106376,
    type: 'default',
  },
  {
    id: 106396,
    label: 'Αθήνα - Νότια Προάστια, Βύρωνας, Ανάληψη',
    value: 106396,
    type: 'default',
  },
  {
    id: 107182,
    label: 'Αθήνα - Νότια Προάστια, Βύρωνας, Νέα Ελβετία',
    value: 107182,
    type: 'default',
  },
  {
    id: 123170,
    label: 'Αθήνα - Νότια Προάστια, Βύρωνας, Μεταμόρφωση Βύρωνα',
    value: 123170,
    type: 'default',
  },
  {
    id: 123171,
    label: 'Αθήνα - Νότια Προάστια, Βύρωνας, Καρέας',
    value: 123171,
    type: 'default',
  },
  {
    id: 2208,
    label: 'Αθήνα - Νότια Προάστια, Γλυφάδα',
    value: 2208,
    type: 'default',
  },
  {
    id: 102208,
    label: 'Αθήνα - Νότια Προάστια, Γλυφάδα, Κάτω Γλυφάδα',
    value: 102208,
    type: 'default',
  },
  {
    id: 106283,
    label: 'Αθήνα - Νότια Προάστια, Γλυφάδα, Αιξωνή',
    value: 106283,
    type: 'default',
  },
  {
    id: 106293,
    label: 'Αθήνα - Νότια Προάστια, Γλυφάδα, Γκολφ',
    value: 106293,
    type: 'default',
  },
  {
    id: 106312,
    label: 'Αθήνα - Νότια Προάστια, Γλυφάδα, Αίγλη',
    value: 106312,
    type: 'default',
  },
  {
    id: 106436,
    label: 'Αθήνα - Νότια Προάστια, Γλυφάδα, Άνω Γλυφάδα',
    value: 106436,
    type: 'default',
  },
  {
    id: 117611,
    label: 'Αθήνα - Νότια Προάστια, Γλυφάδα, Τερψιθέα',
    value: 117611,
    type: 'default',
  },
  {
    id: 2209,
    label: 'Αθήνα - Νότια Προάστια, Δάφνη',
    value: 2209,
    type: 'default',
  },
  {
    id: 123190,
    label: 'Αθήνα - Νότια Προάστια, Δάφνη, Άνω Δάφνη',
    value: 123190,
    type: 'default',
  },
  {
    id: 123193,
    label: 'Αθήνα - Νότια Προάστια, Δάφνη, Κάτω Δάφνη',
    value: 123193,
    type: 'default',
  },
  {
    id: 123192,
    label: 'Αθήνα - Νότια Προάστια, Δάφνη, Αγία Βαρβάρα Δάφνης',
    value: 123192,
    type: 'default',
  },
  {
    id: 123191,
    label: 'Αθήνα - Νότια Προάστια, Δάφνη, Άνω Άγιος Ιωάννης',
    value: 123191,
    type: 'default',
  },
  {
    id: 2210,
    label: 'Αθήνα - Νότια Προάστια, Ελληνικό',
    value: 2210,
    type: 'default',
  },
  {
    id: 106268,
    label: 'Αθήνα - Νότια Προάστια, Ελληνικό, Κάτω Ελληνικό',
    value: 106268,
    type: 'default',
  },
  {
    id: 106377,
    label: 'Αθήνα - Νότια Προάστια, Ελληνικό, Άνω Ελληνικό',
    value: 106377,
    type: 'default',
  },
  {
    id: 123230,
    label: 'Αθήνα - Νότια Προάστια, Ελληνικό, Αγία Παρασκευή Ελληνικού',
    value: 123230,
    type: 'default',
  },
  {
    id: 202323,
    label: 'Αθήνα - Νότια Προάστια, Ελληνικό, Άνω Σούρμενα',
    value: 202323,
    type: 'default',
  },
  {
    id: 202322,
    label: 'Αθήνα - Νότια Προάστια, Ελληνικό, Κάτω Σούρμενα',
    value: 202322,
    type: 'default',
  },
  {
    id: 202321,
    label: 'Αθήνα - Νότια Προάστια, Ελληνικό, Ολυμπιακές Εγκαταστάσεις - Αεροδρόμιο',
    value: 202321,
    type: 'default',
  },
  {
    id: 2211,
    label: 'Αθήνα - Νότια Προάστια, Ζωγράφου',
    value: 2211,
    type: 'default',
  },
  {
    id: 6112,
    label: 'Αθήνα - Νότια Προάστια, Ζωγράφου, Άνω Ιλίσια',
    value: 6112,
    type: 'default',
  },
  {
    id: 102211,
    label: 'Αθήνα - Νότια Προάστια, Ζωγράφου, Κέντρο',
    value: 102211,
    type: 'default',
  },
  {
    id: 107159,
    label: 'Αθήνα - Νότια Προάστια, Ζωγράφου, Πανεπιστημιούπολη',
    value: 107159,
    type: 'default',
  },
  {
    id: 107160,
    label: 'Αθήνα - Νότια Προάστια, Ζωγράφου, Πολυτεχνιούπολη',
    value: 107160,
    type: 'default',
  },
  {
    id: 123150,
    label: 'Αθήνα - Νότια Προάστια, Ζωγράφου, Γουδή',
    value: 123150,
    type: 'default',
  },
  {
    id: 2212,
    label: 'Αθήνα - Νότια Προάστια, Ηλιούπολη',
    value: 2212,
    type: 'default',
  },
  {
    id: 106369,
    label: 'Αθήνα - Νότια Προάστια, Ηλιούπολη, Άνω Ηλιούπολη',
    value: 106369,
    type: 'default',
  },
  {
    id: 106401,
    label: 'Αθήνα - Νότια Προάστια, Ηλιούπολη, Λόφος Γερμανού',
    value: 106401,
    type: 'default',
  },
  {
    id: 106444,
    label: 'Αθήνα - Νότια Προάστια, Ηλιούπολη, Κάτω Ηλιούπολη',
    value: 106444,
    type: 'default',
  },
  {
    id: 107202,
    label: 'Αθήνα - Νότια Προάστια, Ηλιούπολη, Αστυνομικά',
    value: 107202,
    type: 'default',
  },
  {
    id: 2214,
    label: 'Αθήνα - Νότια Προάστια, Καισαριανή',
    value: 2214,
    type: 'default',
  },
  {
    id: 102214,
    label: 'Αθήνα - Νότια Προάστια, Καισαριανή, Κέντρο',
    value: 102214,
    type: 'default',
  },
  {
    id: 106370,
    label: 'Αθήνα - Νότια Προάστια, Καισαριανή, Σκοπευτήριο',
    value: 106370,
    type: 'default',
  },
  {
    id: 107165,
    label: 'Αθήνα - Νότια Προάστια, Καισαριανή, Πανεπιστημιούπολη',
    value: 107165,
    type: 'default',
  },
  {
    id: 123160,
    label: 'Αθήνα - Νότια Προάστια, Καισαριανή, Κάτω Ιλίσια (Καισαριανής)',
    value: 123160,
    type: 'default',
  },
  {
    id: 123161,
    label: 'Αθήνα - Νότια Προάστια, Καισαριανή, Κάτω Καισαριανή',
    value: 123161,
    type: 'default',
  },
  {
    id: 123162,
    label: 'Αθήνα - Νότια Προάστια, Καισαριανή, Άγιος Νικόλαος Καισαριανής',
    value: 123162,
    type: 'default',
  },
  {
    id: 123163,
    label: 'Αθήνα - Νότια Προάστια, Καισαριανή, Άνω Καισαριανή',
    value: 123163,
    type: 'default',
  },
  {
    id: 2216,
    label: 'Αθήνα - Νότια Προάστια, Νέα Σμύρνη',
    value: 2216,
    type: 'default',
  },
  {
    id: 106335,
    label: 'Αθήνα - Νότια Προάστια, Νέα Σμύρνη, Άνω Νέα Σμύρνη',
    value: 106335,
    type: 'default',
  },
  {
    id: 106408,
    label: 'Αθήνα - Νότια Προάστια, Νέα Σμύρνη, Άγιος Σώστης',
    value: 106408,
    type: 'default',
  },
  {
    id: 106411,
    label: 'Αθήνα - Νότια Προάστια, Νέα Σμύρνη, Χρυσάκη',
    value: 106411,
    type: 'default',
  },
  {
    id: 107957,
    label: 'Αθήνα - Νότια Προάστια, Νέα Σμύρνη, Κέντρο',
    value: 107957,
    type: 'default',
  },
  {
    id: 2217,
    label: 'Αθήνα - Νότια Προάστια, Παλαιό Φάληρο',
    value: 2217,
    type: 'default',
  },
  {
    id: 329490,
    label: 'Αθήνα - Νότια Προάστια, Παλαιό Φάληρο, Κέντρο',
    value: 329490,
    type: 'default',
  },
  {
    id: 329491,
    label: 'Αθήνα - Νότια Προάστια, Παλαιό Φάληρο, Παναγίτσα',
    value: 329491,
    type: 'default',
  },
  {
    id: 329492,
    label: 'Αθήνα - Νότια Προάστια, Παλαιό Φάληρο, Αμφιθέα',
    value: 329492,
    type: 'default',
  },
  {
    id: 329493,
    label: 'Αθήνα - Νότια Προάστια, Παλαιό Φάληρο, Κοψαχείλα',
    value: 329493,
    type: 'default',
  },
  {
    id: 329494,
    label: 'Αθήνα - Νότια Προάστια, Παλαιό Φάληρο, Αγία Βαρβάρα',
    value: 329494,
    type: 'default',
  },
  {
    id: 329495,
    label: 'Αθήνα - Νότια Προάστια, Παλαιό Φάληρο, Ευγενίδιο',
    value: 329495,
    type: 'default',
  },
  {
    id: 329498,
    label: 'Αθήνα - Νότια Προάστια, Παλαιό Φάληρο, Εδέμ',
    value: 329498,
    type: 'default',
  },
  {
    id: 329496,
    label: 'Αθήνα - Νότια Προάστια, Παλαιό Φάληρο, Φλοίσβος',
    value: 329496,
    type: 'default',
  },
  {
    id: 329470,
    label: 'Αθήνα - Νότια Προάστια, Παλαιό Φάληρο, Άγιος Πέτρος',
    value: 329470,
    type: 'default',
  },
  {
    id: 329497,
    label: 'Αθήνα - Νότια Προάστια, Παλαιό Φάληρο, Τροκαντερό',
    value: 329497,
    type: 'default',
  },
  {
    id: 2218,
    label: 'Αθήνα - Νότια Προάστια, Υμηττός',
    value: 2218,
    type: 'default',
  },
  {
    id: 123180,
    label: 'Αθήνα - Νότια Προάστια, Υμηττός, Άνω Υμηττός',
    value: 123180,
    type: 'default',
  },
  {
    id: 123181,
    label: 'Αθήνα - Νότια Προάστια, Υμηττός, Αγία Φωτεινή Υμηττού',
    value: 123181,
    type: 'default',
  },
  {
    id: 123182,
    label: 'Αθήνα - Νότια Προάστια, Υμηττός, Πυρκάλ',
    value: 123182,
    type: 'default',
  },
  {
    id: 123183,
    label: 'Αθήνα - Νότια Προάστια, Υμηττός, Αγία Λαύρα Υμηττού',
    value: 123183,
    type: 'default',
  },
  {
    id: 123184,
    label: 'Αθήνα - Νότια Προάστια, Υμηττός, Άγιος Πέτρος και Παύλος',
    value: 123184,
    type: 'default',
  },
  {
    id: 2215,
    label: 'Αθήνα - Νότια Προάστια, Καλλιθέα',
    value: 2215,
    type: 'default',
  },
  {
    id: 107190,
    label: 'Αθήνα - Νότια Προάστια, Καλλιθέα, Τζιτζιφιές',
    value: 107190,
    type: 'default',
  },
  {
    id: 106292,
    label: 'Αθήνα - Νότια Προάστια, Καλλιθέα, Λόφος Φιλαρέτου',
    value: 106292,
    type: 'default',
  },
  {
    id: 106316,
    label: 'Αθήνα - Νότια Προάστια, Καλλιθέα, Χρυσάκη',
    value: 106316,
    type: 'default',
  },
  {
    id: 106320,
    label: 'Αθήνα - Νότια Προάστια, Καλλιθέα, Χαροκόπου',
    value: 106320,
    type: 'default',
  },
  {
    id: 106437,
    label: 'Αθήνα - Νότια Προάστια, Καλλιθέα, Αγία Ελεούσα',
    value: 106437,
    type: 'default',
  },
  {
    id: 106389,
    label: 'Αθήνα - Νότια Προάστια, Καλλιθέα, Λόφος Σικελίας',
    value: 106389,
    type: 'default',
  },
  {
    id: 123220,
    label: 'Αθήνα - Νότια Προάστια, Καλλιθέα, Κέντρο',
    value: 123220,
    type: 'default',
  },
  {
    id: 103,
    label: 'Αθήνα - Δυτικά Προάστια',
    value: 103,
    type: 'default',
  },
  {
    id: 2300,
    label: 'Αθήνα - Δυτικά Προάστια, Αγία Βαρβάρα',
    value: 2300,
    type: 'default',
  },
  {
    id: 4619,
    label: 'Αθήνα - Δυτικά Προάστια, Αγία Βαρβάρα, Πολυκατοικίες',
    value: 4619,
    type: 'default',
  },
  {
    id: 4620,
    label: 'Αθήνα - Δυτικά Προάστια, Αγία Βαρβάρα, Άνω Αγία Βαρβάρα',
    value: 4620,
    type: 'default',
  },
  {
    id: 4616,
    label: 'Αθήνα - Δυτικά Προάστια, Αγία Βαρβάρα, Κέντρο',
    value: 4616,
    type: 'default',
  },
  {
    id: 4618,
    label: 'Αθήνα - Δυτικά Προάστια, Αγία Βαρβάρα, Λοιμωδών',
    value: 4618,
    type: 'default',
  },
  {
    id: 4617,
    label: 'Αθήνα - Δυτικά Προάστια, Αγία Βαρβάρα, Ριμινίτικα',
    value: 4617,
    type: 'default',
  },
  {
    id: 2301,
    label: 'Αθήνα - Δυτικά Προάστια, Αγιοι Ανάργυροι',
    value: 2301,
    type: 'default',
  },
  {
    id: 4625,
    label: 'Αθήνα - Δυτικά Προάστια, Αγιοι Ανάργυροι, Μυκονιάτικα',
    value: 4625,
    type: 'default',
  },
  {
    id: 4622,
    label: 'Αθήνα - Δυτικά Προάστια, Αγιοι Ανάργυροι, Ανάληψη',
    value: 4622,
    type: 'default',
  },
  {
    id: 4623,
    label: 'Αθήνα - Δυτικά Προάστια, Αγιοι Ανάργυροι, Ανάκασα',
    value: 4623,
    type: 'default',
  },
  {
    id: 4624,
    label: 'Αθήνα - Δυτικά Προάστια, Αγιοι Ανάργυροι, Τσούμπα',
    value: 4624,
    type: 'default',
  },
  {
    id: 4621,
    label: 'Αθήνα - Δυτικά Προάστια, Αγιοι Ανάργυροι, Κέντρο',
    value: 4621,
    type: 'default',
  },
  {
    id: 2302,
    label: 'Αθήνα - Δυτικά Προάστια, Αιγάλεω',
    value: 2302,
    type: 'default',
  },
  {
    id: 123100,
    label: 'Αθήνα - Δυτικά Προάστια, Αιγάλεω, Ελαιώνας',
    value: 123100,
    type: 'default',
  },
  {
    id: 123101,
    label: 'Αθήνα - Δυτικά Προάστια, Αιγάλεω, Βοτανικός',
    value: 123101,
    type: 'default',
  },
  {
    id: 123102,
    label: 'Αθήνα - Δυτικά Προάστια, Αιγάλεω, ΤΕΙ Αθηνών',
    value: 123102,
    type: 'default',
  },
  {
    id: 123103,
    label: 'Αθήνα - Δυτικά Προάστια, Αιγάλεω, ΤΕΙ Πειραιά',
    value: 123103,
    type: 'default',
  },
  {
    id: 123104,
    label: 'Αθήνα - Δυτικά Προάστια, Αιγάλεω, Κάτω Αιγάλεω - Εσταυρωμένου',
    value: 123104,
    type: 'default',
  },
  {
    id: 123105,
    label: 'Αθήνα - Δυτικά Προάστια, Αιγάλεω, Νέο Αιγάλεω',
    value: 123105,
    type: 'default',
  },
  {
    id: 123106,
    label: 'Αθήνα - Δυτικά Προάστια, Αιγάλεω, Νταμαράκια',
    value: 123106,
    type: 'default',
  },
  {
    id: 123107,
    label: 'Αθήνα - Δυτικά Προάστια, Αιγάλεω, Ιεράπολη',
    value: 123107,
    type: 'default',
  },
  {
    id: 123108,
    label: 'Αθήνα - Δυτικά Προάστια, Αιγάλεω, Σωτηράκη',
    value: 123108,
    type: 'default',
  },
  {
    id: 123109,
    label: 'Αθήνα - Δυτικά Προάστια, Αιγάλεω, Αναγέννηση',
    value: 123109,
    type: 'default',
  },
  {
    id: 123110,
    label: 'Αθήνα - Δυτικά Προάστια, Αιγάλεω, Μπαρουτάδικο',
    value: 123110,
    type: 'default',
  },
  {
    id: 123111,
    label: 'Αθήνα - Δυτικά Προάστια, Αιγάλεω, Λιούμη',
    value: 123111,
    type: 'default',
  },
  {
    id: 2304,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές',
    value: 2304,
    type: 'default',
  },
  {
    id: 4648,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Πλάτωνας',
    value: 4648,
    type: 'default',
  },
  {
    id: 4649,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Αυλίζα',
    value: 4649,
    type: 'default',
  },
  {
    id: 4650,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Πυργούθι',
    value: 4650,
    type: 'default',
  },
  {
    id: 4635,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Χαραυγή',
    value: 4635,
    type: 'default',
  },
  {
    id: 4636,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Πάρνηθα',
    value: 4636,
    type: 'default',
  },
  {
    id: 4637,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Πανόραμα',
    value: 4637,
    type: 'default',
  },
  {
    id: 4638,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Μεγάλα Σχοινία Α',
    value: 4638,
    type: 'default',
  },
  {
    id: 4639,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Μεγάλα Σχοινία Β',
    value: 4639,
    type: 'default',
  },
  {
    id: 4640,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Αγριλέζα',
    value: 4640,
    type: 'default',
  },
  {
    id: 4641,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Μπόσκιζα',
    value: 4641,
    type: 'default',
  },
  {
    id: 4642,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Αγία Παρασκευή',
    value: 4642,
    type: 'default',
  },
  {
    id: 4643,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Στρατόπεδο',
    value: 4643,
    type: 'default',
  },
  {
    id: 4644,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Ρέθι',
    value: 4644,
    type: 'default',
  },
  {
    id: 4645,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Νέο Νεκροταφείο Αχαρνών',
    value: 4645,
    type: 'default',
  },
  {
    id: 4646,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Άγιος Πέτρος',
    value: 4646,
    type: 'default',
  },
  {
    id: 4651,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Αγία Άννα',
    value: 4651,
    type: 'default',
  },
  {
    id: 4652,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Γεροβουνό',
    value: 4652,
    type: 'default',
  },
  {
    id: 4653,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Λυκότρυπα',
    value: 4653,
    type: 'default',
  },
  {
    id: 4654,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Ολυμπιακό Χωριό',
    value: 4654,
    type: 'default',
  },
  {
    id: 4655,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Νεάπολη',
    value: 4655,
    type: 'default',
  },
  {
    id: 4656,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Μεσονύχι',
    value: 4656,
    type: 'default',
  },
  {
    id: 4657,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Λαθέα',
    value: 4657,
    type: 'default',
  },
  {
    id: 102307,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Θρακομακεδόνες',
    value: 102307,
    type: 'default',
  },
  {
    id: 115901,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Αμυγδαλέζα',
    value: 115901,
    type: 'default',
  },
  {
    id: 4647,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Κέντρο Παλαιό Μενίδι',
    value: 4647,
    type: 'default',
  },
  {
    id: 206708,
    label: 'Αθήνα - Δυτικά Προάστια, Αχαρνές, Βαρυμπόμπη',
    value: 206708,
    type: 'default',
  },
  {
    id: 2305,
    label: 'Αθήνα - Δυτικά Προάστια, Γαλάτσι',
    value: 2305,
    type: 'default',
  },
  {
    id: 106270,
    label: 'Αθήνα - Δυτικά Προάστια, Γαλάτσι, Περιβόλια',
    value: 106270,
    type: 'default',
  },
  {
    id: 106285,
    label: 'Αθήνα - Δυτικά Προάστια, Γαλάτσι, Ακτήμονες',
    value: 106285,
    type: 'default',
  },
  {
    id: 106304,
    label: 'Αθήνα - Δυτικά Προάστια, Γαλάτσι, Μενιδιάτικα',
    value: 106304,
    type: 'default',
  },
  {
    id: 106314,
    label: 'Αθήνα - Δυτικά Προάστια, Γαλάτσι, Λαμπρινή',
    value: 106314,
    type: 'default',
  },
  {
    id: 106353,
    label: 'Αθήνα - Δυτικά Προάστια, Γαλάτσι, Καραγιαννέικα',
    value: 106353,
    type: 'default',
  },
  {
    id: 106365,
    label: 'Αθήνα - Δυτικά Προάστια, Γαλάτσι, Κρητικά',
    value: 106365,
    type: 'default',
  },
  {
    id: 106432,
    label: 'Αθήνα - Δυτικά Προάστια, Γαλάτσι, Άλσος Βεΐκου',
    value: 106432,
    type: 'default',
  },
  {
    id: 2308,
    label: 'Αθήνα - Δυτικά Προάστια, Ίλιον',
    value: 2308,
    type: 'default',
  },
  {
    id: 4658,
    label: 'Αθήνα - Δυτικά Προάστια, Ίλιον, Μιχελή',
    value: 4658,
    type: 'default',
  },
  {
    id: 4659,
    label: 'Αθήνα - Δυτικά Προάστια, Ίλιον, Πάρκο Αντώνη Τρίτση',
    value: 4659,
    type: 'default',
  },
  {
    id: 4660,
    label: 'Αθήνα - Δυτικά Προάστια, Ίλιον, Ριμινιτών',
    value: 4660,
    type: 'default',
  },
  {
    id: 4661,
    label: 'Αθήνα - Δυτικά Προάστια, Ίλιον, Πολυτέκνων',
    value: 4661,
    type: 'default',
  },
  {
    id: 4662,
    label: 'Αθήνα - Δυτικά Προάστια, Ίλιον, Ζωοδόχος Πηγή',
    value: 4662,
    type: 'default',
  },
  {
    id: 4663,
    label: 'Αθήνα - Δυτικά Προάστια, Ίλιον, Νέα Σεπόλια',
    value: 4663,
    type: 'default',
  },
  {
    id: 4664,
    label: 'Αθήνα - Δυτικά Προάστια, Ίλιον, Άγιος Φανούριος',
    value: 4664,
    type: 'default',
  },
  {
    id: 102308,
    label: 'Αθήνα - Δυτικά Προάστια, Ίλιον, Κέντρο',
    value: 102308,
    type: 'default',
  },
  {
    id: 117003,
    label: 'Αθήνα - Δυτικά Προάστια, Ίλιον, Παλατιανή',
    value: 117003,
    type: 'default',
  },
  {
    id: 2309,
    label: 'Αθήνα - Δυτικά Προάστια, Καματερό',
    value: 2309,
    type: 'default',
  },
  {
    id: 123090,
    label: 'Αθήνα - Δυτικά Προάστια, Καματερό, Γερόβουνο',
    value: 123090,
    type: 'default',
  },
  {
    id: 123091,
    label: 'Αθήνα - Δυτικά Προάστια, Καματερό, Αγία Τριάδα',
    value: 123091,
    type: 'default',
  },
  {
    id: 123092,
    label: 'Αθήνα - Δυτικά Προάστια, Καματερό, Νέα Χαραυγή',
    value: 123092,
    type: 'default',
  },
  {
    id: 123093,
    label: 'Αθήνα - Δυτικά Προάστια, Καματερό, Άτταλος',
    value: 123093,
    type: 'default',
  },
  {
    id: 123094,
    label: 'Αθήνα - Δυτικά Προάστια, Καματερό, Άγιος Τρύφωνας',
    value: 123094,
    type: 'default',
  },
  {
    id: 123095,
    label: 'Αθήνα - Δυτικά Προάστια, Καματερό, Τσόπα - Σουλιώτη',
    value: 123095,
    type: 'default',
  },
  {
    id: 2310,
    label: 'Αθήνα - Δυτικά Προάστια, Μεταμόρφωση',
    value: 2310,
    type: 'default',
  },
  {
    id: 106301,
    label: 'Αθήνα - Δυτικά Προάστια, Μεταμόρφωση, Λόγγος',
    value: 106301,
    type: 'default',
  },
  {
    id: 106302,
    label: 'Αθήνα - Δυτικά Προάστια, Μεταμόρφωση, Μποφίλια',
    value: 106302,
    type: 'default',
  },
  {
    id: 106306,
    label: 'Αθήνα - Δυτικά Προάστια, Μεταμόρφωση, Καναπίτσα',
    value: 106306,
    type: 'default',
  },
  {
    id: 106347,
    label: 'Αθήνα - Δυτικά Προάστια, Μεταμόρφωση, Προφήτης Ηλίας',
    value: 106347,
    type: 'default',
  },
  {
    id: 106447,
    label: 'Αθήνα - Δυτικά Προάστια, Μεταμόρφωση, Παλιές Κουκουβάουνες',
    value: 106447,
    type: 'default',
  },
  {
    id: 106350,
    label: 'Αθήνα - Δυτικά Προάστια, Μεταμόρφωση, Βλάχου',
    value: 106350,
    type: 'default',
  },
  {
    id: 102310,
    label: 'Αθήνα - Δυτικά Προάστια, Μεταμόρφωση, Κέντρο',
    value: 102310,
    type: 'default',
  },
  {
    id: 2311,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία',
    value: 2311,
    type: 'default',
  },
  {
    id: 106332,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία, Κάκκαβας',
    value: 106332,
    type: 'default',
  },
  {
    id: 117055,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία, Ελευθερούπολη',
    value: 117055,
    type: 'default',
  },
  {
    id: 123030,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία, Νεάπολη',
    value: 123030,
    type: 'default',
  },
  {
    id: 123031,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία, Άγιοι Ανάργυροι',
    value: 123031,
    type: 'default',
  },
  {
    id: 106342,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία, Άνω Καλογρέζα',
    value: 106342,
    type: 'default',
  },
  {
    id: 106362,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία, Νεόκτιστα',
    value: 106362,
    type: 'default',
  },
  {
    id: 106363,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία, Ινέπολη',
    value: 106363,
    type: 'default',
  },
  {
    id: 106426,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία, Κάτω Καλογρέζα',
    value: 106426,
    type: 'default',
  },
  {
    id: 106434,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία, ΒΙΟΠΑ',
    value: 106434,
    type: 'default',
  },
  {
    id: 107020,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία, Αλσούπολη',
    value: 107020,
    type: 'default',
  },
  {
    id: 102311,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία, Κέντρο',
    value: 102311,
    type: 'default',
  },
  {
    id: 106296,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία, Σαφράμπολη',
    value: 106296,
    type: 'default',
  },
  {
    id: 106289,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία, Περισσός',
    value: 106289,
    type: 'default',
  },
  {
    id: 106323,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Ιωνία, Λαζάρου',
    value: 106323,
    type: 'default',
  },
  {
    id: 2312,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Φιλαδέλφεια',
    value: 2312,
    type: 'default',
  },
  {
    id: 123070,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Φιλαδέλφεια, Μάδυτος',
    value: 123070,
    type: 'default',
  },
  {
    id: 123071,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Φιλαδέλφεια, Ειρήνη',
    value: 123071,
    type: 'default',
  },
  {
    id: 123072,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Φιλαδέλφεια, Νησίδα',
    value: 123072,
    type: 'default',
  },
  {
    id: 123073,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Φιλαδέλφεια, Απόμαχοι',
    value: 123073,
    type: 'default',
  },
  {
    id: 123074,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Φιλαδέλφεια, Κόκκινος Μύλος',
    value: 123074,
    type: 'default',
  },
  {
    id: 123075,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Φιλαδέλφεια, Ρενώ',
    value: 123075,
    type: 'default',
  },
  {
    id: 202308,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Φιλαδέλφεια, Εργατικές Πολυκατοικίες (Κηφισός)',
    value: 202308,
    type: 'default',
  },
  {
    id: 202331,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Φιλαδέλφεια, Εργατικές Πολυκατοικίες (Όρια Νέας Ιωνίας)',
    value: 202331,
    type: 'default',
  },
  {
    id: 202332,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Φιλαδέλφεια, Αστέρας',
    value: 202332,
    type: 'default',
  },
  {
    id: 202333,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Φιλαδέλφεια, Άλσος',
    value: 202333,
    type: 'default',
  },
  {
    id: 2313,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Χαλκηδόνα',
    value: 2313,
    type: 'default',
  },
  {
    id: 102313,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Χαλκηδόνα, Κέντρο',
    value: 102313,
    type: 'default',
  },
  {
    id: 202334,
    label: 'Αθήνα - Δυτικά Προάστια, Νέα Χαλκηδόνα, Χρυσαλλίδα',
    value: 202334,
    type: 'default',
  },
  {
    id: 2314,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι',
    value: 2314,
    type: 'default',
  },
  {
    id: 102314,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι, Κέντρο',
    value: 102314,
    type: 'default',
  },
  {
    id: 106276,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι, Νέα Σεπόλια',
    value: 106276,
    type: 'default',
  },
  {
    id: 106281,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι, Άγιος Ιωάννης Θεολόγος',
    value: 106281,
    type: 'default',
  },
  {
    id: 106288,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι, Λόφος Αξιωματικών',
    value: 106288,
    type: 'default',
  },
  {
    id: 106343,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι, Βιαμάξ',
    value: 106343,
    type: 'default',
  },
  {
    id: 106351,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι, Άσπρα Χώματα',
    value: 106351,
    type: 'default',
  },
  {
    id: 106357,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι, Κηπούπολη',
    value: 106357,
    type: 'default',
  },
  {
    id: 106359,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι, Άνω Λόφος',
    value: 106359,
    type: 'default',
  },
  {
    id: 106395,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι, Νέα Ζωή',
    value: 106395,
    type: 'default',
  },
  {
    id: 106413,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι, Τσαλαβούτα',
    value: 106413,
    type: 'default',
  },
  {
    id: 329480,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι, Άγιος Αντώνιος',
    value: 329480,
    type: 'default',
  },
  {
    id: 117076,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι, Χρυσούπολη',
    value: 117076,
    type: 'default',
  },
  {
    id: 117074,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι, Μπουρνάζι',
    value: 117074,
    type: 'default',
  },
  {
    id: 117075,
    label: 'Αθήνα - Δυτικά Προάστια, Περιστέρι, Ανθούπολη',
    value: 117075,
    type: 'default',
  },
  {
    id: 2315,
    label: 'Αθήνα - Δυτικά Προάστια, Πετρούπολη',
    value: 2315,
    type: 'default',
  },
  {
    id: 102315,
    label: 'Αθήνα - Δυτικά Προάστια, Πετρούπολη, Κέντρο',
    value: 102315,
    type: 'default',
  },
  {
    id: 106348,
    label: 'Αθήνα - Δυτικά Προάστια, Πετρούπολη, Άνω Πετρούπολη',
    value: 106348,
    type: 'default',
  },
  {
    id: 106422,
    label: 'Αθήνα - Δυτικά Προάστια, Πετρούπολη, Πεύκα Βέρδη',
    value: 106422,
    type: 'default',
  },
  {
    id: 106438,
    label: 'Αθήνα - Δυτικά Προάστια, Πετρούπολη, Πανόραμα',
    value: 106438,
    type: 'default',
  },
  {
    id: 123080,
    label: 'Αθήνα - Δυτικά Προάστια, Πετρούπολη, Κηπούπολη',
    value: 123080,
    type: 'default',
  },
  {
    id: 2316,
    label: 'Αθήνα - Δυτικά Προάστια, Χαϊδάρι',
    value: 2316,
    type: 'default',
  },
  {
    id: 107050,
    label: 'Αθήνα - Δυτικά Προάστια, Χαϊδάρι, Δαφνί',
    value: 107050,
    type: 'default',
  },
  {
    id: 108561,
    label: 'Αθήνα - Δυτικά Προάστια, Χαϊδάρι, Δάσος',
    value: 108561,
    type: 'default',
  },
  {
    id: 117077,
    label: 'Αθήνα - Δυτικά Προάστια, Χαϊδάρι, Κουνέλια',
    value: 117077,
    type: 'default',
  },
  {
    id: 117078,
    label: 'Αθήνα - Δυτικά Προάστια, Χαϊδάρι, Παλατάκι',
    value: 117078,
    type: 'default',
  },
  {
    id: 117079,
    label: 'Αθήνα - Δυτικά Προάστια, Χαϊδάρι, Αφαία',
    value: 117079,
    type: 'default',
  },
  {
    id: 123400,
    label: 'Αθήνα - Δυτικά Προάστια, Χαϊδάρι, Προφήτης Ηλίας',
    value: 123400,
    type: 'default',
  },
  {
    id: 123401,
    label: 'Αθήνα - Δυτικά Προάστια, Χαϊδάρι, Νέα Φώκαια',
    value: 123401,
    type: 'default',
  },
  {
    id: 123403,
    label: 'Αθήνα - Δυτικά Προάστια, Χαϊδάρι, Ελαιώνας',
    value: 123403,
    type: 'default',
  },
  {
    id: 123404,
    label: 'Αθήνα - Δυτικά Προάστια, Χαϊδάρι, Άνω Λιούμη',
    value: 123404,
    type: 'default',
  },
  {
    id: 123405,
    label: 'Αθήνα - Δυτικά Προάστια, Χαϊδάρι, Αστυθέα',
    value: 123405,
    type: 'default',
  },
  {
    id: 123406,
    label: 'Αθήνα - Δυτικά Προάστια, Χαϊδάρι, Αγία Γρηγορούσα',
    value: 123406,
    type: 'default',
  },
  {
    id: 206741,
    label: 'Αθήνα - Δυτικά Προάστια, Χαϊδάρι, Σκαραμαγκάς',
    value: 206741,
    type: 'default',
  },
  {
    id: 104,
    label: 'Αθήνα - Ανατολικά Προάστια',
    value: 104,
    type: 'default',
  },
  {
    id: 2400,
    label: 'Αθήνα - Ανατολικά Προάστια, Ανθούσα',
    value: 2400,
    type: 'default',
  },
  {
    id: 499132,
    label: 'Αθήνα - Ανατολικά Προάστια, Ανθούσα, Ανατολικά Λεωφόρου Ανθούσας',
    value: 499132,
    type: 'default',
  },
  {
    id: 499131,
    label: 'Αθήνα - Ανατολικά Προάστια, Ανθούσα, Δυτικά Λεωφόρου Ανθούσας',
    value: 499131,
    type: 'default',
  },
  {
    id: 2401,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα)',
    value: 2401,
    type: 'default',
  },
  {
    id: 102401,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα), Κέντρο',
    value: 102401,
    type: 'default',
  },
  {
    id: 117118,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα), Άγιος Σεραφείμ',
    value: 117118,
    type: 'default',
  },
  {
    id: 206710,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα), Βραυρώνα',
    value: 206710,
    type: 'default',
  },
  {
    id: 240100,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα), Άγιος Ιωάννης',
    value: 240100,
    type: 'default',
  },
  {
    id: 240101,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα), Άγιος Νικόλαος',
    value: 240101,
    type: 'default',
  },
  {
    id: 240102,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα), Αλυκή',
    value: 240102,
    type: 'default',
  },
  {
    id: 240103,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα), Βορινέζα',
    value: 240103,
    type: 'default',
  },
  {
    id: 240104,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα), Γαλήνη',
    value: 240104,
    type: 'default',
  },
  {
    id: 240105,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα), Γιούργια',
    value: 240105,
    type: 'default',
  },
  {
    id: 240106,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα), Πανόραμα',
    value: 240106,
    type: 'default',
  },
  {
    id: 240107,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα), Υπαπαντή',
    value: 240107,
    type: 'default',
  },
  {
    id: 240108,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα), Κατασκηνώσεις',
    value: 240108,
    type: 'default',
  },
  {
    id: 240109,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα), Μεσοβάρδα',
    value: 240109,
    type: 'default',
  },
  {
    id: 240110,
    label: 'Αθήνα - Ανατολικά Προάστια, Αρτέμιδα (Λούτσα), Πράσινος Λόφος',
    value: 240110,
    type: 'default',
  },
  {
    id: 2402,
    label: 'Αθήνα - Ανατολικά Προάστια, Γέρακας',
    value: 2402,
    type: 'default',
  },
  {
    id: 123304,
    label: 'Αθήνα - Ανατολικά Προάστια, Γέρακας, Δέση',
    value: 123304,
    type: 'default',
  },
  {
    id: 102402,
    label: 'Αθήνα - Ανατολικά Προάστια, Γέρακας, Κέντρο',
    value: 102402,
    type: 'default',
  },
  {
    id: 107037,
    label: 'Αθήνα - Ανατολικά Προάστια, Γέρακας, Μπαλάνα',
    value: 107037,
    type: 'default',
  },
  {
    id: 117057,
    label: 'Αθήνα - Ανατολικά Προάστια, Γέρακας, Σταυρός Γέρακα',
    value: 117057,
    type: 'default',
  },
  {
    id: 123303,
    label: 'Αθήνα - Ανατολικά Προάστια, Γέρακας, Γαργηττός',
    value: 123303,
    type: 'default',
  },
  {
    id: 2403,
    label: 'Αθήνα - Ανατολικά Προάστια, Γλυκά Νερά',
    value: 2403,
    type: 'default',
  },
  {
    id: 123310,
    label: 'Αθήνα - Ανατολικά Προάστια, Γλυκά Νερά, Κέντρο',
    value: 123310,
    type: 'default',
  },
  {
    id: 123311,
    label: 'Αθήνα - Ανατολικά Προάστια, Γλυκά Νερά, Φούρεσι',
    value: 123311,
    type: 'default',
  },
  {
    id: 507537,
    label: 'Αθήνα - Ανατολικά Προάστια, Γλυκά Νερά, Μιχούλη',
    value: 507537,
    type: 'default',
  },
  {
    id: 13000000,
    label: 'Αθήνα - Ανατολικά Προάστια, Γλυκά Νερά, Καμίνι',
    value: 13000000,
    type: 'default',
  },
  {
    id: 2404,
    label: 'Αθήνα - Ανατολικά Προάστια, Κορωπί',
    value: 2404,
    type: 'default',
  },
  {
    id: 102404,
    label: 'Αθήνα - Ανατολικά Προάστια, Κορωπί, Κέντρο',
    value: 102404,
    type: 'default',
  },
  {
    id: 117488,
    label: 'Αθήνα - Ανατολικά Προάστια, Κορωπί, Σκάρπιζα',
    value: 117488,
    type: 'default',
  },
  {
    id: 117490,
    label: 'Αθήνα - Ανατολικά Προάστια, Κορωπί, Αγία Μαρίνα',
    value: 117490,
    type: 'default',
  },
  {
    id: 202327,
    label: 'Αθήνα - Ανατολικά Προάστια, Κορωπί, Καρελλάς',
    value: 202327,
    type: 'default',
  },
  {
    id: 202328,
    label: 'Αθήνα - Ανατολικά Προάστια, Κορωπί, Άγιος Δημήτριος',
    value: 202328,
    type: 'default',
  },
  {
    id: 202329,
    label: 'Αθήνα - Ανατολικά Προάστια, Κορωπί, Κίτσι',
    value: 202329,
    type: 'default',
  },
  {
    id: 2405,
    label: 'Αθήνα - Ανατολικά Προάστια, Μαραθώνας',
    value: 2405,
    type: 'default',
  },
  {
    id: 2744,
    label: 'Αθήνα - Ανατολικά Προάστια, Μαραθώνας, Σχινιάς',
    value: 2744,
    type: 'default',
  },
  {
    id: 102405,
    label: 'Αθήνα - Ανατολικά Προάστια, Μαραθώνας, Κέντρο',
    value: 102405,
    type: 'default',
  },
  {
    id: 106266,
    label: 'Αθήνα - Ανατολικά Προάστια, Μαραθώνας, Αύρα',
    value: 106266,
    type: 'default',
  },
  {
    id: 106384,
    label: 'Αθήνα - Ανατολικά Προάστια, Μαραθώνας, Βρανάς',
    value: 106384,
    type: 'default',
  },
  {
    id: 115934,
    label: 'Αθήνα - Ανατολικά Προάστια, Μαραθώνας, Άγιος Παντελεήμονας',
    value: 115934,
    type: 'default',
  },
  {
    id: 115938,
    label: 'Αθήνα - Ανατολικά Προάστια, Μαραθώνας, Βόθωνας',
    value: 115938,
    type: 'default',
  },
  {
    id: 115943,
    label: 'Αθήνα - Ανατολικά Προάστια, Μαραθώνας, Σέσι',
    value: 115943,
    type: 'default',
  },
  {
    id: 123290,
    label: 'Αθήνα - Ανατολικά Προάστια, Μαραθώνας, Άνω Σούλι',
    value: 123290,
    type: 'default',
  },
  {
    id: 123291,
    label: 'Αθήνα - Ανατολικά Προάστια, Μαραθώνας, Κάτω Σούλι',
    value: 123291,
    type: 'default',
  },
  {
    id: 123292,
    label: 'Αθήνα - Ανατολικά Προάστια, Μαραθώνας, Δικαστικά',
    value: 123292,
    type: 'default',
  },
  {
    id: 2407,
    label: 'Αθήνα - Ανατολικά Προάστια, Νέα Μάκρη',
    value: 2407,
    type: 'default',
  },
  {
    id: 2700,
    label: 'Αθήνα - Ανατολικά Προάστια, Νέα Μάκρη, Άγιος Ανδρέας',
    value: 2700,
    type: 'default',
  },
  {
    id: 2729,
    label: 'Αθήνα - Ανατολικά Προάστια, Νέα Μάκρη, Μάτι',
    value: 2729,
    type: 'default',
  },
  {
    id: 2731,
    label: 'Αθήνα - Ανατολικά Προάστια, Νέα Μάκρη, Νέος Βουτζάς',
    value: 2731,
    type: 'default',
  },
  {
    id: 102407,
    label: 'Αθήνα - Ανατολικά Προάστια, Νέα Μάκρη, Κέντρο',
    value: 102407,
    type: 'default',
  },
  {
    id: 123283,
    label: 'Αθήνα - Ανατολικά Προάστια, Νέα Μάκρη, Αγία Μαρίνα Νέας Μάκρης',
    value: 123283,
    type: 'default',
  },
  {
    id: 123284,
    label: 'Αθήνα - Ανατολικά Προάστια, Νέα Μάκρη, Ζούμπερι',
    value: 123284,
    type: 'default',
  },
  {
    id: 2408,
    label: 'Αθήνα - Ανατολικά Προάστια, Παιανία',
    value: 2408,
    type: 'default',
  },
  {
    id: 102408,
    label: 'Αθήνα - Ανατολικά Προάστια, Παιανία, Κέντρο',
    value: 102408,
    type: 'default',
  },
  {
    id: 117333,
    label: 'Αθήνα - Ανατολικά Προάστια, Παιανία, Ουλίντζι',
    value: 117333,
    type: 'default',
  },
  {
    id: 117334,
    label: 'Αθήνα - Ανατολικά Προάστια, Παιανία, Βουή',
    value: 117334,
    type: 'default',
  },
  {
    id: 117335,
    label: 'Αθήνα - Ανατολικά Προάστια, Παιανία, Σπαρόζα',
    value: 117335,
    type: 'default',
  },
  {
    id: 117336,
    label: 'Αθήνα - Ανατολικά Προάστια, Παιανία, Αργιθέα',
    value: 117336,
    type: 'default',
  },
  {
    id: 240800,
    label: 'Αθήνα - Ανατολικά Προάστια, Παιανία, Τρίγωνο Λαγού',
    value: 240800,
    type: 'default',
  },
  {
    id: 240801,
    label: 'Αθήνα - Ανατολικά Προάστια, Παιανία, ΒΙΟ.ΠΑ',
    value: 240801,
    type: 'default',
  },
  {
    id: 240802,
    label: 'Αθήνα - Ανατολικά Προάστια, Παιανία, Αγία Τριάδα',
    value: 240802,
    type: 'default',
  },
  {
    id: 240803,
    label: 'Αθήνα - Ανατολικά Προάστια, Παιανία, Άγιος Ανδρέας',
    value: 240803,
    type: 'default',
  },
  {
    id: 240804,
    label: 'Αθήνα - Ανατολικά Προάστια, Παιανία, Άνοιξη',
    value: 240804,
    type: 'default',
  },
  {
    id: 240805,
    label: 'Αθήνα - Ανατολικά Προάστια, Παιανία, Αγία Μαρίνα',
    value: 240805,
    type: 'default',
  },
  {
    id: 240806,
    label: 'Αθήνα - Ανατολικά Προάστια, Παιανία, Μουσείο Βορρέ',
    value: 240806,
    type: 'default',
  },
  {
    id: 240807,
    label: 'Αθήνα - Ανατολικά Προάστια, Παιανία, Παιανία - Διάφορα',
    value: 240807,
    type: 'default',
  },
  {
    id: 2409,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη',
    value: 2409,
    type: 'default',
  },
  {
    id: 107039,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Κάντζα',
    value: 107039,
    type: 'default',
  },
  {
    id: 13000126,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Παπαχωράφι',
    value: 13000126,
    type: 'default',
  },
  {
    id: 104022,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Κέντρο',
    value: 104022,
    type: 'default',
  },
  {
    id: 13000117,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Άνω Βακαλόπουλο',
    value: 13000117,
    type: 'default',
  },
  {
    id: 13000118,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Άνω Μπαλάνα',
    value: 13000118,
    type: 'default',
  },
  {
    id: 13000119,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Καισάρεια',
    value: 13000119,
    type: 'default',
  },
  {
    id: 13000120,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Κάτω Βακαλόπουλο',
    value: 13000120,
    type: 'default',
  },
  {
    id: 13000121,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Κάτω Χαρβάτι',
    value: 13000121,
    type: 'default',
  },
  {
    id: 13000122,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Λουτρό',
    value: 13000122,
    type: 'default',
  },
  {
    id: 13000123,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Λόφος Παλλήνης',
    value: 13000123,
    type: 'default',
  },
  {
    id: 13000124,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Μαρίζα',
    value: 13000124,
    type: 'default',
  },
  {
    id: 13000125,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Νέα Παλλήνη',
    value: 13000125,
    type: 'default',
  },
  {
    id: 111107,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Άγιος Νικόλαος',
    value: 111107,
    type: 'default',
  },
  {
    id: 123320,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Κάτω Λεοντάρι',
    value: 123320,
    type: 'default',
  },
  {
    id: 507541,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Πανόραμα',
    value: 507541,
    type: 'default',
  },
  {
    id: 13000116,
    label: 'Αθήνα - Ανατολικά Προάστια, Παλλήνη, Άγιος Αθανάσιος',
    value: 13000116,
    type: 'default',
  },
  {
    id: 2412,
    label: 'Αθήνα - Ανατολικά Προάστια, Σπάτα',
    value: 2412,
    type: 'default',
  },
  {
    id: 102412,
    label: 'Αθήνα - Ανατολικά Προάστια, Σπάτα, Κέντρο',
    value: 102412,
    type: 'default',
  },
  {
    id: 117107,
    label: 'Αθήνα - Ανατολικά Προάστια, Σπάτα, Ήμερος Πεύκος',
    value: 117107,
    type: 'default',
  },
  {
    id: 117110,
    label: 'Αθήνα - Ανατολικά Προάστια, Σπάτα, Έτος Στέκο',
    value: 117110,
    type: 'default',
  },
  {
    id: 117113,
    label: 'Αθήνα - Ανατολικά Προάστια, Σπάτα, Νεάπολη',
    value: 117113,
    type: 'default',
  },
  {
    id: 117116,
    label: 'Αθήνα - Ανατολικά Προάστια, Σπάτα, Βελανιδιά',
    value: 117116,
    type: 'default',
  },
  {
    id: 117117,
    label: 'Αθήνα - Ανατολικά Προάστια, Σπάτα, Χριστούπολη',
    value: 117117,
    type: 'default',
  },
  {
    id: 117119,
    label: 'Αθήνα - Ανατολικά Προάστια, Σπάτα, Φοινίκας',
    value: 117119,
    type: 'default',
  },
  {
    id: 117120,
    label: 'Αθήνα - Ανατολικά Προάστια, Σπάτα, Αγία Κυριακή',
    value: 117120,
    type: 'default',
  },
  {
    id: 2707,
    label: 'Αθήνα - Ανατολικά Προάστια, Βαρνάβας',
    value: 2707,
    type: 'default',
  },
  {
    id: 102707,
    label: 'Αθήνα - Ανατολικά Προάστια, Βαρνάβας, Κέντρο',
    value: 102707,
    type: 'default',
  },
  {
    id: 123340,
    label: 'Αθήνα - Ανατολικά Προάστια, Βαρνάβας, Παραλία Βαρνάβα',
    value: 123340,
    type: 'default',
  },
  {
    id: 13000113,
    label: 'Αθήνα - Ανατολικά Προάστια, Βαρνάβας, Αγία Παρασκευή',
    value: 13000113,
    type: 'default',
  },
  {
    id: 13000114,
    label: 'Αθήνα - Ανατολικά Προάστια, Βαρνάβας, Άγιος Ιωάννης',
    value: 13000114,
    type: 'default',
  },
  {
    id: 13000115,
    label: 'Αθήνα - Ανατολικά Προάστια, Βαρνάβας, Πουρίθι',
    value: 13000115,
    type: 'default',
  },
  {
    id: 2711,
    label: 'Αθήνα - Ανατολικά Προάστια, Γραμματικό',
    value: 2711,
    type: 'default',
  },
  {
    id: 102711,
    label: 'Αθήνα - Ανατολικά Προάστια, Γραμματικό, Γραμματικό - Κέντρο',
    value: 102711,
    type: 'default',
  },
  {
    id: 123330,
    label: 'Αθήνα - Ανατολικά Προάστια, Γραμματικό, Αγία Μαρίνα',
    value: 123330,
    type: 'default',
  },
  {
    id: 105,
    label: 'Πειραιάς',
    value: 105,
    type: 'default',
  },
  {
    id: 105,
    label: 'Πειραιάς, Πειραιάς',
    value: 105,
    type: 'default',
  },
  {
    id: 499721,
    label: 'Πειραιάς, Καμίνια – Παλαιά Κοκκινιά',
    value: 499721,
    type: 'default',
  },
  {
    id: 2503,
    label: 'Πειραιάς, Καμίνια – Παλαιά Κοκκινιά, Καμίνια',
    value: 2503,
    type: 'default',
  },
  {
    id: 117415,
    label: 'Πειραιάς, Καμίνια – Παλαιά Κοκκινιά, Παλαιά Κοκκινιά',
    value: 117415,
    type: 'default',
  },
  {
    id: 2506,
    label: 'Πειραιάς, Νέο Φάληρο',
    value: 2506,
    type: 'default',
  },
  {
    id: 499125,
    label: 'Πειραιάς, Νέο Φάληρο, Ελαϊς',
    value: 499125,
    type: 'default',
  },
  {
    id: 499126,
    label: 'Πειραιάς, Νέο Φάληρο, Καραϊσκάκη',
    value: 499126,
    type: 'default',
  },
  {
    id: 499127,
    label: 'Πειραιάς, Νέο Φάληρο, Κέντρο Νέου Φαλήρου',
    value: 499127,
    type: 'default',
  },
  {
    id: 499110,
    label: 'Πειραιάς, Πειραϊκή - Χατζηκυριάκειο',
    value: 499110,
    type: 'default',
  },
  {
    id: 2508,
    label: 'Πειραιάς, Πειραϊκή - Χατζηκυριάκειο, Πειραϊκή',
    value: 2508,
    type: 'default',
  },
  {
    id: 2511,
    label: 'Πειραιάς, Πειραϊκή - Χατζηκυριάκειο, Χατζηκυριάκειο',
    value: 2511,
    type: 'default',
  },
  {
    id: 499111,
    label: 'Πειραιάς, Καλλίπολη – Φρεαττύδα',
    value: 499111,
    type: 'default',
  },
  {
    id: 2501,
    label: 'Πειραιάς, Καλλίπολη – Φρεαττύδα, Άγιος Βασίλειος',
    value: 2501,
    type: 'default',
  },
  {
    id: 2502,
    label: 'Πειραιάς, Καλλίπολη – Φρεαττύδα, Καλλίπολη',
    value: 2502,
    type: 'default',
  },
  {
    id: 2510,
    label: 'Πειραιάς, Καλλίπολη – Φρεαττύδα, Φρεαττύδα',
    value: 2510,
    type: 'default',
  },
  {
    id: 499112,
    label: 'Πειραιάς, Κέντρο - Λιμάνι',
    value: 499112,
    type: 'default',
  },
  {
    id: 2505,
    label: 'Πειραιάς, Κέντρο - Λιμάνι, Πειραιάς - Κέντρο',
    value: 2505,
    type: 'default',
  },
  {
    id: 2509,
    label: 'Πειραιάς, Κέντρο - Λιμάνι, Τερψιθέα',
    value: 2509,
    type: 'default',
  },
  {
    id: 117419,
    label: 'Πειραιάς, Κέντρο - Λιμάνι, Λιμάνι',
    value: 117419,
    type: 'default',
  },
  {
    id: 13000069,
    label: 'Πειραιάς, Κέντρο - Λιμάνι, Ευαγγελίστρια',
    value: 13000069,
    type: 'default',
  },
  {
    id: 499113,
    label: 'Πειραιάς, Ταμπούρια – Αγία Σοφία',
    value: 499113,
    type: 'default',
  },
  {
    id: 2500,
    label: 'Πειραιάς, Ταμπούρια – Αγία Σοφία, Αγία Σοφία',
    value: 2500,
    type: 'default',
  },
  {
    id: 117414,
    label: 'Πειραιάς, Ταμπούρια – Αγία Σοφία, Ταμπούρια',
    value: 117414,
    type: 'default',
  },
  {
    id: 499114,
    label: 'Πειραιάς, Καστέλλα - Πασαλιμάνι',
    value: 499114,
    type: 'default',
  },
  {
    id: 2504,
    label: 'Πειραιάς, Καστέλλα - Πασαλιμάνι, Καστέλλα',
    value: 2504,
    type: 'default',
  },
  {
    id: 2507,
    label: 'Πειραιάς, Καστέλλα - Πασαλιμάνι, Πασαλιμάνι',
    value: 2507,
    type: 'default',
  },
  {
    id: 107176,
    label: 'Πειραιάς, Καστέλλα - Πασαλιμάνι, Μικρολίμανο',
    value: 107176,
    type: 'default',
  },
  {
    id: 106,
    label: 'Προάστια Πειραιά',
    value: 106,
    type: 'default',
  },
  {
    id: 2600,
    label: 'Προάστια Πειραιά, Άγιος Ιωάννης Ρέντης',
    value: 2600,
    type: 'default',
  },
  {
    id: 102600,
    label: 'Προάστια Πειραιά, Άγιος Ιωάννης Ρέντης, Κέντρο',
    value: 102600,
    type: 'default',
  },
  {
    id: 123490,
    label: 'Προάστια Πειραιά, Άγιος Ιωάννης Ρέντης, Άνω Ρέντης',
    value: 123490,
    type: 'default',
  },
  {
    id: 123491,
    label: 'Προάστια Πειραιά, Άγιος Ιωάννης Ρέντης, Σιδηροδρομικό Πάρκο Ρέντη',
    value: 123491,
    type: 'default',
  },
  {
    id: 123492,
    label: 'Προάστια Πειραιά, Άγιος Ιωάννης Ρέντης, Λαχαναγορά',
    value: 123492,
    type: 'default',
  },
  {
    id: 123493,
    label: 'Προάστια Πειραιά, Άγιος Ιωάννης Ρέντης, Αγία Άννα',
    value: 123493,
    type: 'default',
  },
  {
    id: 2605,
    label: 'Προάστια Πειραιά, Δραπετσώνα',
    value: 2605,
    type: 'default',
  },
  {
    id: 123450,
    label: 'Προάστια Πειραιά, Δραπετσώνα, Ανάληψη',
    value: 123450,
    type: 'default',
  },
  {
    id: 123451,
    label: 'Προάστια Πειραιά, Δραπετσώνα, Άγιος Παντελεήμων',
    value: 123451,
    type: 'default',
  },
  {
    id: 123452,
    label: 'Προάστια Πειραιά, Δραπετσώνα, Άγιος Φανούριος',
    value: 123452,
    type: 'default',
  },
  {
    id: 2606,
    label: 'Προάστια Πειραιά, Κερατσίνι',
    value: 2606,
    type: 'default',
  },
  {
    id: 107140,
    label: 'Προάστια Πειραιά, Κερατσίνι, Αμφιάλη',
    value: 107140,
    type: 'default',
  },
  {
    id: 123440,
    label: 'Προάστια Πειραιά, Κερατσίνι, Κοκκινόβραχος',
    value: 123440,
    type: 'default',
  },
  {
    id: 123441,
    label: 'Προάστια Πειραιά, Κερατσίνι, Άγιος Γεώργιος',
    value: 123441,
    type: 'default',
  },
  {
    id: 123442,
    label: 'Προάστια Πειραιά, Κερατσίνι, Άγιος Παντελεήμονας',
    value: 123442,
    type: 'default',
  },
  {
    id: 123443,
    label: 'Προάστια Πειραιά, Κερατσίνι, Ανάσταση',
    value: 123443,
    type: 'default',
  },
  {
    id: 123444,
    label: 'Προάστια Πειραιά, Κερατσίνι, Ευγένεια',
    value: 123444,
    type: 'default',
  },
  {
    id: 123445,
    label: 'Προάστια Πειραιά, Κερατσίνι, Λιμάνι',
    value: 123445,
    type: 'default',
  },
  {
    id: 123446,
    label: 'Προάστια Πειραιά, Κερατσίνι, Κάτω Αμφιάλη',
    value: 123446,
    type: 'default',
  },
  {
    id: 123448,
    label: 'Προάστια Πειραιά, Κερατσίνι, Τουρκοβούνια',
    value: 123448,
    type: 'default',
  },
  {
    id: 123449,
    label: 'Προάστια Πειραιά, Κερατσίνι, Χαραυγή',
    value: 123449,
    type: 'default',
  },
  {
    id: 2607,
    label: 'Προάστια Πειραιά, Κορυδαλλός',
    value: 2607,
    type: 'default',
  },
  {
    id: 123480,
    label: 'Προάστια Πειραιά, Κορυδαλλός, Σχιστό Κορυδαλλού',
    value: 123480,
    type: 'default',
  },
  {
    id: 123481,
    label: 'Προάστια Πειραιά, Κορυδαλλός, Άνω Κορυδαλλός',
    value: 123481,
    type: 'default',
  },
  {
    id: 123482,
    label: 'Προάστια Πειραιά, Κορυδαλλός, Όριο Άγιας Βαρβάρας',
    value: 123482,
    type: 'default',
  },
  {
    id: 123483,
    label: 'Προάστια Πειραιά, Κορυδαλλός, Πλατεία Ελευθερίας',
    value: 123483,
    type: 'default',
  },
  {
    id: 123484,
    label: 'Προάστια Πειραιά, Κορυδαλλός, Πλατεία Μέμου',
    value: 123484,
    type: 'default',
  },
  {
    id: 123485,
    label: 'Προάστια Πειραιά, Κορυδαλλός, Τέρμα Καραβά',
    value: 123485,
    type: 'default',
  },
  {
    id: 123486,
    label: 'Προάστια Πειραιά, Κορυδαλλός, Φυλακές - Αθλητικό Κέντρο',
    value: 123486,
    type: 'default',
  },
  {
    id: 2610,
    label: 'Προάστια Πειραιά, Μοσχάτο',
    value: 2610,
    type: 'default',
  },
  {
    id: 102610,
    label: 'Προάστια Πειραιά, Μοσχάτο, Κέντρο',
    value: 102610,
    type: 'default',
  },
  {
    id: 499128,
    label: 'Προάστια Πειραιά, Μοσχάτο, Πλησίον ΗΣΑΠ',
    value: 499128,
    type: 'default',
  },
  {
    id: 499129,
    label: 'Προάστια Πειραιά, Μοσχάτο, Εθνική οδός - Μακρυγιάννη',
    value: 499129,
    type: 'default',
  },
  {
    id: 499130,
    label: 'Προάστια Πειραιά, Μοσχάτο, Χρυσοστόμου Σμύρνης - Μεταμορφώσεως',
    value: 499130,
    type: 'default',
  },
  {
    id: 2611,
    label: 'Προάστια Πειραιά, Νίκαια',
    value: 2611,
    type: 'default',
  },
  {
    id: 123472,
    label: 'Προάστια Πειραιά, Νίκαια, Χαλκηδόνα',
    value: 123472,
    type: 'default',
  },
  {
    id: 123461,
    label: 'Προάστια Πειραιά, Νίκαια, Άγιος Γεώργιος',
    value: 123461,
    type: 'default',
  },
  {
    id: 123462,
    label: 'Προάστια Πειραιά, Νίκαια, Άγιος Ιωάννης Χρυσόστομος',
    value: 123462,
    type: 'default',
  },
  {
    id: 123463,
    label: 'Προάστια Πειραιά, Νίκαια, Άλσος Βώκου',
    value: 123463,
    type: 'default',
  },
  {
    id: 123464,
    label: 'Προάστια Πειραιά, Νίκαια, Άνω Νεάπολη',
    value: 123464,
    type: 'default',
  },
  {
    id: 123465,
    label: 'Προάστια Πειραιά, Νίκαια, Άσπρα Χώματα',
    value: 123465,
    type: 'default',
  },
  {
    id: 123466,
    label: 'Προάστια Πειραιά, Νίκαια, Γ΄Νεκροταφείο Αθηνών',
    value: 123466,
    type: 'default',
  },
  {
    id: 123467,
    label: 'Προάστια Πειραιά, Νίκαια, Ευαγγελίστρια',
    value: 123467,
    type: 'default',
  },
  {
    id: 123468,
    label: 'Προάστια Πειραιά, Νίκαια, Κατράκειο Θέατρο - Άλσος Δεξαμενής',
    value: 123468,
    type: 'default',
  },
  {
    id: 123469,
    label: 'Προάστια Πειραιά, Νίκαια, Νεκροταφείο',
    value: 123469,
    type: 'default',
  },
  {
    id: 123470,
    label: 'Προάστια Πειραιά, Νίκαια, Νεάπολη',
    value: 123470,
    type: 'default',
  },
  {
    id: 123471,
    label: 'Προάστια Πειραιά, Νίκαια, Μητρόπολη',
    value: 123471,
    type: 'default',
  },
  {
    id: 2612,
    label: 'Προάστια Πειραιά, Πέραμα',
    value: 2612,
    type: 'default',
  },
  {
    id: 106290,
    label: 'Προάστια Πειραιά, Πέραμα, Διυλιστήρια',
    value: 106290,
    type: 'default',
  },
  {
    id: 106346,
    label: 'Προάστια Πειραιά, Πέραμα, Νέο Ικόνιο',
    value: 106346,
    type: 'default',
  },
  {
    id: 106358,
    label: 'Προάστια Πειραιά, Πέραμα, Ναυπηγεία',
    value: 106358,
    type: 'default',
  },
  {
    id: 106404,
    label: 'Προάστια Πειραιά, Πέραμα, Καριώτικα',
    value: 106404,
    type: 'default',
  },
  {
    id: 13000182,
    label: 'Προάστια Πειραιά, Πέραμα, Ψυττάλεια',
    value: 13000182,
    type: 'default',
  },
  {
    id: 103538,
    label: 'Προάστια Πειραιά, Πέραμα, Κέντρο',
    value: 103538,
    type: 'default',
  },
  {
    id: 13000180,
    label: 'Προάστια Πειραιά, Πέραμα, Άνω Πέραμα',
    value: 13000180,
    type: 'default',
  },
  {
    id: 13000181,
    label: 'Προάστια Πειραιά, Πέραμα, Υπόλοιπο Περάματος',
    value: 13000181,
    type: 'default',
  },
  {
    id: 2616,
    label: 'Προάστια Πειραιά, Ταύρος',
    value: 2616,
    type: 'default',
  },
  {
    id: 102616,
    label: 'Προάστια Πειραιά, Ταύρος, Κέντρο',
    value: 102616,
    type: 'default',
  },
  {
    id: 123500,
    label: 'Προάστια Πειραιά, Ταύρος, Πέτρου Ράλλη',
    value: 123500,
    type: 'default',
  },
  {
    id: 123501,
    label: 'Προάστια Πειραιά, Ταύρος, Ρουφ',
    value: 123501,
    type: 'default',
  },
  {
    id: 107,
    label: 'Υπόλοιπο Αττικής',
    value: 107,
    type: 'default',
  },
  {
    id: 2303,
    label: 'Υπόλοιπο Αττικής, Άνω Λιόσια',
    value: 2303,
    type: 'default',
  },
  {
    id: 4626,
    label: 'Υπόλοιπο Αττικής, Άνω Λιόσια, Κέντρο',
    value: 4626,
    type: 'default',
  },
  {
    id: 4627,
    label: 'Υπόλοιπο Αττικής, Άνω Λιόσια, Πανόραμα',
    value: 4627,
    type: 'default',
  },
  {
    id: 4628,
    label: 'Υπόλοιπο Αττικής, Άνω Λιόσια, Άγιος Γεώργιος',
    value: 4628,
    type: 'default',
  },
  {
    id: 4629,
    label: 'Υπόλοιπο Αττικής, Άνω Λιόσια, Άγιος Ιωάννης Θεολόγος',
    value: 4629,
    type: 'default',
  },
  {
    id: 4630,
    label: 'Υπόλοιπο Αττικής, Άνω Λιόσια, Δροσούπολη',
    value: 4630,
    type: 'default',
  },
  {
    id: 4631,
    label: 'Υπόλοιπο Αττικής, Άνω Λιόσια, Λίμνη',
    value: 4631,
    type: 'default',
  },
  {
    id: 4632,
    label: 'Υπόλοιπο Αττικής, Άνω Λιόσια, Άγιος Νικόλαος',
    value: 4632,
    type: 'default',
  },
  {
    id: 4633,
    label: 'Υπόλοιπο Αττικής, Άνω Λιόσια, Πάρκο Πόλης',
    value: 4633,
    type: 'default',
  },
  {
    id: 4634,
    label: 'Υπόλοιπο Αττικής, Άνω Λιόσια, Ζοφριά',
    value: 4634,
    type: 'default',
  },
  {
    id: 13000185,
    label: 'Υπόλοιπο Αττικής, Άνω Λιόσια, Γεννηματάς ΙΙ',
    value: 13000185,
    type: 'default',
  },
  {
    id: 13000186,
    label: 'Υπόλοιπο Αττικής, Άνω Λιόσια, Τσουκλίδι',
    value: 13000186,
    type: 'default',
  },
  {
    id: 2306,
    label: 'Υπόλοιπο Αττικής, Ζεφύρι',
    value: 2306,
    type: 'default',
  },
  {
    id: 499153,
    label: 'Υπόλοιπο Αττικής, Ζεφύρι, Άνω Ζεφύρι',
    value: 499153,
    type: 'default',
  },
  {
    id: 499154,
    label: 'Υπόλοιπο Αττικής, Ζεφύρι, Παναγία Γρηγορούσα',
    value: 499154,
    type: 'default',
  },
  {
    id: 499155,
    label: 'Υπόλοιπο Αττικής, Ζεφύρι, Άγιος Στυλιανός Ζεφυρίου',
    value: 499155,
    type: 'default',
  },
  {
    id: 2406,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο',
    value: 2406,
    type: 'default',
  },
  {
    id: 117577,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο, Κουλιδάς',
    value: 117577,
    type: 'default',
  },
  {
    id: 117578,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο, Αγία Τριάδα',
    value: 117578,
    type: 'default',
  },
  {
    id: 117579,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο, Χαμολιά',
    value: 117579,
    type: 'default',
  },
  {
    id: 117580,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο, Ποριά',
    value: 117580,
    type: 'default',
  },
  {
    id: 123270,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο, Πόρτο Ράφτη',
    value: 123270,
    type: 'default',
  },
  {
    id: 123271,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο, Βραυρώνα',
    value: 123271,
    type: 'default',
  },
  {
    id: 13000223,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο, Υπόλοιπο Μαρκόπουλου',
    value: 13000223,
    type: 'default',
  },
  {
    id: 23406,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο, Κέντρο',
    value: 23406,
    type: 'default',
  },
  {
    id: 13000221,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο, Καλυβέζα',
    value: 13000221,
    type: 'default',
  },
  {
    id: 13000222,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο, Ολυμπιακό Ιππικό Κέντρο',
    value: 13000222,
    type: 'default',
  },
  {
    id: 2410,
    label: 'Υπόλοιπο Αττικής, Πικέρμι',
    value: 2410,
    type: 'default',
  },
  {
    id: 102410,
    label: 'Υπόλοιπο Αττικής, Πικέρμι, Κέντρο',
    value: 102410,
    type: 'default',
  },
  {
    id: 117067,
    label: 'Υπόλοιπο Αττικής, Πικέρμι, Ντράφι',
    value: 117067,
    type: 'default',
  },
  {
    id: 202325,
    label: 'Υπόλοιπο Αττικής, Πικέρμι, Διώνη',
    value: 202325,
    type: 'default',
  },
  {
    id: 2411,
    label: 'Υπόλοιπο Αττικής, Ραφήνα',
    value: 2411,
    type: 'default',
  },
  {
    id: 102411,
    label: 'Υπόλοιπο Αττικής, Ραφήνα, Κέντρο',
    value: 102411,
    type: 'default',
  },
  {
    id: 117062,
    label: 'Υπόλοιπο Αττικής, Ραφήνα, Οικισμός Κόκκινο Λιμανάκι',
    value: 117062,
    type: 'default',
  },
  {
    id: 202326,
    label: 'Υπόλοιπο Αττικής, Ραφήνα, Καλλιτεχνούπολη',
    value: 202326,
    type: 'default',
  },
  {
    id: 13000059,
    label: 'Υπόλοιπο Αττικής, Ραφήνα, Νέος Βουτζάς',
    value: 13000059,
    type: 'default',
  },
  {
    id: 13000070,
    label: 'Υπόλοιπο Αττικής, Ραφήνα, Περιβολάκια',
    value: 13000070,
    type: 'default',
  },
  {
    id: 13000232,
    label: 'Υπόλοιπο Αττικής, Ραφήνα, Περιβόλια',
    value: 13000232,
    type: 'default',
  },
  {
    id: 2701,
    label: 'Υπόλοιπο Αττικής, Άγιος Κωνσταντίνος',
    value: 2701,
    type: 'default',
  },
  {
    id: 499147,
    label: 'Υπόλοιπο Αττικής, Άγιος Κωνσταντίνος, Καμάριζα',
    value: 499147,
    type: 'default',
  },
  {
    id: 499170,
    label: 'Υπόλοιπο Αττικής, Άγιος Κωνσταντίνος, Εσπερίδες',
    value: 499170,
    type: 'default',
  },
  {
    id: 499149,
    label: 'Υπόλοιπο Αττικής, Άγιος Κωνσταντίνος, Εθνικός Δρυμός Σουνίου',
    value: 499149,
    type: 'default',
  },
  {
    id: 499148,
    label: 'Υπόλοιπο Αττικής, Άγιος Κωνσταντίνος, Κέντρο Άγιου Κωνσταντίνου',
    value: 499148,
    type: 'default',
  },
  {
    id: 2703,
    label: 'Υπόλοιπο Αττικής, Ανάβυσσος',
    value: 2703,
    type: 'default',
  },
  {
    id: 117720,
    label: 'Υπόλοιπο Αττικής, Ανάβυσσος, Ανάβυσσος Κέντρο',
    value: 117720,
    type: 'default',
  },
  {
    id: 117721,
    label: 'Υπόλοιπο Αττικής, Ανάβυσσος, Άγιος Νικόλαος',
    value: 117721,
    type: 'default',
  },
  {
    id: 117722,
    label: 'Υπόλοιπο Αττικής, Ανάβυσσος, Μαύρο Λιθάρι',
    value: 117722,
    type: 'default',
  },
  {
    id: 13000183,
    label: 'Υπόλοιπο Αττικής, Ανάβυσσος, Αρσίδα',
    value: 13000183,
    type: 'default',
  },
  {
    id: 13000184,
    label: 'Υπόλοιπο Αττικής, Ανάβυσσος, Λάκκα',
    value: 13000184,
    type: 'default',
  },
  {
    id: 2704,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος',
    value: 2704,
    type: 'default',
  },
  {
    id: 23704,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Κέντρο',
    value: 23704,
    type: 'default',
  },
  {
    id: 115907,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Νέα Ζωή',
    value: 115907,
    type: 'default',
  },
  {
    id: 116047,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Καψαλώνα',
    value: 116047,
    type: 'default',
  },
  {
    id: 116048,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Στεφάνι',
    value: 116048,
    type: 'default',
  },
  {
    id: 116049,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Διυλιστήρια',
    value: 116049,
    type: 'default',
  },
  {
    id: 116050,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Κοκκινιά',
    value: 116050,
    type: 'default',
  },
  {
    id: 116051,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Μυτούλα',
    value: 116051,
    type: 'default',
  },
  {
    id: 116052,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Κουνουπίτσα',
    value: 116052,
    type: 'default',
  },
  {
    id: 116053,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Μαυρηνόρα',
    value: 116053,
    type: 'default',
  },
  {
    id: 116054,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Κάμπος',
    value: 116054,
    type: 'default',
  },
  {
    id: 116055,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Αμμουδιές',
    value: 116055,
    type: 'default',
  },
  {
    id: 116056,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Λάκκες Κυρίλλου',
    value: 116056,
    type: 'default',
  },
  {
    id: 116058,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Μελίσσια',
    value: 116058,
    type: 'default',
  },
  {
    id: 116059,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Πάτημα',
    value: 116059,
    type: 'default',
  },
  {
    id: 116060,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Στρέφη',
    value: 116060,
    type: 'default',
  },
  {
    id: 116061,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Ράχη Γκαμήλας',
    value: 116061,
    type: 'default',
  },
  {
    id: 13000187,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Γκορυτσά',
    value: 13000187,
    type: 'default',
  },
  {
    id: 13000188,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Κάτω Φούσα',
    value: 13000188,
    type: 'default',
  },
  {
    id: 13000189,
    label: 'Υπόλοιπο Αττικής, Ασπρόπυργος, Παραλία - Λαιμός - Λουζιτάνια',
    value: 13000189,
    type: 'default',
  },
  {
    id: 2705,
    label: 'Υπόλοιπο Αττικής, Αυλώνα',
    value: 2705,
    type: 'default',
  },
  {
    id: 499150,
    label: 'Υπόλοιπο Αττικής, Αυλώνα, Κέντρο Αυλώνας',
    value: 499150,
    type: 'default',
  },
  {
    id: 499152,
    label: 'Υπόλοιπο Αττικής, Αυλώνα, Υπόλοιπο Αυλώνας',
    value: 499152,
    type: 'default',
  },
  {
    id: 499151,
    label: 'Υπόλοιπο Αττικής, Αυλώνα, ΚΕΤΘ',
    value: 499151,
    type: 'default',
  },
  {
    id: 2706,
    label: 'Υπόλοιπο Αττικής, Αφίδνες',
    value: 2706,
    type: 'default',
  },
  {
    id: 115521,
    label: 'Υπόλοιπο Αττικής, Αφίδνες, Κοσμοθέα',
    value: 115521,
    type: 'default',
  },
  {
    id: 115523,
    label: 'Υπόλοιπο Αττικής, Αφίδνες, Δροσοπηγή',
    value: 115523,
    type: 'default',
  },
  {
    id: 115524,
    label: 'Υπόλοιπο Αττικής, Αφίδνες, Κοκκινόβραχος',
    value: 115524,
    type: 'default',
  },
  {
    id: 115525,
    label: 'Υπόλοιπο Αττικής, Αφίδνες, Σταθμός Αφιδνών',
    value: 115525,
    type: 'default',
  },
  {
    id: 115526,
    label: 'Υπόλοιπο Αττικής, Αφίδνες, Αγία Τριάδα',
    value: 115526,
    type: 'default',
  },
  {
    id: 270600,
    label: 'Υπόλοιπο Αττικής, Αφίδνες, Κιούρκα',
    value: 270600,
    type: 'default',
  },
  {
    id: 2709,
    label: 'Υπόλοιπο Αττικής, Βίλια',
    value: 2709,
    type: 'default',
  },
  {
    id: 102709,
    label: 'Υπόλοιπο Αττικής, Βίλια, Κέντρο',
    value: 102709,
    type: 'default',
  },
  {
    id: 115915,
    label: 'Υπόλοιπο Αττικής, Βίλια, Ψάθα',
    value: 115915,
    type: 'default',
  },
  {
    id: 115920,
    label: 'Υπόλοιπο Αττικής, Βίλια, Μύτικας',
    value: 115920,
    type: 'default',
  },
  {
    id: 115921,
    label: 'Υπόλοιπο Αττικής, Βίλια, Αγία Παρασκευή',
    value: 115921,
    type: 'default',
  },
  {
    id: 115922,
    label: 'Υπόλοιπο Αττικής, Βίλια, Κρύο Πηγάδι',
    value: 115922,
    type: 'default',
  },
  {
    id: 115926,
    label: 'Υπόλοιπο Αττικής, Βίλια, Άγιος Νεκτάριος',
    value: 115926,
    type: 'default',
  },
  {
    id: 115927,
    label: 'Υπόλοιπο Αττικής, Βίλια, Προφήτης Ηλίας',
    value: 115927,
    type: 'default',
  },
  {
    id: 116315,
    label: 'Υπόλοιπο Αττικής, Βίλια, Αιγειρούσες',
    value: 116315,
    type: 'default',
  },
  {
    id: 116316,
    label: 'Υπόλοιπο Αττικής, Βίλια, Λούμπα',
    value: 116316,
    type: 'default',
  },
  {
    id: 13000192,
    label: 'Υπόλοιπο Αττικής, Βίλια, Βιολέττα',
    value: 13000192,
    type: 'default',
  },
  {
    id: 2702,
    label: 'Υπόλοιπο Αττικής, Βίλια, Άνω Αλεποχώρι',
    value: 2702,
    type: 'default',
  },
  {
    id: 123390,
    label: 'Υπόλοιπο Αττικής, Βίλια, Πόρτο Γερμενό',
    value: 123390,
    type: 'default',
  },
  {
    id: 206702,
    label: 'Υπόλοιπο Αττικής, Βίλια, Κάτω Αλεποχώρι',
    value: 206702,
    type: 'default',
  },
  {
    id: 13000190,
    label: 'Υπόλοιπο Αττικής, Βίλια, Άγιος Κωνσταντίνος',
    value: 13000190,
    type: 'default',
  },
  {
    id: 13000191,
    label: 'Υπόλοιπο Αττικής, Βίλια, Βένιζα',
    value: 13000191,
    type: 'default',
  },
  {
    id: 2712,
    label: 'Υπόλοιπο Αττικής, Ελευσίνα',
    value: 2712,
    type: 'default',
  },
  {
    id: 23712,
    label: 'Υπόλοιπο Αττικής, Ελευσίνα, Κέντρο',
    value: 23712,
    type: 'default',
  },
  {
    id: 2713,
    label: 'Υπόλοιπο Αττικής, Ερυθρές',
    value: 2713,
    type: 'default',
  },
  {
    id: 102713,
    label: 'Υπόλοιπο Αττικής, Ερυθρές, Κέντρο Ερυθρών',
    value: 102713,
    type: 'default',
  },
  {
    id: 499174,
    label: 'Υπόλοιπο Αττικής, Ερυθρές, Κιάφα',
    value: 499174,
    type: 'default',
  },
  {
    id: 499175,
    label: 'Υπόλοιπο Αττικής, Ερυθρές, Καρούμπαλο',
    value: 499175,
    type: 'default',
  },
  {
    id: 2715,
    label: 'Υπόλοιπο Αττικής, Κάλαμος',
    value: 2715,
    type: 'default',
  },
  {
    id: 13000196,
    label: 'Υπόλοιπο Αττικής, Κάλαμος, Υπόλοιπο Κάλαμου',
    value: 13000196,
    type: 'default',
  },
  {
    id: 123372,
    label: 'Υπόλοιπο Αττικής, Κάλαμος, Λιμνιώνας',
    value: 123372,
    type: 'default',
  },
  {
    id: 123373,
    label: 'Υπόλοιπο Αττικής, Κάλαμος, Βλαστός',
    value: 123373,
    type: 'default',
  },
  {
    id: 123374,
    label: 'Υπόλοιπο Αττικής, Κάλαμος, Πράσινος Λόφος',
    value: 123374,
    type: 'default',
  },
  {
    id: 123375,
    label: 'Υπόλοιπο Αττικής, Κάλαμος, Κοιλάδα',
    value: 123375,
    type: 'default',
  },
  {
    id: 123376,
    label: 'Υπόλοιπο Αττικής, Κάλαμος, Μετέωρα',
    value: 123376,
    type: 'default',
  },
  {
    id: 13000193,
    label: 'Υπόλοιπο Αττικής, Κάλαμος, Αγία Βαρβάρα',
    value: 13000193,
    type: 'default',
  },
  {
    id: 13000194,
    label: 'Υπόλοιπο Αττικής, Κάλαμος, Κυψέλη - Ποσειδωνία',
    value: 13000194,
    type: 'default',
  },
  {
    id: 13000195,
    label: 'Υπόλοιπο Αττικής, Κάλαμος, Πανόραμα',
    value: 13000195,
    type: 'default',
  },
  {
    id: 123370,
    label: 'Υπόλοιπο Αττικής, Κάλαμος, Κέντρο',
    value: 123370,
    type: 'default',
  },
  {
    id: 123371,
    label: 'Υπόλοιπο Αττικής, Κάλαμος, Άγιοι Απόστολοι',
    value: 123371,
    type: 'default',
  },
  {
    id: 2716,
    label: 'Υπόλοιπο Αττικής, Καλύβια Θορικού',
    value: 2716,
    type: 'default',
  },
  {
    id: 2722,
    label: 'Υπόλοιπο Αττικής, Καλύβια Θορικού, Λαγονήσι',
    value: 2722,
    type: 'default',
  },
  {
    id: 123250,
    label: 'Υπόλοιπο Αττικής, Καλύβια Θορικού, Κέντρο',
    value: 123250,
    type: 'default',
  },
  {
    id: 2717,
    label: 'Υπόλοιπο Αττικής, Κ. Καπανδριτίου',
    value: 2717,
    type: 'default',
  },
  {
    id: 102717,
    label: 'Υπόλοιπο Αττικής, Κ. Καπανδριτίου, Καπανδρίτι',
    value: 102717,
    type: 'default',
  },
  {
    id: 115527,
    label: 'Υπόλοιπο Αττικής, Κ. Καπανδριτίου, Μικροχώρι',
    value: 115527,
    type: 'default',
  },
  {
    id: 115530,
    label: 'Υπόλοιπο Αττικής, Κ. Καπανδριτίου, Άγιοι Ανάργυροι',
    value: 115530,
    type: 'default',
  },
  {
    id: 2719,
    label: 'Υπόλοιπο Αττικής, Κερατέα',
    value: 2719,
    type: 'default',
  },
  {
    id: 102719,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Κέντρο',
    value: 102719,
    type: 'default',
  },
  {
    id: 118142,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Πόρτο Εννιά',
    value: 118142,
    type: 'default',
  },
  {
    id: 118143,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Πεύκα',
    value: 118143,
    type: 'default',
  },
  {
    id: 118144,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Μαρκάτι',
    value: 118144,
    type: 'default',
  },
  {
    id: 118145,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Πανόραμα Μικρολίμανου',
    value: 118145,
    type: 'default',
  },
  {
    id: 118146,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Σάκκα',
    value: 118146,
    type: 'default',
  },
  {
    id: 118148,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Διψέλιζα',
    value: 118148,
    type: 'default',
  },
  {
    id: 118150,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Μύλος',
    value: 118150,
    type: 'default',
  },
  {
    id: 118151,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Αρί',
    value: 118151,
    type: 'default',
  },
  {
    id: 118152,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Μανούτσο',
    value: 118152,
    type: 'default',
  },
  {
    id: 118154,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Βένιο Δασκαλειού',
    value: 118154,
    type: 'default',
  },
  {
    id: 118155,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Χάρβαλο',
    value: 118155,
    type: 'default',
  },
  {
    id: 118156,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Ριμπάρι',
    value: 118156,
    type: 'default',
  },
  {
    id: 118157,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Ρουντζέρι Λεμπρού',
    value: 118157,
    type: 'default',
  },
  {
    id: 118160,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Δημολάκι',
    value: 118160,
    type: 'default',
  },
  {
    id: 118161,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Μητροπήσι',
    value: 118161,
    type: 'default',
  },
  {
    id: 118163,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Συρί',
    value: 118163,
    type: 'default',
  },
  {
    id: 118170,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Τριανταφυλλιά',
    value: 118170,
    type: 'default',
  },
  {
    id: 118175,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Χάρακας',
    value: 118175,
    type: 'default',
  },
  {
    id: 118177,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Συντερίνα',
    value: 118177,
    type: 'default',
  },
  {
    id: 118180,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Άγιος Γεώργιος Θορικού',
    value: 118180,
    type: 'default',
  },
  {
    id: 118182,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Παλιοκαμάριζα',
    value: 118182,
    type: 'default',
  },
  {
    id: 118183,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Μικρολίμανο',
    value: 118183,
    type: 'default',
  },
  {
    id: 118184,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Πλάκα',
    value: 118184,
    type: 'default',
  },
  {
    id: 118185,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Ελαιοχώρι',
    value: 118185,
    type: 'default',
  },
  {
    id: 118192,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Παραλία Δασκαλειού',
    value: 118192,
    type: 'default',
  },
  {
    id: 118195,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Διόνυσος',
    value: 118195,
    type: 'default',
  },
  {
    id: 118196,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Κακιά Θάλασσα',
    value: 118196,
    type: 'default',
  },
  {
    id: 13000199,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Άγιος Γεώργιος',
    value: 13000199,
    type: 'default',
  },
  {
    id: 13000200,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Αυρόκαστρο',
    value: 13000200,
    type: 'default',
  },
  {
    id: 13000201,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Δασκαλειό - Μαρίστρα',
    value: 13000201,
    type: 'default',
  },
  {
    id: 13000202,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Δροσιά',
    value: 13000202,
    type: 'default',
  },
  {
    id: 13000203,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Ζαπάνι',
    value: 13000203,
    type: 'default',
  },
  {
    id: 13000204,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Κόντρα Βιλαρά',
    value: 13000204,
    type: 'default',
  },
  {
    id: 13000205,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Μεγάλα Πέυκα',
    value: 13000205,
    type: 'default',
  },
  {
    id: 13000206,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Μετόχι',
    value: 13000206,
    type: 'default',
  },
  {
    id: 13000207,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Μυρτέζα - Μπούρτζες',
    value: 13000207,
    type: 'default',
  },
  {
    id: 13000208,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Πρισιλίμες',
    value: 13000208,
    type: 'default',
  },
  {
    id: 13000209,
    label: 'Υπόλοιπο Αττικής, Κερατέα, Τρεχαντιέρα - Σπηλιαζέζα - Καλοπήγαδο',
    value: 13000209,
    type: 'default',
  },
  {
    id: 2721,
    label: 'Υπόλοιπο Αττικής, Κουβαράς',
    value: 2721,
    type: 'default',
  },
  {
    id: 117725,
    label: 'Υπόλοιπο Αττικής, Κουβαράς, Νέος Κουβαράς',
    value: 117725,
    type: 'default',
  },
  {
    id: 117726,
    label: 'Υπόλοιπο Αττικής, Κουβαράς, Μονή Μεταμόρφωσης Σωτήρα',
    value: 117726,
    type: 'default',
  },
  {
    id: 13000210,
    label: 'Υπόλοιπο Αττικής, Κουβαράς, Κέντρο',
    value: 13000210,
    type: 'default',
  },
  {
    id: 2723,
    label: 'Υπόλοιπο Αττικής, Λαύριο',
    value: 2723,
    type: 'default',
  },
  {
    id: 102723,
    label: 'Υπόλοιπο Αττικής, Λαύριο, Κέντρο',
    value: 102723,
    type: 'default',
  },
  {
    id: 118173,
    label: 'Υπόλοιπο Αττικής, Λαύριο, Άσπρο Λιθάρι',
    value: 118173,
    type: 'default',
  },
  {
    id: 118176,
    label: 'Υπόλοιπο Αττικής, Λαύριο, Κάτω Ποσειδωνία',
    value: 118176,
    type: 'default',
  },
  {
    id: 118178,
    label: 'Υπόλοιπο Αττικής, Λαύριο, Άνω Θορικό',
    value: 118178,
    type: 'default',
  },
  {
    id: 118179,
    label: 'Υπόλοιπο Αττικής, Λαύριο, Θορικό',
    value: 118179,
    type: 'default',
  },
  {
    id: 206742,
    label: 'Υπόλοιπο Αττικής, Λαύριο, Κάτω Σούνιο',
    value: 206742,
    type: 'default',
  },
  {
    id: 13000211,
    label: 'Υπόλοιπο Αττικής, Λαύριο, Άγιος Γεράσιμος',
    value: 13000211,
    type: 'default',
  },
  {
    id: 13000212,
    label: 'Υπόλοιπο Αττικής, Λαύριο, Εργατικές Κατοικίες',
    value: 13000212,
    type: 'default',
  },
  {
    id: 13000213,
    label: 'Υπόλοιπο Αττικής, Λαύριο, Κυπριανός',
    value: 13000213,
    type: 'default',
  },
  {
    id: 13000214,
    label: 'Υπόλοιπο Αττικής, Λαύριο, Νεάπολη - Θηραϊκά',
    value: 13000214,
    type: 'default',
  },
  {
    id: 13000215,
    label: 'Υπόλοιπο Αττικής, Λαύριο, Νυχτοχώρι - Αγία Παρασκευή',
    value: 13000215,
    type: 'default',
  },
  {
    id: 13000216,
    label: 'Υπόλοιπο Αττικής, Λαύριο, Πάνορμος',
    value: 13000216,
    type: 'default',
  },
  {
    id: 13000217,
    label: 'Υπόλοιπο Αττικής, Λαύριο, Πέρδικα',
    value: 13000217,
    type: 'default',
  },
  {
    id: 2724,
    label: 'Υπόλοιπο Αττικής, Μαγούλα',
    value: 2724,
    type: 'default',
  },
  {
    id: 116196,
    label: 'Υπόλοιπο Αττικής, Μαγούλα, Νέος Πόντος',
    value: 116196,
    type: 'default',
  },
  {
    id: 499159,
    label: 'Υπόλοιπο Αττικής, Μαγούλα, Κέντρο Μαγούλας',
    value: 499159,
    type: 'default',
  },
  {
    id: 499158,
    label: 'Υπόλοιπο Αττικής, Μαγούλα, Εμπορική και Βιομηχανική περιοχή Μαγούλας',
    value: 499158,
    type: 'default',
  },
  {
    id: 2725,
    label: 'Υπόλοιπο Αττικής, Κ. Μαλακάσας',
    value: 2725,
    type: 'default',
  },
  {
    id: 102725,
    label: 'Υπόλοιπο Αττικής, Κ. Μαλακάσας, Μαλακάσα',
    value: 102725,
    type: 'default',
  },
  {
    id: 115528,
    label: 'Υπόλοιπο Αττικής, Κ. Μαλακάσας, Σφενδάλη',
    value: 115528,
    type: 'default',
  },
  {
    id: 115533,
    label: 'Υπόλοιπο Αττικής, Κ. Μαλακάσας, Μίλεσι',
    value: 115533,
    type: 'default',
  },
  {
    id: 2727,
    label: 'Υπόλοιπο Αττικής, Μάνδρα',
    value: 2727,
    type: 'default',
  },
  {
    id: 13000220,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Πολυκατοικίες',
    value: 13000220,
    type: 'default',
  },
  {
    id: 102727,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Κέντρο',
    value: 102727,
    type: 'default',
  },
  {
    id: 115917,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Παλαιοχώρι',
    value: 115917,
    type: 'default',
  },
  {
    id: 115918,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Άγιος Γεώργιος',
    value: 115918,
    type: 'default',
  },
  {
    id: 115919,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Θέα',
    value: 115919,
    type: 'default',
  },
  {
    id: 115924,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Πουρνάρι',
    value: 115924,
    type: 'default',
  },
  {
    id: 115928,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Λεύκα',
    value: 115928,
    type: 'default',
  },
  {
    id: 115929,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Μονή Οσίου Μελετίου',
    value: 115929,
    type: 'default',
  },
  {
    id: 13000218,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Βιομηχανική Περιοχή',
    value: 13000218,
    type: 'default',
  },
  {
    id: 13000219,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Παπακώστα',
    value: 13000219,
    type: 'default',
  },
  {
    id: 115904,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Πανόραμα',
    value: 115904,
    type: 'default',
  },
  {
    id: 115905,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Λούτσα',
    value: 115905,
    type: 'default',
  },
  {
    id: 115906,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Διόδια',
    value: 115906,
    type: 'default',
  },
  {
    id: 115912,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Άγιος Χαράλαμπος',
    value: 115912,
    type: 'default',
  },
  {
    id: 115913,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Παλιοκούντουρα',
    value: 115913,
    type: 'default',
  },
  {
    id: 115914,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Άγιος Σωτήρας',
    value: 115914,
    type: 'default',
  },
  {
    id: 115916,
    label: 'Υπόλοιπο Αττικής, Μάνδρα, Άγιος Παντελεήμων',
    value: 115916,
    type: 'default',
  },
  {
    id: 2728,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο Ωρωπού',
    value: 2728,
    type: 'default',
  },
  {
    id: 499160,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο Ωρωπού, Παραλία Μαρκόπουλου Ωροπού',
    value: 499160,
    type: 'default',
  },
  {
    id: 499161,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο Ωρωπού, Κέντρο Μαρκόπουλου Ωροπού',
    value: 499161,
    type: 'default',
  },
  {
    id: 499162,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο Ωρωπού, Νέο Λιβίσι',
    value: 499162,
    type: 'default',
  },
  {
    id: 499163,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο Ωρωπού, Αγία Βαρβάρα',
    value: 499163,
    type: 'default',
  },
  {
    id: 499164,
    label: 'Υπόλοιπο Αττικής, Μαρκόπουλο Ωρωπού, Μπάφι',
    value: 499164,
    type: 'default',
  },
  {
    id: 2730,
    label: 'Υπόλοιπο Αττικής, Μέγαρα',
    value: 2730,
    type: 'default',
  },
  {
    id: 102730,
    label: 'Υπόλοιπο Αττικής, Μέγαρα, Κέντρο',
    value: 102730,
    type: 'default',
  },
  {
    id: 116306,
    label: 'Υπόλοιπο Αττικής, Μέγαρα, Πάχη',
    value: 116306,
    type: 'default',
  },
  {
    id: 206720,
    label: 'Υπόλοιπο Αττικής, Μέγαρα, Κινέτα',
    value: 206720,
    type: 'default',
  },
  {
    id: 13000224,
    label: 'Υπόλοιπο Αττικής, Μέγαρα, Αγία Τριάδα',
    value: 13000224,
    type: 'default',
  },
  {
    id: 13000225,
    label: 'Υπόλοιπο Αττικής, Μέγαρα, Κουμιντρί',
    value: 13000225,
    type: 'default',
  },
  {
    id: 13000226,
    label: 'Υπόλοιπο Αττικής, Μέγαρα, Λάκκα Καλογήρου',
    value: 13000226,
    type: 'default',
  },
  {
    id: 13000227,
    label: 'Υπόλοιπο Αττικής, Μέγαρα, Σπάρτα',
    value: 13000227,
    type: 'default',
  },
  {
    id: 13000228,
    label: 'Υπόλοιπο Αττικής, Μέγαρα, Στίκας',
    value: 13000228,
    type: 'default',
  },
  {
    id: 2732,
    label: 'Υπόλοιπο Αττικής, Νέα Πέραμος (Μεγάλο Πεύκο)',
    value: 2732,
    type: 'default',
  },
  {
    id: 102732,
    label: 'Υπόλοιπο Αττικής, Νέα Πέραμος (Μεγάλο Πεύκο), Νέα Πέραμος',
    value: 102732,
    type: 'default',
  },
  {
    id: 116313,
    label: 'Υπόλοιπο Αττικής, Νέα Πέραμος (Μεγάλο Πεύκο), Βλυχάδα',
    value: 116313,
    type: 'default',
  },
  {
    id: 123380,
    label: 'Υπόλοιπο Αττικής, Νέα Πέραμος (Μεγάλο Πεύκο), Νεράκι',
    value: 123380,
    type: 'default',
  },
  {
    id: 123381,
    label: 'Υπόλοιπο Αττικής, Νέα Πέραμος (Μεγάλο Πεύκο), Λουτρόπυργος',
    value: 123381,
    type: 'default',
  },
  {
    id: 2733,
    label: 'Υπόλοιπο Αττικής, Κ. Νέων Παλατίων',
    value: 2733,
    type: 'default',
  },
  {
    id: 102733,
    label: 'Υπόλοιπο Αττικής, Κ. Νέων Παλατίων, Νέα Παλάτια',
    value: 102733,
    type: 'default',
  },
  {
    id: 2734,
    label: 'Υπόλοιπο Αττικής, Οινόη',
    value: 2734,
    type: 'default',
  },
  {
    id: 102734,
    label: 'Υπόλοιπο Αττικής, Οινόη, Κέντρο Οινόης',
    value: 102734,
    type: 'default',
  },
  {
    id: 499176,
    label: 'Υπόλοιπο Αττικής, Οινόη, Υπόλοιπο Οινόης',
    value: 499176,
    type: 'default',
  },
  {
    id: 2735,
    label: 'Υπόλοιπο Αττικής, Παλαιά Φώκαια',
    value: 2735,
    type: 'default',
  },
  {
    id: 123260,
    label: 'Υπόλοιπο Αττικής, Παλαιά Φώκαια, Κέντρο',
    value: 123260,
    type: 'default',
  },
  {
    id: 123261,
    label: 'Υπόλοιπο Αττικής, Παλαιά Φώκαια, Θυμάρι',
    value: 123261,
    type: 'default',
  },
  {
    id: 123262,
    label: 'Υπόλοιπο Αττικής, Παλαιά Φώκαια, Οικισμός Αίολος',
    value: 123262,
    type: 'default',
  },
  {
    id: 2736,
    label: 'Υπόλοιπο Αττικής, Πολυδένδρι',
    value: 2736,
    type: 'default',
  },
  {
    id: 13000231,
    label: 'Υπόλοιπο Αττικής, Πολυδένδρι, Ταξιάρχες',
    value: 13000231,
    type: 'default',
  },
  {
    id: 499166,
    label: 'Υπόλοιπο Αττικής, Πολυδένδρι, Υπόλοιπο Πολυδένδρι',
    value: 499166,
    type: 'default',
  },
  {
    id: 13000229,
    label: 'Υπόλοιπο Αττικής, Πολυδένδρι, Άγιος Γεώργιος',
    value: 13000229,
    type: 'default',
  },
  {
    id: 13000230,
    label: 'Υπόλοιπο Αττικής, Πολυδένδρι, Ηρακλειδείς',
    value: 13000230,
    type: 'default',
  },
  {
    id: 499165,
    label: 'Υπόλοιπο Αττικής, Πολυδένδρι, Κέντρο Πολυδενδρίου',
    value: 499165,
    type: 'default',
  },
  {
    id: 2739,
    label: 'Υπόλοιπο Αττικής, Σαρωνίδα',
    value: 2739,
    type: 'default',
  },
  {
    id: 499167,
    label: 'Υπόλοιπο Αττικής, Σαρωνίδα, Κέντρο Σαρωνίδας - παραλία',
    value: 499167,
    type: 'default',
  },
  {
    id: 499168,
    label: 'Υπόλοιπο Αττικής, Σαρωνίδα, Υπόλοιπο Σαρωνίδας',
    value: 499168,
    type: 'default',
  },
  {
    id: 13000233,
    label: 'Υπόλοιπο Αττικής, Σαρωνίδα, Πανόραμα Σαρωνίδας',
    value: 13000233,
    type: 'default',
  },
  {
    id: 2740,
    label: 'Υπόλοιπο Αττικής, Κ. Σκάλας Ωρωπού',
    value: 2740,
    type: 'default',
  },
  {
    id: 102740,
    label: 'Υπόλοιπο Αττικής, Κ. Σκάλας Ωρωπού, Σκάλα Ωρωπού',
    value: 102740,
    type: 'default',
  },
  {
    id: 115537,
    label: 'Υπόλοιπο Αττικής, Κ. Σκάλας Ωρωπού, Νέα Πολιτεία',
    value: 115537,
    type: 'default',
  },
  {
    id: 115546,
    label: 'Υπόλοιπο Αττικής, Κ. Σκάλας Ωρωπού, Άγιος Κωνσταντίνος',
    value: 115546,
    type: 'default',
  },
  {
    id: 115547,
    label: 'Υπόλοιπο Αττικής, Κ. Σκάλας Ωρωπού, Χαλκούτσι',
    value: 115547,
    type: 'default',
  },
  {
    id: 2742,
    label: 'Υπόλοιπο Αττικής, Σούνιο',
    value: 2742,
    type: 'default',
  },
  {
    id: 499169,
    label: 'Υπόλοιπο Αττικής, Σούνιο, Κάτω Σούνιο',
    value: 499169,
    type: 'default',
  },
  {
    id: 2743,
    label: 'Υπόλοιπο Αττικής, Συκάμινο',
    value: 2743,
    type: 'default',
  },
  {
    id: 115538,
    label: 'Υπόλοιπο Αττικής, Συκάμινο, Κατηφόρι',
    value: 115538,
    type: 'default',
  },
  {
    id: 115543,
    label: 'Υπόλοιπο Αττικής, Συκάμινο, Άγιος Αθανάσιος',
    value: 115543,
    type: 'default',
  },
  {
    id: 499171,
    label: 'Υπόλοιπο Αττικής, Συκάμινο, Πευκιάς',
    value: 499171,
    type: 'default',
  },
  {
    id: 499172,
    label: 'Υπόλοιπο Αττικής, Συκάμινο, Αγία Αικατερίνη',
    value: 499172,
    type: 'default',
  },
  {
    id: 499173,
    label: 'Υπόλοιπο Αττικής, Συκάμινο, Κέντρο Συκάμινου',
    value: 499173,
    type: 'default',
  },
  {
    id: 2745,
    label: 'Υπόλοιπο Αττικής, Φυλή',
    value: 2745,
    type: 'default',
  },
  {
    id: 102745,
    label: 'Υπόλοιπο Αττικής, Φυλή, Κέντρο',
    value: 102745,
    type: 'default',
  },
  {
    id: 116190,
    label: 'Υπόλοιπο Αττικής, Φυλή, Μουζάκα',
    value: 116190,
    type: 'default',
  },
  {
    id: 116191,
    label: 'Υπόλοιπο Αττικής, Φυλή, Μασούρη',
    value: 116191,
    type: 'default',
  },
  {
    id: 116192,
    label: 'Υπόλοιπο Αττικής, Φυλή, Ζωφριά',
    value: 116192,
    type: 'default',
  },
  {
    id: 116193,
    label: 'Υπόλοιπο Αττικής, Φυλή, Πυργάρι',
    value: 116193,
    type: 'default',
  },
  {
    id: 116194,
    label: 'Υπόλοιπο Αττικής, Φυλή, Σκαλιστήρι',
    value: 116194,
    type: 'default',
  },
  {
    id: 116195,
    label: 'Υπόλοιπο Αττικής, Φυλή, Μονή Κοιμήσεως Θεοτόκου Κλειστών',
    value: 116195,
    type: 'default',
  },
  {
    id: 2747,
    label: 'Υπόλοιπο Αττικής, Ωρωπός',
    value: 2747,
    type: 'default',
  },
  {
    id: 102706,
    label: 'Υπόλοιπο Αττικής, Ωρωπός, Κέντρο',
    value: 102706,
    type: 'default',
  },
  {
    id: 115540,
    label: 'Υπόλοιπο Αττικής, Ωρωπός, Νέο Συκάμινο',
    value: 115540,
    type: 'default',
  },
  {
    id: 115541,
    label: 'Υπόλοιπο Αττικής, Ωρωπός, Αγία Αικατερίνη',
    value: 115541,
    type: 'default',
  },
  {
    id: 115542,
    label: 'Υπόλοιπο Αττικής, Ωρωπός, Κάμπος Ωρωπού',
    value: 115542,
    type: 'default',
  },
  {
    id: 115544,
    label: 'Υπόλοιπο Αττικής, Ωρωπός, Καμάρι',
    value: 115544,
    type: 'default',
  },
  {
    id: 115545,
    label: 'Υπόλοιπο Αττικής, Ωρωπός, Πλατάνια Ωρωπού',
    value: 115545,
    type: 'default',
  },
  {
    id: 13000234,
    label: 'Υπόλοιπο Αττικής, Ωρωπός, Αγία Παρασκευή',
    value: 13000234,
    type: 'default',
  },
  {
    id: 13000235,
    label: 'Υπόλοιπο Αττικής, Ωρωπός, Βαρικό',
    value: 13000235,
    type: 'default',
  },
  {
    id: 118174,
    label: 'Υπόλοιπο Αττικής, Λεγρενά',
    value: 118174,
    type: 'default',
  },
  {
    id: 499156,
    label: 'Υπόλοιπο Αττικής, Λεγρενά, Λεγρενά - παραλιακά',
    value: 499156,
    type: 'default',
  },
  {
    id: 499157,
    label: 'Υπόλοιπο Αττικής, Λεγρενά, Κέντρο Λεγρενών',
    value: 499157,
    type: 'default',
  },
  {
    id: 100,
    label: 'Κέντρο Αθήνας',
    value: 100,
    type: 'default',
  },
  {
    id: 2011,
    label: 'Κέντρο Αθήνας, Γουδή',
    value: 2011,
    type: 'default',
  },
  {
    id: 6110,
    label: 'Κέντρο Αθήνας, Γουδή, Νοσοκομείο Παίδων',
    value: 6110,
    type: 'default',
  },
  {
    id: 6122,
    label: 'Κέντρο Αθήνας, Γουδή, Ιατρική Σχολή',
    value: 6122,
    type: 'default',
  },
  {
    id: 6124,
    label: 'Κέντρο Αθήνας, Γουδή, Άγιος Θωμάς',
    value: 6124,
    type: 'default',
  },
  {
    id: 6123,
    label: 'Κέντρο Αθήνας, Γουδή, Άλσος',
    value: 6123,
    type: 'default',
  },
  {
    id: 13000131,
    label: 'Κέντρο Αθήνας, Γουδή, Ιπποκράτειο',
    value: 13000131,
    type: 'default',
  },
  {
    id: 2015,
    label: 'Κέντρο Αθήνας, Ιλίσια',
    value: 2015,
    type: 'default',
  },
  {
    id: 2055,
    label: 'Κέντρο Αθήνας, Ιλίσια, Hilton',
    value: 2055,
    type: 'default',
  },
  {
    id: 6111,
    label: 'Κέντρο Αθήνας, Ιλίσια, Κάτω Ιλίσια',
    value: 6111,
    type: 'default',
  },
  {
    id: 2022,
    label: 'Κέντρο Αθήνας, Κυψέλη',
    value: 2022,
    type: 'default',
  },
  {
    id: 13000132,
    label: 'Κέντρο Αθήνας, Κυψέλη, Άγιος Γεώργιος',
    value: 13000132,
    type: 'default',
  },
  {
    id: 6116,
    label: 'Κέντρο Αθήνας, Κυψέλη, Φωκίωνος Νέγρη',
    value: 6116,
    type: 'default',
  },
  {
    id: 6117,
    label: 'Κέντρο Αθήνας, Κυψέλη, Πλατεία Κυψέλης',
    value: 6117,
    type: 'default',
  },
  {
    id: 6118,
    label: 'Κέντρο Αθήνας, Κυψέλη, Νέα Κυψέλη',
    value: 6118,
    type: 'default',
  },
  {
    id: 6119,
    label: 'Κέντρο Αθήνας, Κυψέλη, Άνω Κυψέλη - Ευελπίδων',
    value: 6119,
    type: 'default',
  },
  {
    id: 2025,
    label: 'Κέντρο Αθήνας, Λεωφ. Πατησίων - Λεωφ. Αχαρνών',
    value: 2025,
    type: 'default',
  },
  {
    id: 2003,
    label: 'Κέντρο Αθήνας, Λεωφ. Πατησίων - Λεωφ. Αχαρνών, Άγιος Παντελεήμονας',
    value: 2003,
    type: 'default',
  },
  {
    id: 2023,
    label: 'Κέντρο Αθήνας, Λεωφ. Πατησίων - Λεωφ. Αχαρνών, Κάτω Πατήσια',
    value: 2023,
    type: 'default',
  },
  {
    id: 2002,
    label: 'Κέντρο Αθήνας, Λεωφ. Πατησίων - Λεωφ. Αχαρνών, Άγιος Νικόλαος',
    value: 2002,
    type: 'default',
  },
  {
    id: 2040,
    label: 'Κέντρο Αθήνας, Λεωφ. Πατησίων - Λεωφ. Αχαρνών, Πλατεία Αμερικής',
    value: 2040,
    type: 'default',
  },
  {
    id: 2043,
    label: 'Κέντρο Αθήνας, Λεωφ. Πατησίων - Λεωφ. Αχαρνών, Αγ. Μελετίου - Πλ. Βικτωρίας - Μάρνη',
    value: 2043,
    type: 'default',
  },
  {
    id: 6126,
    label: 'Κέντρο Αθήνας, Λεωφ. Πατησίων - Λεωφ. Αχαρνών, Τρεις Γέφυρες',
    value: 6126,
    type: 'default',
  },
  {
    id: 2033,
    label: 'Κέντρο Αθήνας, Νέος Κόσμος',
    value: 2033,
    type: 'default',
  },
  {
    id: 5144,
    label: 'Κέντρο Αθήνας, Νέος Κόσμος, Κέντρο',
    value: 5144,
    type: 'default',
  },
  {
    id: 5145,
    label: 'Κέντρο Αθήνας, Νέος Κόσμος, Άγιος Σώστης',
    value: 5145,
    type: 'default',
  },
  {
    id: 5147,
    label: 'Κέντρο Αθήνας, Νέος Κόσμος, Κυνοσάργους',
    value: 5147,
    type: 'default',
  },
  {
    id: 5146,
    label: 'Κέντρο Αθήνας, Νέος Κόσμος, Άγιος Ιωάννης',
    value: 5146,
    type: 'default',
  },
  {
    id: 2036,
    label: 'Κέντρο Αθήνας, Πατήσια',
    value: 2036,
    type: 'default',
  },
  {
    id: 2046,
    label: 'Κέντρο Αθήνας, Πατήσια, Πλατεία Κολιάτσου',
    value: 2046,
    type: 'default',
  },
  {
    id: 5148,
    label: 'Κέντρο Αθήνας, Πατήσια, Όσιος Λουκάς',
    value: 5148,
    type: 'default',
  },
  {
    id: 6120,
    label: 'Κέντρο Αθήνας, Πατήσια, Γκράβα',
    value: 6120,
    type: 'default',
  },
  {
    id: 2038,
    label: 'Κέντρο Αθήνας, Πετράλωνα',
    value: 2038,
    type: 'default',
  },
  {
    id: 5149,
    label: 'Κέντρο Αθήνας, Πετράλωνα, Κάτω Πετράλωνα',
    value: 5149,
    type: 'default',
  },
  {
    id: 5150,
    label: 'Κέντρο Αθήνας, Πετράλωνα, Άνω Πετράλωνα',
    value: 5150,
    type: 'default',
  },
  {
    id: 2099,
    label: 'Κέντρο Αθήνας, Κέντρο',
    value: 2099,
    type: 'default',
  },
  {
    id: 2045,
    label: 'Κέντρο Αθήνας, Κέντρο, Πλατεία Κλαυθμώνος',
    value: 2045,
    type: 'default',
  },
  {
    id: 2004,
    label: 'Κέντρο Αθήνας, Κέντρο, Ακαδημία',
    value: 2004,
    type: 'default',
  },
  {
    id: 2034,
    label: 'Κέντρο Αθήνας, Κέντρο, Ομόνοια',
    value: 2034,
    type: 'default',
  },
  {
    id: 2042,
    label: 'Κέντρο Αθήνας, Κέντρο, Πλατεία Βάθης',
    value: 2042,
    type: 'default',
  },
  {
    id: 2044,
    label: 'Κέντρο Αθήνας, Κέντρο, Πλατεία Κάνιγγος',
    value: 2044,
    type: 'default',
  },
  {
    id: 2053,
    label: 'Κέντρο Αθήνας, Κέντρο, Σύνταγμα',
    value: 2053,
    type: 'default',
  },
  {
    id: 2056,
    label: 'Κέντρο Αθήνας, Κέντρο, Ψυρρή',
    value: 2056,
    type: 'default',
  },
  {
    id: 6125,
    label: 'Κέντρο Αθήνας, Κέντρο, Ζάππειο',
    value: 6125,
    type: 'default',
  },
  {
    id: 6115,
    label: 'Κέντρο Αθήνας, Κέντρο, Παλιά Βουλή',
    value: 6115,
    type: 'default',
  },
  {
    id: 6114,
    label: 'Κέντρο Αθήνας, Κέντρο, Πλατεία Καρύτση',
    value: 6114,
    type: 'default',
  },
  {
    id: 6113,
    label: 'Κέντρο Αθήνας, Κέντρο, Πλατεία Κουμουνδούρου',
    value: 6113,
    type: 'default',
  },
  {
    id: 6001,
    label: 'Κέντρο Αθήνας, Άγιος Ελευθέριος - Προμπονά - Ριζούπολη',
    value: 6001,
    type: 'default',
  },
  {
    id: 2001,
    label: 'Κέντρο Αθήνας, Άγιος Ελευθέριος - Προμπονά - Ριζούπολη, Άγιος Ελευθέριος',
    value: 2001,
    type: 'default',
  },
  {
    id: 2049,
    label: 'Κέντρο Αθήνας, Άγιος Ελευθέριος - Προμπονά - Ριζούπολη, Ριζούπολη',
    value: 2049,
    type: 'default',
  },
  {
    id: 6101,
    label: 'Κέντρο Αθήνας, Άγιος Ελευθέριος - Προμπονά - Ριζούπολη, Προμπονά',
    value: 6101,
    type: 'default',
  },
  {
    id: 6002,
    label: 'Κέντρο Αθήνας, Αμπελόκηποι - Πεντάγωνο',
    value: 6002,
    type: 'default',
  },
  {
    id: 2012,
    label: 'Κέντρο Αθήνας, Αμπελόκηποι - Πεντάγωνο, Ελληνορώσων',
    value: 2012,
    type: 'default',
  },
  {
    id: 2047,
    label: 'Κέντρο Αθήνας, Αμπελόκηποι - Πεντάγωνο, Πλατεία Μαβίλη',
    value: 2047,
    type: 'default',
  },
  {
    id: 6102,
    label: 'Κέντρο Αθήνας, Αμπελόκηποι - Πεντάγωνο, Σούτσου',
    value: 6102,
    type: 'default',
  },
  {
    id: 6103,
    label: 'Κέντρο Αθήνας, Αμπελόκηποι - Πεντάγωνο, Πύργος Αθηνών',
    value: 6103,
    type: 'default',
  },
  {
    id: 6104,
    label: 'Κέντρο Αθήνας, Αμπελόκηποι - Πεντάγωνο, Πεντάγωνο',
    value: 6104,
    type: 'default',
  },
  {
    id: 6105,
    label: 'Κέντρο Αθήνας, Αμπελόκηποι - Πεντάγωνο, Πανόρμου',
    value: 6105,
    type: 'default',
  },
  {
    id: 6106,
    label: 'Κέντρο Αθήνας, Αμπελόκηποι - Πεντάγωνο, Ερυθρός',
    value: 6106,
    type: 'default',
  },
  {
    id: 6135,
    label: 'Κέντρο Αθήνας, Αμπελόκηποι - Πεντάγωνο, Νέα Φιλοθέη',
    value: 6135,
    type: 'default',
  },
  {
    id: 2007,
    label: 'Κέντρο Αθήνας, Αμπελόκηποι - Πεντάγωνο, Αμπελόκηποι',
    value: 2007,
    type: 'default',
  },
  {
    id: 6136,
    label: 'Κέντρο Αθήνας, Αμπελόκηποι - Πεντάγωνο, Γηροκομείο',
    value: 6136,
    type: 'default',
  },
  {
    id: 6003,
    label: 'Κέντρο Αθήνας, Άνω Πατήσια',
    value: 6003,
    type: 'default',
  },
  {
    id: 6107,
    label: 'Κέντρο Αθήνας, Άνω Πατήσια, Πλατεία Παπαδιαμάντη',
    value: 6107,
    type: 'default',
  },
  {
    id: 6108,
    label: 'Κέντρο Αθήνας, Άνω Πατήσια, Λαμπρινή',
    value: 6108,
    type: 'default',
  },
  {
    id: 6109,
    label: 'Κέντρο Αθήνας, Άνω Πατήσια, Κλωναρίδου',
    value: 6109,
    type: 'default',
  },
  {
    id: 6137,
    label: 'Κέντρο Αθήνας, Άνω Πατήσια, Κυπριάδου - Άνω Πατήσια',
    value: 6137,
    type: 'default',
  },
  {
    id: 6004,
    label: 'Κέντρο Αθήνας, Αττική',
    value: 6004,
    type: 'default',
  },
  {
    id: 2024,
    label: 'Κέντρο Αθήνας, Αττική, Λεωφ. Λιοσίων',
    value: 2024,
    type: 'default',
  },
  {
    id: 2041,
    label: 'Κέντρο Αθήνας, Αττική, Πλατεία Αττικής',
    value: 2041,
    type: 'default',
  },
  {
    id: 6121,
    label: 'Κέντρο Αθήνας, Αττική, Θυμαράκια',
    value: 6121,
    type: 'default',
  },
  {
    id: 6005,
    label: 'Κέντρο Αθήνας, Γκάζι - Μεταξουργείο - Βοτανικός',
    value: 6005,
    type: 'default',
  },
  {
    id: 2008,
    label: 'Κέντρο Αθήνας, Γκάζι - Μεταξουργείο - Βοτανικός, Βοτανικός',
    value: 2008,
    type: 'default',
  },
  {
    id: 2009,
    label: 'Κέντρο Αθήνας, Γκάζι - Μεταξουργείο - Βοτανικός, Γκάζι',
    value: 2009,
    type: 'default',
  },
  {
    id: 2017,
    label: 'Κέντρο Αθήνας, Γκάζι - Μεταξουργείο - Βοτανικός, Κεραμεικός',
    value: 2017,
    type: 'default',
  },
  {
    id: 2029,
    label: 'Κέντρο Αθήνας, Γκάζι - Μεταξουργείο - Βοτανικός, Μεταξουργείο',
    value: 2029,
    type: 'default',
  },
  {
    id: 2050,
    label: 'Κέντρο Αθήνας, Γκάζι - Μεταξουργείο - Βοτανικός, Ρουφ',
    value: 2050,
    type: 'default',
  },
  {
    id: 6006,
    label: 'Κέντρο Αθήνας, Γκύζη - Πεδίον Άρεως',
    value: 6006,
    type: 'default',
  },
  {
    id: 2010,
    label: 'Κέντρο Αθήνας, Γκύζη - Πεδίον Άρεως, Πλατεία Γκύζη',
    value: 2010,
    type: 'default',
  },
  {
    id: 2037,
    label: 'Κέντρο Αθήνας, Γκύζη - Πεδίον Άρεως, Πεδίο Άρεως',
    value: 2037,
    type: 'default',
  },
  {
    id: 6128,
    label: 'Κέντρο Αθήνας, Γκύζη - Πεδίον Άρεως, Λόφος Φινοπούλου',
    value: 6128,
    type: 'default',
  },
  {
    id: 6129,
    label: 'Κέντρο Αθήνας, Γκύζη - Πεδίον Άρεως, Γκύζη - Άρειος Πάγος',
    value: 6129,
    type: 'default',
  },
  {
    id: 6007,
    label: 'Κέντρο Αθήνας, Εξάρχεια - Νεάπολη',
    value: 6007,
    type: 'default',
  },
  {
    id: 2013,
    label: 'Κέντρο Αθήνας, Εξάρχεια - Νεάπολη, Εξάρχεια',
    value: 2013,
    type: 'default',
  },
  {
    id: 2032,
    label: 'Κέντρο Αθήνας, Εξάρχεια - Νεάπολη, Νεάπολη Εξαρχείων',
    value: 2032,
    type: 'default',
  },
  {
    id: 6127,
    label: 'Κέντρο Αθήνας, Εξάρχεια - Νεάπολη, Μουσείο',
    value: 6127,
    type: 'default',
  },
  {
    id: 6139,
    label: 'Κέντρο Αθήνας, Εξάρχεια - Νεάπολη, Πολυτεχνείο',
    value: 6139,
    type: 'default',
  },
  {
    id: 6008,
    label: 'Κέντρο Αθήνας, Ιστορικό Κέντρο',
    value: 6008,
    type: 'default',
  },
  {
    id: 2006,
    label: 'Κέντρο Αθήνας, Ιστορικό Κέντρο, Ακρόπολη',
    value: 2006,
    type: 'default',
  },
  {
    id: 2014,
    label: 'Κέντρο Αθήνας, Ιστορικό Κέντρο, Θησείο',
    value: 2014,
    type: 'default',
  },
  {
    id: 2031,
    label: 'Κέντρο Αθήνας, Ιστορικό Κέντρο, Μοναστηράκι',
    value: 2031,
    type: 'default',
  },
  {
    id: 2039,
    label: 'Κέντρο Αθήνας, Ιστορικό Κέντρο, Πλάκα',
    value: 2039,
    type: 'default',
  },
  {
    id: 2054,
    label: 'Κέντρο Αθήνας, Ιστορικό Κέντρο, Φιλοπάππου',
    value: 2054,
    type: 'default',
  },
  {
    id: 6009,
    label: 'Κέντρο Αθήνας, Κολωνάκι - Λυκαβηττός',
    value: 6009,
    type: 'default',
  },
  {
    id: 13000004,
    label: 'Κέντρο Αθήνας, Κολωνάκι - Λυκαβηττός, Ανάκτορα',
    value: 13000004,
    type: 'default',
  },
  {
    id: 2019,
    label: 'Κέντρο Αθήνας, Κολωνάκι - Λυκαβηττός, Κολωνάκι',
    value: 2019,
    type: 'default',
  },
  {
    id: 2027,
    label: 'Κέντρο Αθήνας, Κολωνάκι - Λυκαβηττός, Λυκαβηττός',
    value: 2027,
    type: 'default',
  },
  {
    id: 6130,
    label: 'Κέντρο Αθήνας, Κολωνάκι - Λυκαβηττός, Ρηγίλλης',
    value: 6130,
    type: 'default',
  },
  {
    id: 6010,
    label: 'Κέντρο Αθήνας, Κολωνός - Κολοκυνθούς',
    value: 6010,
    type: 'default',
  },
  {
    id: 2005,
    label: 'Κέντρο Αθήνας, Κολωνός - Κολοκυνθούς, Ακαδημία Πλάτωνος',
    value: 2005,
    type: 'default',
  },
  {
    id: 2018,
    label: 'Κέντρο Αθήνας, Κολωνός - Κολοκυνθούς, Κολοκυνθούς',
    value: 2018,
    type: 'default',
  },
  {
    id: 2020,
    label: 'Κέντρο Αθήνας, Κολωνός - Κολοκυνθούς, Κολωνός',
    value: 2020,
    type: 'default',
  },
  {
    id: 2052,
    label: 'Κέντρο Αθήνας, Κολωνός - Κολοκυνθούς, Σταθμός Λαρίσης',
    value: 2052,
    type: 'default',
  },
  {
    id: 6011,
    label: 'Κέντρο Αθήνας, Κουκάκι - Μακρυγιάννη',
    value: 6011,
    type: 'default',
  },
  {
    id: 2021,
    label: 'Κέντρο Αθήνας, Κουκάκι - Μακρυγιάννη, Φιξ',
    value: 2021,
    type: 'default',
  },
  {
    id: 2028,
    label: 'Κέντρο Αθήνας, Κουκάκι - Μακρυγιάννη, Μακρυγιάννη',
    value: 2028,
    type: 'default',
  },
  {
    id: 6131,
    label: 'Κέντρο Αθήνας, Κουκάκι - Μακρυγιάννη, Κουκάκι - Παιδική Χαρά',
    value: 6131,
    type: 'default',
  },
  {
    id: 6012,
    label: 'Κέντρο Αθήνας, Μετς - Καλλιμάρμαρο',
    value: 6012,
    type: 'default',
  },
  {
    id: 2016,
    label: 'Κέντρο Αθήνας, Μετς - Καλλιμάρμαρο, Καλλιμάρμαρο',
    value: 2016,
    type: 'default',
  },
  {
    id: 2030,
    label: 'Κέντρο Αθήνας, Μετς - Καλλιμάρμαρο, Μετς',
    value: 2030,
    type: 'default',
  },
  {
    id: 6132,
    label: 'Κέντρο Αθήνας, Μετς - Καλλιμάρμαρο, Ά Νεκροταφείο',
    value: 6132,
    type: 'default',
  },
  {
    id: 6013,
    label: 'Κέντρο Αθήνας, Παγκράτι',
    value: 6013,
    type: 'default',
  },
  {
    id: 2000,
    label: 'Κέντρο Αθήνας, Παγκράτι, Άγιος Αρτέμιος',
    value: 2000,
    type: 'default',
  },
  {
    id: 6140,
    label: 'Κέντρο Αθήνας, Παγκράτι, Προφήτης Ηλίας',
    value: 6140,
    type: 'default',
  },
  {
    id: 6134,
    label: 'Κέντρο Αθήνας, Παγκράτι, Άλσος Παγκρατίου',
    value: 6134,
    type: 'default',
  },
  {
    id: 2035,
    label: 'Κέντρο Αθήνας, Παγκράτι, Κέντρο Παγκρατίου',
    value: 2035,
    type: 'default',
  },
  {
    id: 6133,
    label: 'Κέντρο Αθήνας, Παγκράτι, Βαρνάβα',
    value: 6133,
    type: 'default',
  },
  {
    id: 6014,
    label: 'Κέντρο Αθήνας, Πολύγωνο - Τουρκοβούνια',
    value: 6014,
    type: 'default',
  },
  {
    id: 2048,
    label: 'Κέντρο Αθήνας, Πολύγωνο - Τουρκοβούνια, Πολύγωνο',
    value: 2048,
    type: 'default',
  },
  {
    id: 5143,
    label: 'Κέντρο Αθήνας, Πολύγωνο - Τουρκοβούνια, Αττικό Άλσος',
    value: 5143,
    type: 'default',
  },
  {
    id: 6141,
    label: 'Κέντρο Αθήνας, Πολύγωνο - Τουρκοβούνια, Τουρκοβούνια',
    value: 6141,
    type: 'default',
  },
  {
    id: 6142,
    label: 'Κέντρο Αθήνας, Πολύγωνο - Τουρκοβούνια, Ευελπίδων',
    value: 6142,
    type: 'default',
  },
  {
    id: 6015,
    label: 'Κέντρο Αθήνας, Σεπόλια - Σκουζέ',
    value: 6015,
    type: 'default',
  },
  {
    id: 2026,
    label: 'Κέντρο Αθήνας, Σεπόλια - Σκουζέ, Λόφος Σκουζέ',
    value: 2026,
    type: 'default',
  },
  {
    id: 2051,
    label: 'Κέντρο Αθήνας, Σεπόλια - Σκουζέ, Σεπόλια',
    value: 2051,
    type: 'default',
  },
  {
    id: 108,
    label: 'Θεσσαλονίκη - Δήμος',
    value: 108,
    type: 'default',
  },
  {
    id: 2803,
    label: 'Θεσσαλονίκη - Δήμος, Άνω Πόλη',
    value: 2803,
    type: 'default',
  },
  {
    id: 499207,
    label: 'Θεσσαλονίκη - Δήμος, Άνω Πόλη, Τσινάρι',
    value: 499207,
    type: 'default',
  },
  {
    id: 499208,
    label: 'Θεσσαλονίκη - Δήμος, Άνω Πόλη, Κάστρα',
    value: 499208,
    type: 'default',
  },
  {
    id: 13000384,
    label: 'Θεσσαλονίκη - Δήμος, Άνω Πόλη, Αγία Αικατερίνη',
    value: 13000384,
    type: 'default',
  },
  {
    id: 13000385,
    label: 'Θεσσαλονίκη - Δήμος, Άνω Πόλη, Άγιος Νικόλαος',
    value: 13000385,
    type: 'default',
  },
  {
    id: 13000386,
    label: 'Θεσσαλονίκη - Δήμος, Άνω Πόλη, Βλατάδων',
    value: 13000386,
    type: 'default',
  },
  {
    id: 13000387,
    label: 'Θεσσαλονίκη - Δήμος, Άνω Πόλη, Καλλιθέα',
    value: 13000387,
    type: 'default',
  },
  {
    id: 13000388,
    label: 'Θεσσαλονίκη - Δήμος, Άνω Πόλη, Κόκκινη Βρύση',
    value: 13000388,
    type: 'default',
  },
  {
    id: 13000389,
    label: 'Θεσσαλονίκη - Δήμος, Άνω Πόλη, Κουλέ Καφέ',
    value: 13000389,
    type: 'default',
  },
  {
    id: 13000390,
    label: 'Θεσσαλονίκη - Δήμος, Άνω Πόλη, Όσιος Δαυίδ',
    value: 13000390,
    type: 'default',
  },
  {
    id: 13000391,
    label: 'Θεσσαλονίκη - Δήμος, Άνω Πόλη, Πορτάρα',
    value: 13000391,
    type: 'default',
  },
  {
    id: 13000392,
    label: 'Θεσσαλονίκη - Δήμος, Άνω Πόλη, Τερψιθέα',
    value: 13000392,
    type: 'default',
  },
  {
    id: 2823,
    label: 'Θεσσαλονίκη - Δήμος, Χαριλάου',
    value: 2823,
    type: 'default',
  },
  {
    id: 499209,
    label: 'Θεσσαλονίκη - Δήμος, Χαριλάου, Αγία Κυριακή',
    value: 499209,
    type: 'default',
  },
  {
    id: 2817,
    label: 'Θεσσαλονίκη - Δήμος, Χαριλάου, Νέα Ελβετία',
    value: 2817,
    type: 'default',
  },
  {
    id: 499211,
    label: 'Θεσσαλονίκη - Δήμος, Χαριλάου, Βρυσάκι',
    value: 499211,
    type: 'default',
  },
  {
    id: 499212,
    label: 'Θεσσαλονίκη - Δήμος, Χαριλάου, Οσία Ξένη',
    value: 499212,
    type: 'default',
  },
  {
    id: 13000402,
    label: 'Θεσσαλονίκη - Δήμος, Χαριλάου, Βούλγαρη - Κηφισιά',
    value: 13000402,
    type: 'default',
  },
  {
    id: 499210,
    label: 'Θεσσαλονίκη - Δήμος, Χαριλάου, Άγιος Νικόλαος',
    value: 499210,
    type: 'default',
  },
  {
    id: 499115,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης',
    value: 499115,
    type: 'default',
  },
  {
    id: 2809,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, Ροτόντα',
    value: 2809,
    type: 'default',
  },
  {
    id: 2812,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, Λευκός Πύργος',
    value: 2812,
    type: 'default',
  },
  {
    id: 2813,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, Λαδάδικα',
    value: 2813,
    type: 'default',
  },
  {
    id: 2826,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, Άγιος Δημήτριος',
    value: 2826,
    type: 'default',
  },
  {
    id: 2899,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, ΔΕΘ - Πανεπιστήμια',
    value: 2899,
    type: 'default',
  },
  {
    id: 7378,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, Ιστορικό Κέντρο',
    value: 7378,
    type: 'default',
  },
  {
    id: 10294,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, Καμάρα',
    value: 10294,
    type: 'default',
  },
  {
    id: 507534,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, Αγία Σοφία',
    value: 507534,
    type: 'default',
  },
  {
    id: 507535,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, Αντιγονιδών',
    value: 507535,
    type: 'default',
  },
  {
    id: 13000393,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, Πανεπιστημιούπολη',
    value: 13000393,
    type: 'default',
  },
  {
    id: 13000394,
    label:
      'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, Πλατεία Εμπορίου - Ανω Λαδάδικα - Ιστορικό Κέντρο',
    value: 13000394,
    type: 'default',
  },
  {
    id: 13000395,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, Πλατεία Ναυαρίνου',
    value: 13000395,
    type: 'default',
  },
  {
    id: 13000396,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, Ρωμαϊκή Αγορά - Βενιζέλου - Ιστορικό Κέντρο',
    value: 13000396,
    type: 'default',
  },
  {
    id: 13000397,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, Τουρκικό Προξενείο',
    value: 13000397,
    type: 'default',
  },
  {
    id: 2807,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, Διοικητήριο',
    value: 2807,
    type: 'default',
  },
  {
    id: 13000398,
    label: 'Θεσσαλονίκη - Δήμος, Κέντρο Θεσσαλονίκης, ΧΑΝΘ',
    value: 13000398,
    type: 'default',
  },
  {
    id: 499116,
    label: 'Θεσσαλονίκη - Δήμος, Σφαγεία - Ιχθυόσκαλα',
    value: 499116,
    type: 'default',
  },
  {
    id: 10297,
    label: 'Θεσσαλονίκη - Δήμος, Σφαγεία - Ιχθυόσκαλα, Λιμάνι - Περιοχή FIX',
    value: 10297,
    type: 'default',
  },
  {
    id: 10301,
    label: 'Θεσσαλονίκη - Δήμος, Σφαγεία - Ιχθυόσκαλα, Παλαιός Σιδηροδρομικός Σταθμός',
    value: 10301,
    type: 'default',
  },
  {
    id: 13000399,
    label: 'Θεσσαλονίκη - Δήμος, Σφαγεία - Ιχθυόσκαλα, Σφαγεία',
    value: 13000399,
    type: 'default',
  },
  {
    id: 499117,
    label: 'Θεσσαλονίκη - Δήμος, Βαρδάρης - Λαχανόκηποι',
    value: 499117,
    type: 'default',
  },
  {
    id: 2805,
    label: 'Θεσσαλονίκη - Δήμος, Βαρδάρης - Λαχανόκηποι, Βαρδάρης',
    value: 2805,
    type: 'default',
  },
  {
    id: 2821,
    label: 'Θεσσαλονίκη - Δήμος, Βαρδάρης - Λαχανόκηποι, Σταθμός ΟΣΕ',
    value: 2821,
    type: 'default',
  },
  {
    id: 2827,
    label: 'Θεσσαλονίκη - Δήμος, Βαρδάρης - Λαχανόκηποι, Λαχανόκηποι',
    value: 2827,
    type: 'default',
  },
  {
    id: 499118,
    label: 'Θεσσαλονίκη - Δήμος, Ξηροκρήνη - Παναγία Φανερωμένη',
    value: 499118,
    type: 'default',
  },
  {
    id: 2820,
    label: 'Θεσσαλονίκη - Δήμος, Ξηροκρήνη - Παναγία Φανερωμένη, Παναγία Φανερωμένη',
    value: 2820,
    type: 'default',
  },
  {
    id: 10304,
    label: 'Θεσσαλονίκη - Δήμος, Ξηροκρήνη - Παναγία Φανερωμένη, Ξηροκρήνη',
    value: 10304,
    type: 'default',
  },
  {
    id: 499119,
    label: 'Θεσσαλονίκη - Δήμος, 40 Εκκλησιές - Ευαγγελίστρια',
    value: 499119,
    type: 'default',
  },
  {
    id: 2800,
    label: 'Θεσσαλονίκη - Δήμος, 40 Εκκλησιές - Ευαγγελίστρια, 40 Εκκλησιές',
    value: 2800,
    type: 'default',
  },
  {
    id: 2808,
    label: 'Θεσσαλονίκη - Δήμος, 40 Εκκλησιές - Ευαγγελίστρια, Ευαγγελίστρια',
    value: 2808,
    type: 'default',
  },
  {
    id: 499120,
    label: 'Θεσσαλονίκη - Δήμος, Τριανδρία - Δόξα',
    value: 499120,
    type: 'default',
  },
  {
    id: 2916,
    label: 'Θεσσαλονίκη - Δήμος, Τριανδρία - Δόξα, Τριανδρία',
    value: 2916,
    type: 'default',
  },
  {
    id: 10293,
    label: 'Θεσσαλονίκη - Δήμος, Τριανδρία - Δόξα, Δόξα',
    value: 10293,
    type: 'default',
  },
  {
    id: 13000400,
    label: 'Θεσσαλονίκη - Δήμος, Τριανδρία - Δόξα, Κρυονέρι',
    value: 13000400,
    type: 'default',
  },
  {
    id: 499121,
    label: 'Θεσσαλονίκη - Δήμος, Τούμπα',
    value: 499121,
    type: 'default',
  },
  {
    id: 2804,
    label: 'Θεσσαλονίκη - Δήμος, Τούμπα, Άνω Τούμπα',
    value: 2804,
    type: 'default',
  },
  {
    id: 2824,
    label: 'Θεσσαλονίκη - Δήμος, Τούμπα, Παπάφη',
    value: 2824,
    type: 'default',
  },
  {
    id: 2814,
    label: 'Θεσσαλονίκη - Δήμος, Τούμπα, Μαλακοπή',
    value: 2814,
    type: 'default',
  },
  {
    id: 2810,
    label: 'Θεσσαλονίκη - Δήμος, Τούμπα, Κάτω Τούμπα',
    value: 2810,
    type: 'default',
  },
  {
    id: 499122,
    label: 'Θεσσαλονίκη - Δήμος, Φάληρο - Ιπποκράτειο',
    value: 499122,
    type: 'default',
  },
  {
    id: 2822,
    label: 'Θεσσαλονίκη - Δήμος, Φάληρο - Ιπποκράτειο, Αγία Τριάδα',
    value: 2822,
    type: 'default',
  },
  {
    id: 2825,
    label: 'Θεσσαλονίκη - Δήμος, Φάληρο - Ιπποκράτειο, Ιπποκράτειο',
    value: 2825,
    type: 'default',
  },
  {
    id: 13000401,
    label: 'Θεσσαλονίκη - Δήμος, Φάληρο - Ιπποκράτειο, Ευζώνων - Πεδίον Άρεως',
    value: 13000401,
    type: 'default',
  },
  {
    id: 499123,
    label: 'Θεσσαλονίκη - Δήμος, Ανάληψη - Μπότσαρη - Νέα Παραλία',
    value: 499123,
    type: 'default',
  },
  {
    id: 2802,
    label: 'Θεσσαλονίκη - Δήμος, Ανάληψη - Μπότσαρη - Νέα Παραλία, Ανάληψη',
    value: 2802,
    type: 'default',
  },
  {
    id: 2816,
    label: 'Θεσσαλονίκη - Δήμος, Ανάληψη - Μπότσαρη - Νέα Παραλία, Μπότσαρη',
    value: 2816,
    type: 'default',
  },
  {
    id: 2818,
    label: 'Θεσσαλονίκη - Δήμος, Ανάληψη - Μπότσαρη - Νέα Παραλία, Νέα Παραλία',
    value: 2818,
    type: 'default',
  },
  {
    id: 499124,
    label: 'Θεσσαλονίκη - Δήμος, Βούλγαρη - Ντεπώ - Μαρτίου',
    value: 499124,
    type: 'default',
  },
  {
    id: 2806,
    label: 'Θεσσαλονίκη - Δήμος, Βούλγαρη - Ντεπώ - Μαρτίου, Βούλγαρη - Άγιος Ελευθέριος',
    value: 2806,
    type: 'default',
  },
  {
    id: 2815,
    label: 'Θεσσαλονίκη - Δήμος, Βούλγαρη - Ντεπώ - Μαρτίου, Μαρτίου',
    value: 2815,
    type: 'default',
  },
  {
    id: 2819,
    label: 'Θεσσαλονίκη - Δήμος, Βούλγαρη - Ντεπώ - Μαρτίου, Ντεπώ',
    value: 2819,
    type: 'default',
  },
  {
    id: 109,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι',
    value: 109,
    type: 'default',
  },
  {
    id: 2900,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Άγιος Παύλος',
    value: 2900,
    type: 'default',
  },
  {
    id: 329507,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Άγιος Παύλος, Χίλια Δέντρα',
    value: 329507,
    type: 'default',
  },
  {
    id: 110276,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Άγιος Παύλος, Πανεπιστημιούπολη',
    value: 110276,
    type: 'default',
  },
  {
    id: 329506,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Άγιος Παύλος, Γεντί Κουλέ',
    value: 329506,
    type: 'default',
  },
  {
    id: 2901,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αμπελόκηποι',
    value: 2901,
    type: 'default',
  },
  {
    id: 13000403,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αμπελόκηποι, Καΐστρι',
    value: 13000403,
    type: 'default',
  },
  {
    id: 110262,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αμπελόκηποι, Πλατεία Δημοκρατίας',
    value: 110262,
    type: 'default',
  },
  {
    id: 13000404,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αμπελόκηποι, Μεγάλου Αλεξάνδρου',
    value: 13000404,
    type: 'default',
  },
  {
    id: 110258,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αμπελόκηποι, Μεταγωγών',
    value: 110258,
    type: 'default',
  },
  {
    id: 110274,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αμπελόκηποι, Επτάλοφος',
    value: 110274,
    type: 'default',
  },
  {
    id: 110273,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αμπελόκηποι, Ζωοδόχου Πηγής',
    value: 110273,
    type: 'default',
  },
  {
    id: 110272,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αμπελόκηποι, Φιλλίπου',
    value: 110272,
    type: 'default',
  },
  {
    id: 110271,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αμπελόκηποι, Δημαρχείου',
    value: 110271,
    type: 'default',
  },
  {
    id: 110270,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αμπελόκηποι, Σκεπάρνη',
    value: 110270,
    type: 'default',
  },
  {
    id: 110269,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αμπελόκηποι, Βόσπορος',
    value: 110269,
    type: 'default',
  },
  {
    id: 2902,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ελευθέριο-Κορδελιό',
    value: 2902,
    type: 'default',
  },
  {
    id: 102902,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ελευθέριο-Κορδελιό, Κέντρο',
    value: 102902,
    type: 'default',
  },
  {
    id: 110267,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ελευθέριο-Κορδελιό, Νέο Κορδελιό',
    value: 110267,
    type: 'default',
  },
  {
    id: 13000406,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ελευθέριο-Κορδελιό, Αγία Ειρήνη',
    value: 13000406,
    type: 'default',
  },
  {
    id: 13000407,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ελευθέριο-Κορδελιό, Διαλογή',
    value: 13000407,
    type: 'default',
  },
  {
    id: 13000408,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ελευθέριο-Κορδελιό, Ελευθερία',
    value: 13000408,
    type: 'default',
  },
  {
    id: 13000409,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ελευθέριο-Κορδελιό, Ζιάκα',
    value: 13000409,
    type: 'default',
  },
  {
    id: 2903,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ευκαρπία',
    value: 2903,
    type: 'default',
  },
  {
    id: 102903,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ευκαρπία, Κέντρο',
    value: 102903,
    type: 'default',
  },
  {
    id: 13000421,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ευκαρπία, Φιλοθέη',
    value: 13000421,
    type: 'default',
  },
  {
    id: 13000419,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ευκαρπία, Οικισμός Μακεδονία - Εργατικές Κατοικίες',
    value: 13000419,
    type: 'default',
  },
  {
    id: 13000420,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ευκαρπία, Τραυματιούπολη',
    value: 13000420,
    type: 'default',
  },
  {
    id: 499177,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ευκαρπία, Ευξεινούπολη Ευκαρπίας',
    value: 499177,
    type: 'default',
  },
  {
    id: 13000417,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ευκαρπία, Άνω Ανθόκηποι',
    value: 13000417,
    type: 'default',
  },
  {
    id: 13000418,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ευκαρπία, Εφεδρούπολη',
    value: 13000418,
    type: 'default',
  },
  {
    id: 2904,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εύοσμος',
    value: 2904,
    type: 'default',
  },
  {
    id: 102904,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εύοσμος, Κέντρο',
    value: 102904,
    type: 'default',
  },
  {
    id: 110266,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εύοσμος, Εύοσμο',
    value: 110266,
    type: 'default',
  },
  {
    id: 290400,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εύοσμος, Άνωθεν Περιφερειακού',
    value: 290400,
    type: 'default',
  },
  {
    id: 290401,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εύοσμος, Ευαγγελισμός - Νέος Κουκλουτζάς',
    value: 290401,
    type: 'default',
  },
  {
    id: 290402,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εύοσμος, Κάτω Ηλιούπολη',
    value: 290402,
    type: 'default',
  },
  {
    id: 290403,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εύοσμος, Νέα Πολιτεία',
    value: 290403,
    type: 'default',
  },
  {
    id: 13000422,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εύοσμος, Άγιος Κοσμάς',
    value: 13000422,
    type: 'default',
  },
  {
    id: 13000423,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εύοσμος, Άνω Εύοσμος',
    value: 13000423,
    type: 'default',
  },
  {
    id: 13000424,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εύοσμος, Κάτω Εύοσμος',
    value: 13000424,
    type: 'default',
  },
  {
    id: 2905,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θερμαϊκός',
    value: 2905,
    type: 'default',
  },
  {
    id: 107425,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θερμαϊκός, Κέντρο',
    value: 107425,
    type: 'default',
  },
  {
    id: 110628,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θερμαϊκός, Λιβάδακιο',
    value: 110628,
    type: 'default',
  },
  {
    id: 110633,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θερμαϊκός, Περαία',
    value: 110633,
    type: 'default',
  },
  {
    id: 110634,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θερμαϊκός, Νέοι Επιβάτες',
    value: 110634,
    type: 'default',
  },
  {
    id: 110636,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θερμαϊκός, Σκάλα Ν. Επιβατών',
    value: 110636,
    type: 'default',
  },
  {
    id: 13000427,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θερμαϊκός, Άνω Αγία Τριάδα',
    value: 13000427,
    type: 'default',
  },
  {
    id: 13000428,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θερμαϊκός, Άνω Περαία',
    value: 13000428,
    type: 'default',
  },
  {
    id: 13000429,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θερμαϊκός, Ελβετία',
    value: 13000429,
    type: 'default',
  },
  {
    id: 13000430,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θερμαϊκός, Θεσσαλονικέων',
    value: 13000430,
    type: 'default',
  },
  {
    id: 13000431,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θερμαϊκός, Καλλιθέα',
    value: 13000431,
    type: 'default',
  },
  {
    id: 13000432,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θερμαϊκός, Πανόραμα',
    value: 13000432,
    type: 'default',
  },
  {
    id: 2801,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θερμαϊκός, Αγία Τριάδα',
    value: 2801,
    type: 'default',
  },
  {
    id: 13000433,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θερμαϊκός, Πεύκων',
    value: 13000433,
    type: 'default',
  },
  {
    id: 2906,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη',
    value: 2906,
    type: 'default',
  },
  {
    id: 102906,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Κέντρο',
    value: 102906,
    type: 'default',
  },
  {
    id: 110455,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Ταγαράδες',
    value: 110455,
    type: 'default',
  },
  {
    id: 110456,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Νέο Ρύσιο',
    value: 110456,
    type: 'default',
  },
  {
    id: 110460,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Νέα Ραιδεστός',
    value: 110460,
    type: 'default',
  },
  {
    id: 110461,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Κράνη',
    value: 110461,
    type: 'default',
  },
  {
    id: 110462,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Τριάδιο',
    value: 110462,
    type: 'default',
  },
  {
    id: 499692,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Περιοχή Αεροδρομίου',
    value: 499692,
    type: 'default',
  },
  {
    id: 13000434,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Mediterranean Cosmos',
    value: 13000434,
    type: 'default',
  },
  {
    id: 13000435,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Άγιος Τρύφωνας',
    value: 13000435,
    type: 'default',
  },
  {
    id: 13000436,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Δροσιά',
    value: 13000436,
    type: 'default',
  },
  {
    id: 13000437,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Επέκταση Θέρμης',
    value: 13000437,
    type: 'default',
  },
  {
    id: 13000438,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Λήδα - Μαρία',
    value: 13000438,
    type: 'default',
  },
  {
    id: 13000439,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Λιόγερμα',
    value: 13000439,
    type: 'default',
  },
  {
    id: 13000440,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, ΣΕΔΕΣ',
    value: 13000440,
    type: 'default',
  },
  {
    id: 13000441,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Συνοικισμός Παραλίμνη',
    value: 13000441,
    type: 'default',
  },
  {
    id: 13000442,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Φαρμακείκα',
    value: 13000442,
    type: 'default',
  },
  {
    id: 13000443,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Θέρμη, Φιλοθέη',
    value: 13000443,
    type: 'default',
  },
  {
    id: 2907,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά',
    value: 2907,
    type: 'default',
  },
  {
    id: 10291,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Βυζάντιο',
    value: 10291,
    type: 'default',
  },
  {
    id: 102907,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Κέντρο',
    value: 102907,
    type: 'default',
  },
  {
    id: 110438,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Δέρκων',
    value: 110438,
    type: 'default',
  },
  {
    id: 110439,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Άγιος Ιωάννης',
    value: 110439,
    type: 'default',
  },
  {
    id: 110440,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Αρετσού',
    value: 110440,
    type: 'default',
  },
  {
    id: 110441,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Κουρί',
    value: 110441,
    type: 'default',
  },
  {
    id: 110442,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Βότση',
    value: 110442,
    type: 'default',
  },
  {
    id: 110443,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Καραμπουρνακι',
    value: 110443,
    type: 'default',
  },
  {
    id: 110444,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Κηφισιά',
    value: 110444,
    type: 'default',
  },
  {
    id: 110445,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Νέα Κρήνη',
    value: 110445,
    type: 'default',
  },
  {
    id: 290700,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Επέκταση',
    value: 290700,
    type: 'default',
  },
  {
    id: 290701,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Φοίνικας',
    value: 290701,
    type: 'default',
  },
  {
    id: 290702,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Άγιος Παντελεήμων',
    value: 290702,
    type: 'default',
  },
  {
    id: 13000444,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Κατιρλί',
    value: 13000444,
    type: 'default',
  },
  {
    id: 13000445,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλαμαριά, Μίκρα',
    value: 13000445,
    type: 'default',
  },
  {
    id: 2908,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μενεμένη',
    value: 2908,
    type: 'default',
  },
  {
    id: 102908,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μενεμένη, Κέντρο',
    value: 102908,
    type: 'default',
  },
  {
    id: 110265,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μενεμένη, Δενδροπόταμος',
    value: 110265,
    type: 'default',
  },
  {
    id: 110268,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μενεμένη, Λαχανόκηποι',
    value: 110268,
    type: 'default',
  },
  {
    id: 2909,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Νεάπολη',
    value: 2909,
    type: 'default',
  },
  {
    id: 290900,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Νεάπολη, Άγιος Γιώργιος - Τρώαδα',
    value: 290900,
    type: 'default',
  },
  {
    id: 290901,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Νεάπολη, Άνω Αναγέννηση',
    value: 290901,
    type: 'default',
  },
  {
    id: 290903,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Νεάπολη, Κουντουριώτη',
    value: 290903,
    type: 'default',
  },
  {
    id: 290902,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Νεάπολη, Κάτω Αναγέννηση',
    value: 290902,
    type: 'default',
  },
  {
    id: 290904,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Νεάπολη, Νεάπολη',
    value: 290904,
    type: 'default',
  },
  {
    id: 290905,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Νεάπολη, Πυροπαθών',
    value: 290905,
    type: 'default',
  },
  {
    id: 290906,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Νεάπολη, Ρήγα Φεραίου',
    value: 290906,
    type: 'default',
  },
  {
    id: 290907,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Νεάπολη, Στρεμπενιώτη',
    value: 290907,
    type: 'default',
  },
  {
    id: 290908,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Νεάπολη, Υδραγωγείο',
    value: 290908,
    type: 'default',
  },
  {
    id: 114525,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Νεάπολη, Νέο Χωριό',
    value: 114525,
    type: 'default',
  },
  {
    id: 290909,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Νεάπολη, Κόκκορας',
    value: 290909,
    type: 'default',
  },
  {
    id: 207219,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Νεάπολη, Κέντρο',
    value: 207219,
    type: 'default',
  },
  {
    id: 2910,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πανόραμα',
    value: 2910,
    type: 'default',
  },
  {
    id: 329503,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πανόραμα, Οικισμός Τοπογράφων',
    value: 329503,
    type: 'default',
  },
  {
    id: 102910,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πανόραμα, Κέντρο',
    value: 102910,
    type: 'default',
  },
  {
    id: 329500,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πανόραμα, Παλιός Οικισμός Πανοράματος',
    value: 329500,
    type: 'default',
  },
  {
    id: 329501,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πανόραμα, Συνοικισμός Νόμου 751',
    value: 329501,
    type: 'default',
  },
  {
    id: 329502,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πανόραμα, Οικισμός Μακεδονία',
    value: 329502,
    type: 'default',
  },
  {
    id: 2911,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πεύκα',
    value: 2911,
    type: 'default',
  },
  {
    id: 329509,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πεύκα, Στροφή Φιλύρου',
    value: 329509,
    type: 'default',
  },
  {
    id: 102911,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πεύκα, Κέντρο',
    value: 102911,
    type: 'default',
  },
  {
    id: 329508,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πεύκα, Δελασάλ',
    value: 329508,
    type: 'default',
  },
  {
    id: 2912,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πολίχνη',
    value: 2912,
    type: 'default',
  },
  {
    id: 102912,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πολίχνη, Κέντρο',
    value: 102912,
    type: 'default',
  },
  {
    id: 110261,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πολίχνη, Μετέωρα',
    value: 110261,
    type: 'default',
  },
  {
    id: 291200,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πολίχνη, Άγιος Ιωάννης',
    value: 291200,
    type: 'default',
  },
  {
    id: 291201,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πολίχνη, Άγιος Παντελεήμονας',
    value: 291201,
    type: 'default',
  },
  {
    id: 291202,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πολίχνη, Άγιος Ραφαήλ',
    value: 291202,
    type: 'default',
  },
  {
    id: 291203,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πολίχνη, Ανθόκηποι',
    value: 291203,
    type: 'default',
  },
  {
    id: 291204,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πολίχνη, Άνω Πολίχνη',
    value: 291204,
    type: 'default',
  },
  {
    id: 291205,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πολίχνη, Επέκταση',
    value: 291205,
    type: 'default',
  },
  {
    id: 291206,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πολίχνη, Καρατάσσου',
    value: 291206,
    type: 'default',
  },
  {
    id: 13000446,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πολίχνη, Ελπίδος',
    value: 13000446,
    type: 'default',
  },
  {
    id: 13000447,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πολίχνη, Μεγάλος Αλέξανδρος - Εργατικές Κατοικίες',
    value: 13000447,
    type: 'default',
  },
  {
    id: 13000448,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πολίχνη, Νερόμυλων',
    value: 13000448,
    type: 'default',
  },
  {
    id: 13000449,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πολίχνη, Τσαλδάρη',
    value: 13000449,
    type: 'default',
  },
  {
    id: 2913,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία',
    value: 2913,
    type: 'default',
  },
  {
    id: 102913,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Κέντρο',
    value: 102913,
    type: 'default',
  },
  {
    id: 110305,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Φοινίκας',
    value: 110305,
    type: 'default',
  },
  {
    id: 291300,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Άνω Μαλακοπή',
    value: 291300,
    type: 'default',
  },
  {
    id: 291301,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Βίλλα Ριτζ',
    value: 291301,
    type: 'default',
  },
  {
    id: 291302,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Πουρνάρι',
    value: 291302,
    type: 'default',
  },
  {
    id: 291303,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Πυλαιώτικα',
    value: 291303,
    type: 'default',
  },
  {
    id: 291304,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Ελαιώνες',
    value: 291304,
    type: 'default',
  },
  {
    id: 291305,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Τοπογράφοι',
    value: 291305,
    type: 'default',
  },
  {
    id: 291306,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Επέκταση',
    value: 291306,
    type: 'default',
  },
  {
    id: 291307,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Mediterranean Cosmos',
    value: 291307,
    type: 'default',
  },
  {
    id: 13000455,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Λυγαριά',
    value: 13000455,
    type: 'default',
  },
  {
    id: 2811,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Κωνσταντινοπολίτικα',
    value: 2811,
    type: 'default',
  },
  {
    id: 13000450,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Αμαξοστάσιο',
    value: 13000450,
    type: 'default',
  },
  {
    id: 13000451,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Βιομηχανική Περιοχή',
    value: 13000451,
    type: 'default',
  },
  {
    id: 13000452,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Κάτω Πυλαία',
    value: 13000452,
    type: 'default',
  },
  {
    id: 13000453,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Κηπούπολη',
    value: 13000453,
    type: 'default',
  },
  {
    id: 13000454,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Πυλαία, Κυψέλη',
    value: 13000454,
    type: 'default',
  },
  {
    id: 2914,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη',
    value: 2914,
    type: 'default',
  },
  {
    id: 110263,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Τερψιθέα',
    value: 110263,
    type: 'default',
  },
  {
    id: 110264,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Πρόνοια',
    value: 110264,
    type: 'default',
  },
  {
    id: 206914,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Κέντρο',
    value: 206914,
    type: 'default',
  },
  {
    id: 291400,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Άνωθεν Ασύλου',
    value: 291400,
    type: 'default',
  },
  {
    id: 291401,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Αμπελώνες',
    value: 291401,
    type: 'default',
  },
  {
    id: 291402,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Άνω Ηλιούπολη',
    value: 291402,
    type: 'default',
  },
  {
    id: 291403,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Κάτω Ηλιούπολη',
    value: 291403,
    type: 'default',
  },
  {
    id: 291404,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Νικόπολη',
    value: 291404,
    type: 'default',
  },
  {
    id: 291405,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Ομόνοια',
    value: 291405,
    type: 'default',
  },
  {
    id: 13000456,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Άνω Νικόπολη',
    value: 13000456,
    type: 'default',
  },
  {
    id: 13000457,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Κάτω Ομόνοια',
    value: 13000457,
    type: 'default',
  },
  {
    id: 13000458,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Κέντρο Ομόνοιας',
    value: 13000458,
    type: 'default',
  },
  {
    id: 110259,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Αναγέννηση',
    value: 110259,
    type: 'default',
  },
  {
    id: 13000459,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Νεόκτιστα',
    value: 13000459,
    type: 'default',
  },
  {
    id: 110260,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Σταυρούπολη, Ακριτών',
    value: 110260,
    type: 'default',
  },
  {
    id: 2915,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Συκιές',
    value: 2915,
    type: 'default',
  },
  {
    id: 102915,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Συκιές, Κέντρο',
    value: 102915,
    type: 'default',
  },
  {
    id: 110280,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Συκιές, Καλλιθέα',
    value: 110280,
    type: 'default',
  },
  {
    id: 110284,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Συκιές, Ροδοχώρι',
    value: 110284,
    type: 'default',
  },
  {
    id: 110289,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Συκιές, Επταπύργιο',
    value: 110289,
    type: 'default',
  },
  {
    id: 13000463,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Συκιές, Κρυονέρι',
    value: 13000463,
    type: 'default',
  },
  {
    id: 329504,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Συκιές, Δροσιά',
    value: 329504,
    type: 'default',
  },
  {
    id: 329505,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Συκιές, Άγιοι Θεόδωροι',
    value: 329505,
    type: 'default',
  },
  {
    id: 13000460,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Συκιές, Βάρνα',
    value: 13000460,
    type: 'default',
  },
  {
    id: 13000461,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Συκιές, Εθνικής Αντίστασης',
    value: 13000461,
    type: 'default',
  },
  {
    id: 13000462,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Συκιές, Κολοκοτρώνη',
    value: 13000462,
    type: 'default',
  },
  {
    id: 291500,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Συκιές, Άλσος',
    value: 291500,
    type: 'default',
  },
  {
    id: 291501,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Συκιές, Μαύρος Γάτος',
    value: 291501,
    type: 'default',
  },
  {
    id: 291502,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Συκιές, Παράσχου',
    value: 291502,
    type: 'default',
  },
  {
    id: 2917,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Χορτιάτης',
    value: 2917,
    type: 'default',
  },
  {
    id: 102917,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Χορτιάτης, Κέντρο',
    value: 102917,
    type: 'default',
  },
  {
    id: 110307,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Χορτιάτης, Πουρναροχώρι',
    value: 110307,
    type: 'default',
  },
  {
    id: 110308,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Χορτιάτης, Εξοχή',
    value: 110308,
    type: 'default',
  },
  {
    id: 110309,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Χορτιάτης, Ασβεστοχώρι',
    value: 110309,
    type: 'default',
  },
  {
    id: 110310,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Χορτιάτης, Φίλυρο',
    value: 110310,
    type: 'default',
  },
  {
    id: 2918,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ωραιόκαστρο',
    value: 2918,
    type: 'default',
  },
  {
    id: 102918,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ωραιόκαστρο, Κέντρο',
    value: 102918,
    type: 'default',
  },
  {
    id: 110180,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ωραιόκαστρο, Γαλήνη',
    value: 110180,
    type: 'default',
  },
  {
    id: 110181,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ωραιόκαστρο, Παλαιόκαστρο',
    value: 110181,
    type: 'default',
  },
  {
    id: 291800,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ωραιόκαστρο, Ασπρόβρυση',
    value: 291800,
    type: 'default',
  },
  {
    id: 291801,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ωραιόκαστρο, ΒΙ.ΠΑ.',
    value: 291801,
    type: 'default',
  },
  {
    id: 291802,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ωραιόκαστρο, Τούμπα',
    value: 291802,
    type: 'default',
  },
  {
    id: 291803,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ωραιόκαστρο, Αμφιθέα',
    value: 291803,
    type: 'default',
  },
  {
    id: 13000464,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ωραιόκαστρο, Άγιος Γεώργιος',
    value: 13000464,
    type: 'default',
  },
  {
    id: 13000465,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Ωραιόκαστρο, Νεόκαστρο',
    value: 13000465,
    type: 'default',
  },
  {
    id: 3002,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αξιός',
    value: 3002,
    type: 'default',
  },
  {
    id: 103002,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αξιός, Κέντρο',
    value: 103002,
    type: 'default',
  },
  {
    id: 108621,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αξιός, Κύμινα',
    value: 108621,
    type: 'default',
  },
  {
    id: 110191,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αξιός, Νέα Μάλγαρα',
    value: 110191,
    type: 'default',
  },
  {
    id: 110193,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Αξιός, Βραχιά',
    value: 110193,
    type: 'default',
  },
  {
    id: 3006,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Βασιλικά',
    value: 3006,
    type: 'default',
  },
  {
    id: 110447,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Βασιλικά, Μονοπήγαδο',
    value: 110447,
    type: 'default',
  },
  {
    id: 110448,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Βασιλικά, Άγιος Αντώνιος',
    value: 110448,
    type: 'default',
  },
  {
    id: 110452,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Βασιλικά, Σουρωτή',
    value: 110452,
    type: 'default',
  },
  {
    id: 110454,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Βασιλικά, Αγία Παρασκευή',
    value: 110454,
    type: 'default',
  },
  {
    id: 110457,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Βασιλικά, Λουτρά Θέρμης',
    value: 110457,
    type: 'default',
  },
  {
    id: 110458,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Βασιλικά, Λακκιά',
    value: 110458,
    type: 'default',
  },
  {
    id: 110459,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Βασιλικά, Λιβάδι',
    value: 110459,
    type: 'default',
  },
  {
    id: 110463,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Βασιλικά, Περιστέρα',
    value: 110463,
    type: 'default',
  },
  {
    id: 13000405,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Βασιλικά, Λάναρι',
    value: 13000405,
    type: 'default',
  },
  {
    id: 103006,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Βασιλικά, Κέντρο',
    value: 103006,
    type: 'default',
  },
  {
    id: 3009,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Επανομή',
    value: 3009,
    type: 'default',
  },
  {
    id: 103009,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Επανομή, Κέντρο',
    value: 103009,
    type: 'default',
  },
  {
    id: 110626,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Επανομή, Λεύκες',
    value: 110626,
    type: 'default',
  },
  {
    id: 110627,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Επανομή, Πύργος Επανομής',
    value: 110627,
    type: 'default',
  },
  {
    id: 110629,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Επανομή, Μεσημέρι',
    value: 110629,
    type: 'default',
  },
  {
    id: 13000410,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Επανομή, Αλατιέρες',
    value: 13000410,
    type: 'default',
  },
  {
    id: 13000411,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Επανομή, Επανομή - Βόρεια',
    value: 13000411,
    type: 'default',
  },
  {
    id: 13000412,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Επανομή, Επανομή - Νότια',
    value: 13000412,
    type: 'default',
  },
  {
    id: 13000413,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Επανομή, Μετόχι - Τούμπα',
    value: 13000413,
    type: 'default',
  },
  {
    id: 13000414,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Επανομή, Ντουράκι',
    value: 13000414,
    type: 'default',
  },
  {
    id: 13000415,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Επανομή, Παραλία Επανομής',
    value: 13000415,
    type: 'default',
  },
  {
    id: 13000416,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Επανομή, Σμίλα - Πάλιουρα',
    value: 13000416,
    type: 'default',
  },
  {
    id: 3010,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εχέδωρος',
    value: 3010,
    type: 'default',
  },
  {
    id: 103010,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εχέδωρος, Κέντρο',
    value: 103010,
    type: 'default',
  },
  {
    id: 110192,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εχέδωρος, Καλοχώρι',
    value: 110192,
    type: 'default',
  },
  {
    id: 110195,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εχέδωρος, Σίνδος',
    value: 110195,
    type: 'default',
  },
  {
    id: 110196,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εχέδωρος, Διαβατά',
    value: 110196,
    type: 'default',
  },
  {
    id: 110197,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εχέδωρος, Νέα Μαγνησία',
    value: 110197,
    type: 'default',
  },
  {
    id: 13000425,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εχέδωρος, Αγία Σοφία',
    value: 13000425,
    type: 'default',
  },
  {
    id: 13000426,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Εχέδωρος, Βιομηχανική Περιοχή',
    value: 13000426,
    type: 'default',
  },
  {
    id: 3011,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλλιθέα',
    value: 3011,
    type: 'default',
  },
  {
    id: 110183,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλλιθέα, Πεντάλοφος',
    value: 110183,
    type: 'default',
  },
  {
    id: 110190,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλλιθέα, Πετρωτό',
    value: 110190,
    type: 'default',
  },
  {
    id: 110189,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλλιθέα, Μονόλοφο',
    value: 110189,
    type: 'default',
  },
  {
    id: 110188,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλλιθέα, Νέα Φιλαδέλφεια',
    value: 110188,
    type: 'default',
  },
  {
    id: 110182,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλλιθέα, Νεοχωρούδα',
    value: 110182,
    type: 'default',
  },
  {
    id: 110187,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Καλλιθέα, Μεσαίο',
    value: 110187,
    type: 'default',
  },
  {
    id: 3018,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μηχανιώνα',
    value: 3018,
    type: 'default',
  },
  {
    id: 103018,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μηχανιώνα, Κέντρο',
    value: 103018,
    type: 'default',
  },
  {
    id: 110630,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μηχανιώνα, Νέα Μηχανιώνα',
    value: 110630,
    type: 'default',
  },
  {
    id: 110631,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μηχανιώνα, Νέα Κερασιά',
    value: 110631,
    type: 'default',
  },
  {
    id: 110632,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μηχανιώνα, Αγγελοχώρι',
    value: 110632,
    type: 'default',
  },
  {
    id: 3019,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μίκρα',
    value: 3019,
    type: 'default',
  },
  {
    id: 103019,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μίκρα, Κέντρο',
    value: 103019,
    type: 'default',
  },
  {
    id: 110451,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μίκρα, Καρδία',
    value: 110451,
    type: 'default',
  },
  {
    id: 110453,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μίκρα, Πλαγιάρι',
    value: 110453,
    type: 'default',
  },
  {
    id: 110446,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μίκρα, Κάτω Σχολάρι',
    value: 110446,
    type: 'default',
  },
  {
    id: 110449,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μίκρα, Άνω Σχολάρι',
    value: 110449,
    type: 'default',
  },
  {
    id: 110450,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μίκρα, Τρίλοφο',
    value: 110450,
    type: 'default',
  },
  {
    id: 3020,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μυγδονία',
    value: 3020,
    type: 'default',
  },
  {
    id: 103020,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μυγδονία, Κέντρο',
    value: 103020,
    type: 'default',
  },
  {
    id: 110179,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μυγδονία, Ανθούπολη',
    value: 110179,
    type: 'default',
  },
  {
    id: 110184,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μυγδονία, Λητή',
    value: 110184,
    type: 'default',
  },
  {
    id: 110185,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μυγδονία, Μελισσοχώρι',
    value: 110185,
    type: 'default',
  },
  {
    id: 110186,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Μυγδονία, Δρυμός',
    value: 110186,
    type: 'default',
  },
  {
    id: 3023,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Χαλάστρα',
    value: 3023,
    type: 'default',
  },
  {
    id: 103023,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Χαλάστρα, Κέντρο',
    value: 103023,
    type: 'default',
  },
  {
    id: 110194,
    label: 'Θεσσαλονίκη - Περιφ/κοί δήμοι, Χαλάστρα, Ανατολικό',
    value: 110194,
    type: 'default',
  },
  {
    id: 110,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού',
    value: 110,
    type: 'default',
  },
  {
    id: 3000,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Αθανάσιος',
    value: 3000,
    type: 'default',
  },
  {
    id: 110140,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Αθανάσιος, Νέα Μεσημβρία',
    value: 110140,
    type: 'default',
  },
  {
    id: 110135,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Αθανάσιος, Αγχίαλος',
    value: 110135,
    type: 'default',
  },
  {
    id: 110136,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Αθανάσιος, Κάτω Γέφυρα',
    value: 110136,
    type: 'default',
  },
  {
    id: 110138,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Αθανάσιος, Γέφυρα',
    value: 110138,
    type: 'default',
  },
  {
    id: 110141,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Αθανάσιος, Βαθύλακκος',
    value: 110141,
    type: 'default',
  },
  {
    id: 103000,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Αθανάσιος, Κέντρο',
    value: 103000,
    type: 'default',
  },
  {
    id: 110144,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Αθανάσιος, Ξηροχώρι',
    value: 110144,
    type: 'default',
  },
  {
    id: 110142,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Αθανάσιος, Μπαλαίικα',
    value: 110142,
    type: 'default',
  },
  {
    id: 3001,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Γεώργιος',
    value: 3001,
    type: 'default',
  },
  {
    id: 13000072,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Γεώργιος, Παλιάμπελα',
    value: 13000072,
    type: 'default',
  },
  {
    id: 13000071,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Γεώργιος, Βρασνά',
    value: 13000071,
    type: 'default',
  },
  {
    id: 300101,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Γεώργιος, Νέα Βρασνά',
    value: 300101,
    type: 'default',
  },
  {
    id: 300100,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Γεώργιος, Ασπροβάλτα',
    value: 300100,
    type: 'default',
  },
  {
    id: 13000104,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άγιος Γεώργιος, Παραλία Βρασνών',
    value: 13000104,
    type: 'default',
  },
  {
    id: 3003,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Απολλώνια',
    value: 3003,
    type: 'default',
  },
  {
    id: 103003,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Απολλώνια, Κέντρο',
    value: 103003,
    type: 'default',
  },
  {
    id: 108620,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Απολλώνια, Πλατεία',
    value: 108620,
    type: 'default',
  },
  {
    id: 110095,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Απολλώνια, Ασπρόχωμα',
    value: 110095,
    type: 'default',
  },
  {
    id: 110096,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Απολλώνια, Μελισσουργός',
    value: 110096,
    type: 'default',
  },
  {
    id: 110097,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Απολλώνια, Μεσοπόταμο',
    value: 110097,
    type: 'default',
  },
  {
    id: 110100,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Απολλώνια, Νέα Απολλωνία',
    value: 110100,
    type: 'default',
  },
  {
    id: 110101,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Απολλώνια, Νικομηδινό',
    value: 110101,
    type: 'default',
  },
  {
    id: 110102,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Απολλώνια, Στίβος',
    value: 110102,
    type: 'default',
  },
  {
    id: 110104,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Απολλώνια, Λουτρά Βόλβης',
    value: 110104,
    type: 'default',
  },
  {
    id: 110107,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Απολλώνια, Περιστερώνα',
    value: 110107,
    type: 'default',
  },
  {
    id: 110105,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Απολλώνια, Σπιτάκια',
    value: 110105,
    type: 'default',
  },
  {
    id: 3004,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Αρέθουσα',
    value: 3004,
    type: 'default',
  },
  {
    id: 103004,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Αρέθουσα, Κέντρο',
    value: 103004,
    type: 'default',
  },
  {
    id: 110120,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Αρέθουσα, Παλαιοχώρι',
    value: 110120,
    type: 'default',
  },
  {
    id: 110122,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Αρέθουσα, Λευκούδα',
    value: 110122,
    type: 'default',
  },
  {
    id: 110123,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Αρέθουσα, Παλιάμπελα',
    value: 110123,
    type: 'default',
  },
  {
    id: 110124,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Αρέθουσα, Φιλαδέλφι',
    value: 110124,
    type: 'default',
  },
  {
    id: 110125,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Αρέθουσα, Ανοιξιά',
    value: 110125,
    type: 'default',
  },
  {
    id: 110126,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Αρέθουσα, Στεφανινά',
    value: 110126,
    type: 'default',
  },
  {
    id: 110127,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Αρέθουσα, Ξηροπόταμος',
    value: 110127,
    type: 'default',
  },
  {
    id: 110128,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Αρέθουσα, Λίμνη',
    value: 110128,
    type: 'default',
  },
  {
    id: 110129,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Αρέθουσα, Μαυρούδα',
    value: 110129,
    type: 'default',
  },
  {
    id: 110130,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Αρέθουσα, Σκεπαστό',
    value: 110130,
    type: 'default',
  },
  {
    id: 13000466,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Αρέθουσα, Κάτω Στεφανινά',
    value: 13000466,
    type: 'default',
  },
  {
    id: 3005,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άσσηρος',
    value: 3005,
    type: 'default',
  },
  {
    id: 103005,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άσσηρος, Κέντρο',
    value: 103005,
    type: 'default',
  },
  {
    id: 109851,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άσσηρος, Κριθιά',
    value: 109851,
    type: 'default',
  },
  {
    id: 109852,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άσσηρος, Μαυρορράχη',
    value: 109852,
    type: 'default',
  },
  {
    id: 109853,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Άσσηρος, Εξαμίλι',
    value: 109853,
    type: 'default',
  },
  {
    id: 3007,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Βερτίσκος',
    value: 3007,
    type: 'default',
  },
  {
    id: 103007,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Βερτίσκος, Κέντρο',
    value: 103007,
    type: 'default',
  },
  {
    id: 109839,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Βερτίσκος, Αρετή',
    value: 109839,
    type: 'default',
  },
  {
    id: 109843,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Βερτίσκος, Λοφίσκος',
    value: 109843,
    type: 'default',
  },
  {
    id: 109844,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Βερτίσκος, Βαθουλό',
    value: 109844,
    type: 'default',
  },
  {
    id: 109845,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Βερτίσκος, Πέντε Βρύσες',
    value: 109845,
    type: 'default',
  },
  {
    id: 109848,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Βερτίσκος, Πολυδένδρι',
    value: 109848,
    type: 'default',
  },
  {
    id: 109849,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Βερτίσκος, Όσσα',
    value: 109849,
    type: 'default',
  },
  {
    id: 109850,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Βερτίσκος, Γαλήνη',
    value: 109850,
    type: 'default',
  },
  {
    id: 109857,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Βερτίσκος, Χωρούδα',
    value: 109857,
    type: 'default',
  },
  {
    id: 3008,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Εγνατία',
    value: 3008,
    type: 'default',
  },
  {
    id: 300801,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Εγνατία, Ευαγγελισμός',
    value: 300801,
    type: 'default',
  },
  {
    id: 300803,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Εγνατία, Νυμφόπετρα',
    value: 300803,
    type: 'default',
  },
  {
    id: 300804,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Εγνατία, Προφήτης',
    value: 300804,
    type: 'default',
  },
  {
    id: 300805,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Εγνατία, Σχολάρι',
    value: 300805,
    type: 'default',
  },
  {
    id: 300802,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Εγνατία, Μικροκώμη',
    value: 300802,
    type: 'default',
  },
  {
    id: 300800,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Εγνατία, Βαϊοχώρι',
    value: 300800,
    type: 'default',
  },
  {
    id: 3012,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Καλλίνδοια',
    value: 3012,
    type: 'default',
  },
  {
    id: 103012,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Καλλίνδοια, Κέντρο',
    value: 103012,
    type: 'default',
  },
  {
    id: 108501,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Καλλίνδοια, Αδάμ',
    value: 108501,
    type: 'default',
  },
  {
    id: 109816,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Καλλίνδοια, Πετροκέρασα',
    value: 109816,
    type: 'default',
  },
  {
    id: 109817,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Καλλίνδοια, Καλαμωτό',
    value: 109817,
    type: 'default',
  },
  {
    id: 109818,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Καλλίνδοια, Μεσόκωμο',
    value: 109818,
    type: 'default',
  },
  {
    id: 109819,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Καλλίνδοια, Ζαγκλιβέρι',
    value: 109819,
    type: 'default',
  },
  {
    id: 109820,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Καλλίνδοια, Αγγελοχώρι',
    value: 109820,
    type: 'default',
  },
  {
    id: 109821,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Καλλίνδοια, Άγιος Χαράλαμπος',
    value: 109821,
    type: 'default',
  },
  {
    id: 109822,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Καλλίνδοια, Σαρακήνα',
    value: 109822,
    type: 'default',
  },
  {
    id: 109823,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Καλλίνδοια, Παρθένι',
    value: 109823,
    type: 'default',
  },
  {
    id: 3013,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Κορώνεια',
    value: 3013,
    type: 'default',
  },
  {
    id: 506113,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Κορώνεια, Αρδαμέρι',
    value: 506113,
    type: 'default',
  },
  {
    id: 207318,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Κορώνεια, Γερακαρού',
    value: 207318,
    type: 'default',
  },
  {
    id: 506110,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Κορώνεια, Άγιος Βασίλειος',
    value: 506110,
    type: 'default',
  },
  {
    id: 506111,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Κορώνεια, Βασιλούδι',
    value: 506111,
    type: 'default',
  },
  {
    id: 506112,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Κορώνεια, Λαγκαδίκια',
    value: 506112,
    type: 'default',
  },
  {
    id: 3014,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Κουφάλια',
    value: 3014,
    type: 'default',
  },
  {
    id: 103014,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Κουφάλια, Κέντρο',
    value: 103014,
    type: 'default',
  },
  {
    id: 107352,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Κουφάλια, Πέλλα',
    value: 107352,
    type: 'default',
  },
  {
    id: 110143,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Κουφάλια, Πρόχωμα',
    value: 110143,
    type: 'default',
  },
  {
    id: 110145,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Κουφάλια, Καστανάς',
    value: 110145,
    type: 'default',
  },
  {
    id: 110146,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Κουφάλια, Ακροπόταμος',
    value: 110146,
    type: 'default',
  },
  {
    id: 3015,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαγκαδάς',
    value: 3015,
    type: 'default',
  },
  {
    id: 103015,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαγκαδάς, Κέντρο',
    value: 103015,
    type: 'default',
  },
  {
    id: 109829,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαγκαδάς, Καβαλλάρι',
    value: 109829,
    type: 'default',
  },
  {
    id: 109830,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαγκαδάς, Κάτω Καβαλλάρι',
    value: 109830,
    type: 'default',
  },
  {
    id: 109831,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαγκαδάς, Ανάληψη',
    value: 109831,
    type: 'default',
  },
  {
    id: 109832,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαγκαδάς, Λαγυνά',
    value: 109832,
    type: 'default',
  },
  {
    id: 109833,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαγκαδάς, Λουτρά Λαγκαδά',
    value: 109833,
    type: 'default',
  },
  {
    id: 109834,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαγκαδάς, Δρακόντιο',
    value: 109834,
    type: 'default',
  },
  {
    id: 109835,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαγκαδάς, Ακροχώρι',
    value: 109835,
    type: 'default',
  },
  {
    id: 109836,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαγκαδάς, Περιβολάκι',
    value: 109836,
    type: 'default',
  },
  {
    id: 109838,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαγκαδάς, Κολχικό',
    value: 109838,
    type: 'default',
  },
  {
    id: 109840,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαγκαδάς, Ηράκλειο',
    value: 109840,
    type: 'default',
  },
  {
    id: 109842,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαγκαδάς, Χρυσαυγή',
    value: 109842,
    type: 'default',
  },
  {
    id: 3016,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαχανάς',
    value: 3016,
    type: 'default',
  },
  {
    id: 103016,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαχανάς, Κέντρο',
    value: 103016,
    type: 'default',
  },
  {
    id: 109815,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαχανάς, Ευαγγελίστρια',
    value: 109815,
    type: 'default',
  },
  {
    id: 109855,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαχανάς, Δορκάδα',
    value: 109855,
    type: 'default',
  },
  {
    id: 109856,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαχανάς, Νικόπολη',
    value: 109856,
    type: 'default',
  },
  {
    id: 109858,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαχανάς, Καρτερές',
    value: 109858,
    type: 'default',
  },
  {
    id: 109859,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαχανάς, Στεφανιά',
    value: 109859,
    type: 'default',
  },
  {
    id: 109860,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαχανάς, Λευκοχώρι',
    value: 109860,
    type: 'default',
  },
  {
    id: 109861,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαχανάς, Ξυλόπολη',
    value: 109861,
    type: 'default',
  },
  {
    id: 109862,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Λαχανάς, Κυδωνιά',
    value: 109862,
    type: 'default',
  },
  {
    id: 3017,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Μάδυτος',
    value: 3017,
    type: 'default',
  },
  {
    id: 103017,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Μάδυτος, Κέντρο',
    value: 103017,
    type: 'default',
  },
  {
    id: 108606,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Μάδυτος, Μόδι',
    value: 108606,
    type: 'default',
  },
  {
    id: 110098,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Μάδυτος, Νέα Μάδυτος',
    value: 110098,
    type: 'default',
  },
  {
    id: 110099,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Μάδυτος, Κοκκαλού',
    value: 110099,
    type: 'default',
  },
  {
    id: 3021,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Ρεντίνα',
    value: 3021,
    type: 'default',
  },
  {
    id: 103021,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Ρεντίνα, Κέντρο',
    value: 103021,
    type: 'default',
  },
  {
    id: 110103,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Ρεντίνα, Άνω Σταυρός',
    value: 110103,
    type: 'default',
  },
  {
    id: 110106,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Ρεντίνα, Μηλιές',
    value: 110106,
    type: 'default',
  },
  {
    id: 110108,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Ρεντίνα, Σταυρός',
    value: 110108,
    type: 'default',
  },
  {
    id: 110110,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Ρεντίνα, Μικρή Βόλβη',
    value: 110110,
    type: 'default',
  },
  {
    id: 110111,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Ρεντίνα, Βαμβακιά',
    value: 110111,
    type: 'default',
  },
  {
    id: 110115,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Ρεντίνα, Μεγάλη Βόλβη',
    value: 110115,
    type: 'default',
  },
  {
    id: 3022,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Σοχός',
    value: 3022,
    type: 'default',
  },
  {
    id: 103022,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Σοχός, Κέντρο',
    value: 103022,
    type: 'default',
  },
  {
    id: 109837,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Σοχός, Ασκός',
    value: 109837,
    type: 'default',
  },
  {
    id: 109841,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Σοχός, Πολυδένδρι',
    value: 109841,
    type: 'default',
  },
  {
    id: 109846,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Σοχός, Αυγή',
    value: 109846,
    type: 'default',
  },
  {
    id: 109847,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Σοχός, Κρυονέρι',
    value: 109847,
    type: 'default',
  },
  {
    id: 109854,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Σοχός, Νέα Σεβάστεια',
    value: 109854,
    type: 'default',
  },
  {
    id: 3024,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Χαλκηδόνα',
    value: 3024,
    type: 'default',
  },
  {
    id: 110131,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Χαλκηδόνα, Άδενδρο',
    value: 110131,
    type: 'default',
  },
  {
    id: 110132,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Χαλκηδόνα, Λουδίας',
    value: 110132,
    type: 'default',
  },
  {
    id: 110133,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Χαλκηδόνα, Παρθένι',
    value: 110133,
    type: 'default',
  },
  {
    id: 110134,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Χαλκηδόνα, Μικρό Μοναστήρι',
    value: 110134,
    type: 'default',
  },
  {
    id: 110137,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Χαλκηδόνα, Βαλτοχώρι',
    value: 110137,
    type: 'default',
  },
  {
    id: 110139,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Χαλκηδόνα, Ελεούσα',
    value: 110139,
    type: 'default',
  },
  {
    id: 103024,
    label: 'Θεσσαλονίκη - Υπόλ. Νομού, Χαλκηδόνα, Κέντρο',
    value: 103024,
    type: 'default',
  },
];
